import React, { useEffect } from 'react';

interface ModalData {
    title: string;
    body: string;
}

const MODALS: Record<string, ModalData> = {

'preview-value-pools-map': {
    title: 'Value Pools Map.pdf',
    body: `<div class="dlv-page">
        <div class="dlv-sanitized"><div class="dlv-sanitized-stripe">Sanitized client example</div></div>
        <div class="dlv-doc-header">
          <div class="dlv-doc-brand">PERCEPT<em>Y</em>A</div>
          <div class="dlv-doc-meta">
            <span>Value Pools Map</span>
            <span>March 2024</span>
            <span class="dlv-doc-badge">Confidential</span>
          </div>
        </div>
        <div style="padding: 32px 24px; border-bottom: 1px solid #ddd;">
          <div class="dlv-doc-title">AI Value Pools Analysis</div>
          <div class="dlv-doc-subtitle">Latin American Big Fashion Retail — 18–36 Month Horizon</div>
        </div>
        <div style="padding: 32px 24px;">
          <div class="dlv-section-title">Total Addressable AI Value</div>
          <div style="display: flex; gap: 24px; margin-bottom: 32px; font-family: 'DM Mono', monospace;">
            <div style="text-align: center;">
              <div style="font-size: 36px; font-weight: 600; color: #FF6B2B;">$24.8M</div>
              <div style="font-size: 12px; color: #888; margin-top: 4px;">Cumulative 3-Year Value</div>
            </div>
            <div style="text-align: center;">
              <div style="font-size: 28px; font-weight: 600; color: #1a1a1a;">7.2x</div>
              <div style="font-size: 12px; color: #888; margin-top: 4px;">ROI Multiplier</div>
            </div>
          </div>

          <div class="dlv-section-title">Value Pools by Business Area &amp; Category</div>
          <svg viewBox="0 0 700 400" style="width: 100%; margin-bottom: 24px; background: #f9f9f9; border-radius: 4px;">
            <defs>
              <pattern id="grid" width="70" height="50" patternUnits="userSpaceOnUse">
                <path d="M 70 0 L 0 0 0 50" fill="none" stroke="#eee" stroke-width="1"/>
              </pattern>
            </defs>
            <rect width="700" height="400" fill="url(#grid)"/>

            <text x="20" y="30" font-family="DM Mono" font-size="11" fill="#888">Business Functions →</text>
            <text x="10" y="120" font-family="DM Mono" font-size="11" fill="#888" text-anchor="middle">Value Pools ↓</text>

            <text x="100" y="25" font-family="DM Mono" font-size="10" fill="#1a1a1a" text-anchor="middle" font-weight="600">Merchandising</text>
            <text x="200" y="25" font-family="DM Mono" font-size="10" fill="#1a1a1a" text-anchor="middle" font-weight="600">Marketing</text>
            <text x="300" y="25" font-family="DM Mono" font-size="10" fill="#1a1a1a" text-anchor="middle" font-weight="600">Supply Chain</text>
            <text x="400" y="25" font-family="DM Mono" font-size="10" fill="#1a1a1a" text-anchor="middle" font-weight="600">Store Ops</text>
            <text x="500" y="25" font-family="DM Mono" font-size="10" fill="#1a1a1a" text-anchor="middle" font-weight="600">E-commerce</text>
            <text x="600" y="25" font-family="DM Mono" font-size="10" fill="#1a1a1a" text-anchor="middle" font-weight="600">Customer Svc</text>

            <text x="70" y="75" font-family="DM Mono" font-size="10" fill="#1a1a1a" text-anchor="end" font-weight="600">Revenue Growth</text>
            <text x="70" y="155" font-family="DM Mono" font-size="10" fill="#1a1a1a" text-anchor="end" font-weight="600">Cost Reduction</text>
            <text x="70" y="235" font-family="DM Mono" font-size="10" fill="#1a1a1a" text-anchor="end" font-weight="600">Customer Exp</text>
            <text x="70" y="315" font-family="DM Mono" font-size="10" fill="#1a1a1a" text-anchor="end" font-weight="600">Operational Eff</text>

            <rect x="85" y="55" width="30" height="30" fill="#FF6B2B" opacity="0.2" stroke="#FF6B2B" stroke-width="1"/>
            <text x="100" y="76" font-family="DM Mono" font-size="9" fill="#1a1a1a" text-anchor="middle" font-weight="600">$3.2M</text>
            <rect x="185" y="55" width="30" height="30" fill="#FF6B2B" opacity="0.3" stroke="#FF6B2B" stroke-width="1"/>
            <text x="200" y="76" font-family="DM Mono" font-size="9" fill="#1a1a1a" text-anchor="middle" font-weight="600">$4.8M</text>
            <rect x="285" y="55" width="30" height="30" fill="#FF6B2B" opacity="0.15" stroke="#FF6B2B" stroke-width="1"/>
            <text x="300" y="76" font-family="DM Mono" font-size="9" fill="#888" text-anchor="middle" font-weight="600">$1.1M</text>
            <rect x="385" y="55" width="30" height="30" fill="#ddd"/>
            <text x="400" y="76" font-family="DM Mono" font-size="9" fill="#888" text-anchor="middle">—</text>
            <rect x="485" y="55" width="30" height="30" fill="#FF6B2B" opacity="0.25" stroke="#FF6B2B" stroke-width="1"/>
            <text x="500" y="76" font-family="DM Mono" font-size="9" fill="#1a1a1a" text-anchor="middle" font-weight="600">$3.7M</text>
            <rect x="585" y="55" width="30" height="30" fill="#FF6B2B" opacity="0.1" stroke="#FF6B2B" stroke-width="1"/>
            <text x="600" y="76" font-family="DM Mono" font-size="9" fill="#888" text-anchor="middle" font-weight="600">$800K</text>

            <rect x="85" y="135" width="30" height="30" fill="#16a34a" opacity="0.2" stroke="#16a34a" stroke-width="1"/>
            <text x="100" y="156" font-family="DM Mono" font-size="9" fill="#1a1a1a" text-anchor="middle" font-weight="600">$2.1M</text>
            <rect x="185" y="135" width="30" height="30" fill="#16a34a" opacity="0.15" stroke="#16a34a" stroke-width="1"/>
            <text x="200" y="156" font-family="DM Mono" font-size="9" fill="#888" text-anchor="middle" font-weight="600">$900K</text>
            <rect x="285" y="135" width="30" height="30" fill="#16a34a" opacity="0.3" stroke="#16a34a" stroke-width="1"/>
            <text x="300" y="156" font-family="DM Mono" font-size="9" fill="#1a1a1a" text-anchor="middle" font-weight="600">$4.2M</text>
            <rect x="385" y="135" width="30" height="30" fill="#16a34a" opacity="0.25" stroke="#16a34a" stroke-width="1"/>
            <text x="400" y="156" font-family="DM Mono" font-size="9" fill="#1a1a1a" text-anchor="middle" font-weight="600">$2.8M</text>
            <rect x="485" y="135" width="30" height="30" fill="#ddd"/>
            <text x="500" y="156" font-family="DM Mono" font-size="9" fill="#888" text-anchor="middle">—</text>
            <rect x="585" y="135" width="30" height="30" fill="#16a34a" opacity="0.2" stroke="#16a34a" stroke-width="1"/>
            <text x="600" y="156" font-family="DM Mono" font-size="9" fill="#888" text-anchor="middle" font-weight="600">$1.3M</text>

            <rect x="85" y="215" width="30" height="30" fill="#0066cc" opacity="0.2" stroke="#0066cc" stroke-width="1"/>
            <text x="100" y="236" font-family="DM Mono" font-size="9" fill="#888" text-anchor="middle" font-weight="600">$600K</text>
            <rect x="185" y="215" width="30" height="30" fill="#0066cc" opacity="0.25" stroke="#0066cc" stroke-width="1"/>
            <text x="200" y="236" font-family="DM Mono" font-size="9" fill="#1a1a1a" text-anchor="middle" font-weight="600">$2.2M</text>
            <rect x="285" y="215" width="30" height="30" fill="#ddd"/>
            <text x="300" y="236" font-family="DM Mono" font-size="9" fill="#888" text-anchor="middle">—</text>
            <rect x="385" y="215" width="30" height="30" fill="#0066cc" opacity="0.15" stroke="#0066cc" stroke-width="1"/>
            <text x="400" y="236" font-family="DM Mono" font-size="9" fill="#888" text-anchor="middle" font-weight="600">$1.1M</text>
            <rect x="485" y="215" width="30" height="30" fill="#0066cc" opacity="0.22" stroke="#0066cc" stroke-width="1"/>
            <text x="500" y="236" font-family="DM Mono" font-size="9" fill="#1a1a1a" text-anchor="middle" font-weight="600">$1.8M</text>
            <rect x="585" y="215" width="30" height="30" fill="#0066cc" opacity="0.28" stroke="#0066cc" stroke-width="1"/>
            <text x="600" y="236" font-family="DM Mono" font-size="9" fill="#1a1a1a" text-anchor="middle" font-weight="600">$2.4M</text>

            <rect x="85" y="295" width="30" height="30" fill="#8b5cf6" opacity="0.15" stroke="#8b5cf6" stroke-width="1"/>
            <text x="100" y="316" font-family="DM Mono" font-size="9" fill="#888" text-anchor="middle" font-weight="600">$800K</text>
            <rect x="185" y="295" width="30" height="30" fill="#8b5cf6" opacity="0.1" stroke="#8b5cf6" stroke-width="1"/>
            <text x="200" y="316" font-family="DM Mono" font-size="9" fill="#888" text-anchor="middle" font-weight="600">$500K</text>
            <rect x="285" y="295" width="30" height="30" fill="#8b5cf6" opacity="0.2" stroke="#8b5cf6" stroke-width="1"/>
            <text x="300" y="316" font-family="DM Mono" font-size="9" fill="#1a1a1a" text-anchor="middle" font-weight="600">$1.9M</text>
            <rect x="385" y="295" width="30" height="30" fill="#8b5cf6" opacity="0.25" stroke="#8b5cf6" stroke-width="1"/>
            <text x="400" y="316" font-family="DM Mono" font-size="9" fill="#1a1a1a" text-anchor="middle" font-weight="600">$2.3M</text>
            <rect x="485" y="295" width="30" height="30" fill="#8b5cf6" opacity="0.18" stroke="#8b5cf6" stroke-width="1"/>
            <text x="500" y="316" font-family="DM Mono" font-size="9" fill="#888" text-anchor="middle" font-weight="600">$1.4M</text>
            <rect x="585" y="295" width="30" height="30" fill="#ddd"/>
            <text x="600" y="316" font-family="DM Mono" font-size="9" fill="#888" text-anchor="middle">—</text>
          </svg>

          <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 16px; font-family: 'DM Mono', monospace; font-size: 13px;">
            <div style="border-left: 2px solid #FF6B2B; padding-left: 12px;">
              <div style="color: #888; font-size: 11px; margin-bottom: 4px;">REVENUE GROWTH</div>
              <div style="color: #1a1a1a; font-weight: 600; font-size: 16px;">$13.6M</div>
            </div>
            <div style="border-left: 2px solid #16a34a; padding-left: 12px;">
              <div style="color: #888; font-size: 11px; margin-bottom: 4px;">COST REDUCTION</div>
              <div style="color: #1a1a1a; font-weight: 600; font-size: 16px;">$7.3M</div>
            </div>
            <div style="border-left: 2px solid #0066cc; padding-left: 12px;">
              <div style="color: #888; font-size: 11px; margin-bottom: 4px;">OTHER VALUE</div>
              <div style="color: #1a1a1a; font-weight: 600; font-size: 16px;">$3.9M</div>
            </div>
          </div>
        </div>
        <div class="dlv-doc-footer">
          <span style="font-size: 11px; color: #888;">Perceptya AI Value Discovery</span>
          <span style="font-size: 11px; color: #888;">Page 1 of 1</span>
        </div>
      </div>`,
},

'preview-ambition-statement': {
    title: 'AI Ambition Statement.pdf',
    body: `<div class="dlv-page">
        <div class="dlv-sanitized"><div class="dlv-sanitized-stripe">Sanitized client example</div></div>
        <div class="dlv-doc-header">
          <div class="dlv-doc-brand">PERCEPT<em>Y</em>A</div>
          <div class="dlv-doc-meta">
            <span>Ambition Statement</span>
            <span>March 2024</span>
            <span class="dlv-doc-badge">Confidential</span>
          </div>
        </div>
        <div style="padding: 32px 24px; border-bottom: 1px solid #ddd;">
          <div class="dlv-doc-title">AI Ambition Statement</div>
          <div class="dlv-doc-subtitle">Strategic Direction for AI-Driven Value Creation</div>
        </div>
        <div style="padding: 32px 24px; font-family: 'Urbanist', sans-serif; color: #1a1a1a; line-height: 1.7;">
          <div style="margin-bottom: 32px;">
            <h3 style="font-size: 13px; color: #888; text-transform: uppercase; letter-spacing: 0.12em; font-family: 'DM Mono', monospace; margin-bottom: 12px; font-weight: 600;">Strategic Context</h3>
            <p style="font-size: 14px; margin: 0;">Latin American Big Fashion Retail operates across 240+ stores in 8 countries, with growing e-commerce penetration (now 22% of revenue). The business faces intense margin pressure, seasonal volatility, and rising customer expectations for personalization. AI is a lever to recapture margin, accelerate decision-making, and create differentiated customer experiences in a fragmented regional market.</p>
          </div>

          <div style="margin-bottom: 32px;">
            <h3 style="font-size: 13px; color: #888; text-transform: uppercase; letter-spacing: 0.12em; font-family: 'DM Mono', monospace; margin-bottom: 12px; font-weight: 600;">AI Vision Statement</h3>
            <p style="font-size: 16px; font-weight: 500; margin: 0; color: #1a1a1a; padding: 16px; background: #f9f9f9; border-left: 2px solid #FF6B2B;">To make data and AI foundational to every decision—from merchandising and pricing to supply chain and customer engagement—capturing $25M+ in value by 2028 while building a culture of evidence-based, AI-augmented decision-making across the enterprise.</p>
          </div>

          <div style="margin-bottom: 32px;">
            <h3 style="font-size: 13px; color: #888; text-transform: uppercase; letter-spacing: 0.12em; font-family: 'DM Mono', monospace; margin-bottom: 12px; font-weight: 600;">Strategic Pillars</h3>
            <div style="margin-bottom: 16px;">
              <h4 style="font-size: 13px; font-weight: 600; color: #1a1a1a; margin: 0 0 6px 0;">1. Revenue Acceleration</h4>
              <p style="font-size: 13px; color: #888; margin: 0;">Dynamic pricing, demand forecasting, and personalization engines that drive AOV, conversion, and customer lifetime value.</p>
            </div>
            <div style="margin-bottom: 16px;">
              <h4 style="font-size: 13px; font-weight: 600; color: #1a1a1a; margin: 0 0 6px 0;">2. Operational Efficiency</h4>
              <p style="font-size: 13px; color: #888; margin: 0;">AI-driven supply chain optimization, inventory management, and store-level automation reducing waste and accelerating decisions.</p>
            </div>
            <div style="margin-bottom: 16px;">
              <h4 style="font-size: 13px; font-weight: 600; color: #1a1a1a; margin: 0 0 6px 0;">3. Customer Intimacy</h4>
              <p style="font-size: 13px; color: #888; margin: 0;">Predictive analytics and intelligent agents delivering frictionless, personalized experiences across all touchpoints.</p>
            </div>
            <div style="margin-bottom: 16px;">
              <h4 style="font-size: 13px; font-weight: 600; color: #1a1a1a; margin: 0 0 6px 0;">4. Risk &amp; Governance</h4>
              <p style="font-size: 13px; color: #888; margin: 0;">Established guardrails, compliance frameworks, and human-in-the-loop oversight ensuring responsible, auditable AI deployment.</p>
            </div>
          </div>

          <div style="margin-bottom: 32px;">
            <h3 style="font-size: 13px; color: #888; text-transform: uppercase; letter-spacing: 0.12em; font-family: 'DM Mono', monospace; margin-bottom: 12px; font-weight: 600;">Success Metrics (18–36 months)</h3>
            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 12px; font-family: 'DM Mono', monospace; font-size: 12px;">
              <div style="border: 1px solid #ddd; padding: 12px; border-radius: 4px;">
                <div style="color: #888; font-size: 10px; margin-bottom: 4px;">FINANCIAL</div>
                <div style="color: #FF6B2B; font-weight: 600;">$25M+ cumulative value</div>
                <div style="color: #888; font-size: 10px; margin-top: 4px;">7+ high-impact use cases live</div>
              </div>
              <div style="border: 1px solid #ddd; padding: 12px; border-radius: 4px;">
                <div style="color: #888; font-size: 10px; margin-bottom: 4px;">OPERATIONAL</div>
                <div style="color: #16a34a; font-weight: 600;">80% adoption of AI tools</div>
                <div style="color: #888; font-size: 10px; margin-top: 4px;">4-week decision velocity increase</div>
              </div>
              <div style="border: 1px solid #ddd; padding: 12px; border-radius: 4px;">
                <div style="color: #888; font-size: 10px; margin-bottom: 4px;">CUSTOMER</div>
                <div style="color: #0066cc; font-weight: 600;">+8% NPS / +12% AOV</div>
                <div style="color: #888; font-size: 10px; margin-top: 4px;">40% lift in personalization engagement</div>
              </div>
              <div style="border: 1px solid #ddd; padding: 12px; border-radius: 4px;">
                <div style="color: #888; font-size: 10px; margin-bottom: 4px;">RISK &amp; GOVERNANCE</div>
                <div style="color: #8b5cf6; font-weight: 600;">100% model audit coverage</div>
                <div style="color: #888; font-size: 10px; margin-top: 4px;">Zero untracked AI decisions</div>
              </div>
            </div>
          </div>

          <div>
            <h3 style="font-size: 13px; color: #888; text-transform: uppercase; letter-spacing: 0.12em; font-family: 'DM Mono', monospace; margin-bottom: 12px; font-weight: 600;">Timeline Horizon</h3>
            <p style="font-size: 13px; color: #1a1a1a; margin: 0 0 8px 0;"><strong>H1 (Months 1–6):</strong> Data foundation modernization, governance setup, quick wins implementation.</p>
            <p style="font-size: 13px; color: #1a1a1a; margin: 0 0 8px 0;"><strong>H2 (Months 7–18):</strong> Core use cases at scale, agent architecture deployment, operating model embedded.</p>
            <p style="font-size: 13px; color: #1a1a1a; margin: 0;">H3 (Months 19–36):</strong> Optimization, expansion to adjacent use cases, continuous value realization.</p>
          </div>
        </div>
        <div class="dlv-doc-footer">
          <span style="font-size: 11px; color: #888;">Perceptya AI Value Discovery</span>
          <span style="font-size: 11px; color: #888;">Page 1 of 1</span>
        </div>
      </div>`,
},

'preview-metrics-framework': {
    title: 'Metrics Framework.xlsx',
    body: `<div class="dlv-page">
        <div class="dlv-sanitized"><div class="dlv-sanitized-stripe">Sanitized client example</div></div>
        <div class="dlv-doc-header">
          <div class="dlv-doc-brand">PERCEPT<em>Y</em>A</div>
          <div class="dlv-doc-meta">
            <span>Metrics Framework</span>
            <span>March 2024</span>
            <span class="dlv-doc-badge">Confidential</span>
          </div>
        </div>
        <div style="padding: 24px; border-bottom: 1px solid #ddd;">
          <div class="dlv-doc-title">AI Value Metrics Framework</div>
          <div class="dlv-doc-subtitle">Tracking baseline, targets, and value realization | Latin American Big Fashion Retail</div>
        </div>
        <div style="padding: 16px 24px; overflow-x: auto;">
          <table class="dlv-table" style="width: 100%; font-size: 12px; border-collapse: collapse;">
            <thead>
              <tr style="background: #f9f9f9; border-bottom: 2px solid #ddd;">
                <th style="text-align: left; padding: 10px; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 11px;">Metric Category</th>
                <th style="text-align: left; padding: 10px; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 11px;">KPI</th>
                <th style="text-align: center; padding: 10px; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 11px;">Current</th>
                <th style="text-align: center; padding: 10px; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 11px;">12-Mo Target</th>
                <th style="text-align: center; padding: 10px; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 11px;">24-Mo Target</th>
                <th style="text-align: left; padding: 10px; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 11px;">Owner</th>
                <th style="text-align: left; padding: 10px; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 11px;">Data Source</th>
              </tr>
            </thead>
            <tbody>
              <tr style="border-bottom: 1px solid #eee;">
                <td style="padding: 10px; color: #FF6B2B; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 10px;">REVENUE</td>
                <td style="padding: 10px; color: #1a1a1a;">Average Order Value</td>
                <td style="padding: 10px; text-align: center; color: #1a1a1a;">$156</td>
                <td style="padding: 10px; text-align: center; color: #16a34a; font-weight: 600;">$168</td>
                <td style="padding: 10px; text-align: center; color: #16a34a; font-weight: 600;">$182</td>
                <td style="padding: 10px; color: #888;">VP Merchandising</td>
                <td style="padding: 10px; color: #888;">POS + E-commerce</td>
              </tr>
              <tr style="border-bottom: 1px solid #eee;">
                <td style="padding: 10px; color: #FF6B2B; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 10px;"></td>
                <td style="padding: 10px; color: #1a1a1a;">Conversion Rate (E-comm)</td>
                <td style="padding: 10px; text-align: center; color: #1a1a1a;">2.8%</td>
                <td style="padding: 10px; text-align: center; color: #16a34a; font-weight: 600;">3.4%</td>
                <td style="padding: 10px; text-align: center; color: #16a34a; font-weight: 600;">4.1%</td>
                <td style="padding: 10px; color: #888;">Head of E-comm</td>
                <td style="padding: 10px; color: #888;">Shopify / Analytics</td>
              </tr>
              <tr style="border-bottom: 1px solid #eee;">
                <td style="padding: 10px; color: #FF6B2B; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 10px;"></td>
                <td style="padding: 10px; color: #1a1a1a;">Cross-sell Revenue %</td>
                <td style="padding: 10px; text-align: center; color: #1a1a1a;">12%</td>
                <td style="padding: 10px; text-align: center; color: #16a34a; font-weight: 600;">18%</td>
                <td style="padding: 10px; text-align: center; color: #16a34a; font-weight: 600;">24%</td>
                <td style="padding: 10px; color: #888;">Chief Commercial</td>
                <td style="padding: 10px; color: #888;">POS / CRM</td>
              </tr>
              <tr style="border-bottom: 1px solid #eee;">
                <td style="padding: 10px; color: #16a34a; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 10px;">EFFICIENCY</td>
                <td style="padding: 10px; color: #1a1a1a;">Inventory Turnover</td>
                <td style="padding: 10px; text-align: center; color: #1a1a1a;">3.2x</td>
                <td style="padding: 10px; text-align: center; color: #16a34a; font-weight: 600;">3.8x</td>
                <td style="padding: 10px; text-align: center; color: #16a34a; font-weight: 600;">4.4x</td>
                <td style="padding: 10px; color: #888;">VP Supply Chain</td>
                <td style="padding: 10px; color: #888;">Warehouse Mgmt</td>
              </tr>
              <tr style="border-bottom: 1px solid #eee;">
                <td style="padding: 10px; color: #16a34a; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 10px;"></td>
                <td style="padding: 10px; color: #1a1a1a;">Forecast Accuracy (MAPE)</td>
                <td style="padding: 10px; text-align: center; color: #1a1a1a;">18.2%</td>
                <td style="padding: 10px; text-align: center; color: #16a34a; font-weight: 600;">12.5%</td>
                <td style="padding: 10px; text-align: center; color: #16a34a; font-weight: 600;">8.7%</td>
                <td style="padding: 10px; color: #888;">Demand Planner</td>
                <td style="padding: 10px; color: #888;">Planning System</td>
              </tr>
              <tr style="border-bottom: 1px solid #eee;">
                <td style="padding: 10px; color: #16a34a; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 10px;"></td>
                <td style="padding: 10px; color: #1a1a1a;">Decision Cycle Time (hours)</td>
                <td style="padding: 10px; text-align: center; color: #1a1a1a;">72</td>
                <td style="padding: 10px; text-align: center; color: #16a34a; font-weight: 600;">36</td>
                <td style="padding: 10px; text-align: center; color: #16a34a; font-weight: 600;">12</td>
                <td style="padding: 10px; color: #888;">Chief Analyst</td>
                <td style="padding: 10px; color: #888;">Dashboard / System</td>
              </tr>
              <tr style="border-bottom: 1px solid #eee;">
                <td style="padding: 10px; color: #0066cc; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 10px;">CUSTOMER</td>
                <td style="padding: 10px; color: #1a1a1a;">Net Promoter Score</td>
                <td style="padding: 10px; text-align: center; color: #1a1a1a;">42</td>
                <td style="padding: 10px; text-align: center; color: #16a34a; font-weight: 600;">48</td>
                <td style="padding: 10px; text-align: center; color: #16a34a; font-weight: 600;">54</td>
                <td style="padding: 10px; color: #888;">Chief Experience Officer</td>
                <td style="padding: 10px; color: #888;">Survey / CSAT System</td>
              </tr>
              <tr style="border-bottom: 1px solid #eee;">
                <td style="padding: 10px; color: #0066cc; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 10px;"></td>
                <td style="padding: 10px; color: #1a1a1a;">Customer Lifetime Value</td>
                <td style="padding: 10px; text-align: center; color: #1a1a1a;">$2,840</td>
                <td style="padding: 10px; text-align: center; color: #16a34a; font-weight: 600;">$3,320</td>
                <td style="padding: 10px; text-align: center; color: #16a34a; font-weight: 600;">$3,920</td>
                <td style="padding: 10px; color: #888;">VP Customer Analytics</td>
                <td style="padding: 10px; color: #888;">CRM / Data Lake</td>
              </tr>
              <tr style="border-bottom: 1px solid #eee;">
                <td style="padding: 10px; color: #0066cc; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 10px;"></td>
                <td style="padding: 10px; color: #1a1a1a;">Repeat Purchase Rate</td>
                <td style="padding: 10px; text-align: center; color: #1a1a1a;">28%</td>
                <td style="padding: 10px; text-align: center; color: #16a34a; font-weight: 600;">34%</td>
                <td style="padding: 10px; text-align: center; color: #16a34a; font-weight: 600;">42%</td>
                <td style="padding: 10px; color: #888;">Head of Loyalty</td>
                <td style="padding: 10px; color: #888;">CRM</td>
              </tr>
              <tr style="border-bottom: 1px solid #eee;">
                <td style="padding: 10px; color: #8b5cf6; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 10px;">OPERATIONS</td>
                <td style="padding: 10px; color: #1a1a1a;">Supply Chain Resilience (%)</td>
                <td style="padding: 10px; text-align: center; color: #1a1a1a;">68%</td>
                <td style="padding: 10px; text-align: center; color: #16a34a; font-weight: 600;">78%</td>
                <td style="padding: 10px; text-align: center; color: #16a34a; font-weight: 600;">88%</td>
                <td style="padding: 10px; color: #888;">Dir. Planning</td>
                <td style="padding: 10px; color: #888;">Supply Chain Tool</td>
              </tr>
              <tr style="border-bottom: 1px solid #eee;">
                <td style="padding: 10px; color: #8b5cf6; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 10px;"></td>
                <td style="padding: 10px; color: #1a1a1a;">Store Labor Efficiency</td>
                <td style="padding: 10px; text-align: center; color: #1a1a1a;">$18.50/unit</td>
                <td style="padding: 10px; text-align: center; color: #16a34a; font-weight: 600;">$16.20/unit</td>
                <td style="padding: 10px; text-align: center; color: #16a34a; font-weight: 600;">$14.80/unit</td>
                <td style="padding: 10px; color: #888;">Dir. Store Ops</td>
                <td style="padding: 10px; color: #888;">HCM / POS</td>
              </tr>
              <tr>
                <td style="padding: 10px; color: #8b5cf6; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 10px;"></td>
                <td style="padding: 10px; color: #1a1a1a;">Data Quality Score</td>
                <td style="padding: 10px; text-align: center; color: #1a1a1a;">62%</td>
                <td style="padding: 10px; text-align: center; color: #16a34a; font-weight: 600;">80%</td>
                <td style="padding: 10px; text-align: center; color: #16a34a; font-weight: 600;">92%</td>
                <td style="padding: 10px; color: #888;">Chief Data Officer</td>
                <td style="padding: 10px; color: #888;">Data Catalog</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="dlv-doc-footer">
          <span style="font-size: 11px; color: #888;">Perceptya AI Value Discovery</span>
          <span style="font-size: 11px; color: #888;">Sheet 1: Metrics Framework</span>
        </div>
      </div>`,
},

'preview-maturity-score': {
    title: 'AI Maturity Score Report.pdf',
    body: `<div class="dlv-page">
        <div class="dlv-sanitized"><div class="dlv-sanitized-stripe">Sanitized client example</div></div>
        <div class="dlv-doc-header"><div class="dlv-doc-brand">PERCEPT<em>Y</em>A</div><div class="dlv-doc-meta"><span>Maturity Assessment</span><span>April 2024</span><span class="dlv-doc-badge">Confidential</span></div></div>
        <div style="padding: 32px 24px; border-bottom: 1px solid #ddd;"><div class="dlv-doc-title">AI Maturity Score Report™</div><div class="dlv-doc-subtitle">Current State Assessment | Latin American Big Fashion Retail</div></div>
        <div style="padding: 32px 24px;">
          <div style="text-align: center; margin-bottom: 32px;">
            <div style="font-family: 'DM Mono', monospace; font-size: 48px; font-weight: 600; color: #FF6B2B;">2.3 / 5.0</div>
            <div style="font-family: 'DM Mono', monospace; font-size: 12px; color: #888; margin-top: 4px; letter-spacing: 0.08em;">OVERALL MATURITY SCORE</div>
            <div style="font-family: 'DM Mono', monospace; font-size: 11px; color: #888; margin-top: 8px;">ASSESSMENT LEVEL: Early Adoption | INDUSTRY BENCHMARK: 2.6</div>
          </div>
          <svg viewBox="0 0 500 300" style="width: 100%; max-width: 500px; margin: 0 auto 32px; display: block;">
            <g>
              <circle cx="250" cy="150" r="2" fill="#1a1a1a"/>
              <circle cx="250" cy="150" r="30" fill="none" stroke="#eee" stroke-width="1" stroke-dasharray="2,2" opacity="0.5"/>
              <circle cx="250" cy="150" r="60" fill="none" stroke="#eee" stroke-width="1" stroke-dasharray="2,2" opacity="0.5"/>
              <circle cx="250" cy="150" r="90" fill="none" stroke="#eee" stroke-width="1" stroke-dasharray="2,2" opacity="0.5"/>
              <circle cx="250" cy="150" r="120" fill="none" stroke="#ddd" stroke-width="1"/>
              <line x1="250" y1="30" x2="250" y2="150" stroke="#ddd" stroke-width="1"/>
              <text x="250" y="15" text-anchor="middle" font-family="DM Mono" font-size="10" fill="#1a1a1a" font-weight="600">Data Infrastructure</text>
              <circle cx="250" cy="78" r="3.6" fill="#FF6B2B" opacity="0.8"/>
              <line x1="366" y1="73" x2="250" y2="150" stroke="#ddd" stroke-width="1"/>
              <text x="385" y="60" text-anchor="start" font-family="DM Mono" font-size="10" fill="#1a1a1a" font-weight="600">Data Governance</text>
              <circle cx="318" cy="99" r="3.2" fill="#FF6B2B" opacity="0.8"/>
              <line x1="366" y1="227" x2="250" y2="150" stroke="#ddd" stroke-width="1"/>
              <text x="385" y="245" text-anchor="start" font-family="DM Mono" font-size="10" fill="#1a1a1a" font-weight="600">Analytics Maturity</text>
              <circle cx="318" cy="198" r="3.6" fill="#FF6B2B" opacity="0.8"/>
              <line x1="134" y1="227" x2="250" y2="150" stroke="#ddd" stroke-width="1"/>
              <text x="80" y="245" text-anchor="end" font-family="DM Mono" font-size="10" fill="#1a1a1a" font-weight="600">AI/ML Capability</text>
              <circle cx="182" cy="198" r="2.4" fill="#FF6B2B" opacity="0.8"/>
              <line x1="134" y1="73" x2="250" y2="150" stroke="#ddd" stroke-width="1"/>
              <text x="80" y="60" text-anchor="end" font-family="DM Mono" font-size="10" fill="#1a1a1a" font-weight="600">Org. Readiness</text>
              <circle cx="182" cy="99" r="3.0" fill="#FF6B2B" opacity="0.8"/>
              <polygon points="250,78 318,99 318,198 182,198 182,99" fill="#FF6B2B" opacity="0.15" stroke="#FF6B2B" stroke-width="2"/>
              <polygon points="250,84 332,103 320,209 170,209 168,103" fill="#16a34a" opacity="0.05" stroke="#16a34a" stroke-width="1" stroke-dasharray="2,2"/>
            </g>
          </svg>
          <div style="margin-bottom: 24px;">
            <div style="font-family: 'DM Mono', monospace; font-size: 11px; color: #888; margin-bottom: 8px; letter-spacing: 0.08em; text-transform: uppercase;">DIMENSION SCORECARD</div>
            <table class="dlv-table" style="width: 100%; font-size: 12px;">
              <thead><tr style="background: #f9f9f9; border-bottom: 1px solid #ddd;"><th style="text-align: left; padding: 10px; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 11px;">Dimension</th><th style="text-align: center; padding: 10px; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 11px;">Current</th><th style="text-align: center; padding: 10px; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 11px;">Benchmark</th><th style="text-align: center; padding: 10px; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 11px;">Gap</th><th style="text-align: left; padding: 10px; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 11px;">Priority</th></tr></thead>
              <tbody>
                <tr style="border-bottom: 1px solid #eee;"><td style="padding: 10px; color: #1a1a1a; font-weight: 500;">Data Infrastructure</td><td style="padding: 10px; text-align: center; color: #1a1a1a; font-weight: 600;">1.8</td><td style="padding: 10px; text-align: center; color: #888;">2.4</td><td style="padding: 10px; text-align: center; color: #1a1a1a;">−0.6</td><td style="padding: 10px;"><span class="dlv-status orange">CRITICAL</span></td></tr>
                <tr style="border-bottom: 1px solid #eee;"><td style="padding: 10px; color: #1a1a1a; font-weight: 500;">Data Governance</td><td style="padding: 10px; text-align: center; color: #1a1a1a; font-weight: 600;">1.6</td><td style="padding: 10px; text-align: center; color: #888;">2.3</td><td style="padding: 10px; text-align: center; color: #1a1a1a;">−0.7</td><td style="padding: 10px;"><span class="dlv-status orange">CRITICAL</span></td></tr>
                <tr style="border-bottom: 1px solid #eee;"><td style="padding: 10px; color: #1a1a1a; font-weight: 500;">Analytics Maturity</td><td style="padding: 10px; text-align: center; color: #1a1a1a; font-weight: 600;">1.8</td><td style="padding: 10px; text-align: center; color: #888;">2.5</td><td style="padding: 10px; text-align: center; color: #1a1a1a;">−0.7</td><td style="padding: 10px;"><span class="dlv-status orange">CRITICAL</span></td></tr>
                <tr style="border-bottom: 1px solid #eee;"><td style="padding: 10px; color: #1a1a1a; font-weight: 500;">AI/ML Capability</td><td style="padding: 10px; text-align: center; color: #1a1a1a; font-weight: 600;">1.2</td><td style="padding: 10px; text-align: center; color: #888;">2.8</td><td style="padding: 10px; text-align: center; color: #1a1a1a;">−1.6</td><td style="padding: 10px;"><span class="dlv-status orange">CRITICAL</span></td></tr>
                <tr><td style="padding: 10px; color: #1a1a1a; font-weight: 500;">Organizational Readiness</td><td style="padding: 10px; text-align: center; color: #1a1a1a; font-weight: 600;">1.5</td><td style="padding: 10px; text-align: center; color: #888;">2.2</td><td style="padding: 10px; text-align: center; color: #1a1a1a;">−0.7</td><td style="padding: 10px;"><span class="dlv-status orange">HIGH</span></td></tr>
              </tbody>
            </table>
          </div>
          <div style="font-family: 'DM Mono', monospace; font-size: 11px; color: #888; margin-bottom: 8px; letter-spacing: 0.08em; text-transform: uppercase;">RECOMMENDATIONS</div>
          <div style="background: #f9f9f9; padding: 16px; border-radius: 4px; font-size: 13px; color: #1a1a1a; line-height: 1.6;">
            <p style="margin: 0 0 8px 0;">1. <strong>Immediate focus:</strong> Modernize data infrastructure (lakehouse, cloud migration, data quality tooling).</p>
            <p style="margin: 0 0 8px 0;">2. <strong>Parallel track:</strong> Establish governance frameworks and establish a data CoE to coordinate across functions.</p>
            <p style="margin: 0 0 8px 0;">3. <strong>Talent acquisition:</strong> Hire ML engineers and data scientists; upskill existing analytics team on AI/ML fundamentals.</p>
            <p style="margin: 0;">4. <strong>Change management:</strong> Launch cross-functional AI literacy program and executive steering committee.</p>
          </div>
        </div>
        <div class="dlv-doc-footer"><span style="font-size: 11px; color: #888;">Perceptya AI Value Discovery</span><span style="font-size: 11px; color: #888;">Page 1 of 1</span></div>
      </div>`,
},

'preview-capability-heatmap': {
    title: 'Capability Heatmap.xlsx',
    body: `<div class="dlv-page">
        <div class="dlv-sanitized"><div class="dlv-sanitized-stripe">Sanitized client example</div></div>
        <div class="dlv-doc-header"><div class="dlv-doc-brand">PERCEPT<em>Y</em>A</div><div class="dlv-doc-meta"><span>Capability Heatmap</span><span>April 2024</span><span class="dlv-doc-badge">Confidential</span></div></div>
        <div style="padding: 24px; border-bottom: 1px solid #ddd;"><div class="dlv-doc-title">Technical &amp; Organizational Capability Heatmap</div><div class="dlv-doc-subtitle">Maturity assessment by team and capability dimension</div></div>
        <div style="padding: 16px 24px; overflow-x: auto;">
          <table class="dlv-table" style="width: 100%; font-size: 11px; border-collapse: collapse;">
            <thead><tr style="background: #f9f9f9; border-bottom: 2px solid #ddd;"><th style="text-align: left; padding: 10px; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 10px; min-width: 140px;">Team / Function</th><th style="text-align: center; padding: 8px; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 10px; width: 90px;">Skills</th><th style="text-align: center; padding: 8px; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 10px; width: 90px;">Tools</th><th style="text-align: center; padding: 8px; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 10px; width: 90px;">Processes</th><th style="text-align: center; padding: 8px; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 10px; width: 90px;">Governance</th><th style="text-align: center; padding: 8px; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 10px; width: 90px;">Culture</th><th style="text-align: center; padding: 8px; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 10px; width: 70px;">Avg</th></tr></thead>
            <tbody>
              <tr style="border-bottom: 1px solid #eee;"><td style="padding: 10px; color: #1a1a1a; font-weight: 500;">Data Engineering</td><td style="padding: 8px; text-align: center; background: #fee2e2; color: #991b1b; font-weight: 600; font-family: 'DM Mono', monospace;">1.8</td><td style="padding: 8px; text-align: center; background: #fed7aa; color: #7c2d12; font-weight: 600; font-family: 'DM Mono', monospace;">2.2</td><td style="padding: 8px; text-align: center; background: #fed7aa; color: #7c2d12; font-weight: 600; font-family: 'DM Mono', monospace;">2.4</td><td style="padding: 8px; text-align: center; background: #fef3c7; color: #78350f; font-weight: 600; font-family: 'DM Mono', monospace;">2.1</td><td style="padding: 8px; text-align: center; background: #fee2e2; color: #991b1b; font-weight: 600; font-family: 'DM Mono', monospace;">1.6</td><td style="padding: 8px; text-align: center; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; background: #f3f4f6;">2.0</td></tr>
              <tr style="border-bottom: 1px solid #eee;"><td style="padding: 10px; color: #1a1a1a; font-weight: 500;">Data Science</td><td style="padding: 8px; text-align: center; background: #fef3c7; color: #78350f; font-weight: 600; font-family: 'DM Mono', monospace;">2.1</td><td style="padding: 8px; text-align: center; background: #fee2e2; color: #991b1b; font-weight: 600; font-family: 'DM Mono', monospace;">1.5</td><td style="padding: 8px; text-align: center; background: #fed7aa; color: #7c2d12; font-weight: 600; font-family: 'DM Mono', monospace;">2.3</td><td style="padding: 8px; text-align: center; background: #fee2e2; color: #991b1b; font-weight: 600; font-family: 'DM Mono', monospace;">1.4</td><td style="padding: 8px; text-align: center; background: #fee2e2; color: #991b1b; font-weight: 600; font-family: 'DM Mono', monospace;">1.3</td><td style="padding: 8px; text-align: center; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; background: #f3f4f6;">1.7</td></tr>
              <tr style="border-bottom: 1px solid #eee;"><td style="padding: 10px; color: #1a1a1a; font-weight: 500;">Analytics</td><td style="padding: 8px; text-align: center; background: #fef3c7; color: #78350f; font-weight: 600; font-family: 'DM Mono', monospace;">2.4</td><td style="padding: 8px; text-align: center; background: #fed7aa; color: #7c2d12; font-weight: 600; font-family: 'DM Mono', monospace;">2.6</td><td style="padding: 8px; text-align: center; background: #fef3c7; color: #78350f; font-weight: 600; font-family: 'DM Mono', monospace;">2.2</td><td style="padding: 8px; text-align: center; background: #fee2e2; color: #991b1b; font-weight: 600; font-family: 'DM Mono', monospace;">1.8</td><td style="padding: 8px; text-align: center; background: #fef3c7; color: #78350f; font-weight: 600; font-family: 'DM Mono', monospace;">2.3</td><td style="padding: 8px; text-align: center; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; background: #f3f4f6;">2.3</td></tr>
              <tr style="border-bottom: 1px solid #eee;"><td style="padding: 10px; color: #1a1a1a; font-weight: 500;">MLOps / DevOps</td><td style="padding: 8px; text-align: center; background: #fee2e2; color: #991b1b; font-weight: 600; font-family: 'DM Mono', monospace;">1.2</td><td style="padding: 8px; text-align: center; background: #fed7aa; color: #7c2d12; font-weight: 600; font-family: 'DM Mono', monospace;">2.0</td><td style="padding: 8px; text-align: center; background: #fed7aa; color: #7c2d12; font-weight: 600; font-family: 'DM Mono', monospace;">1.9</td><td style="padding: 8px; text-align: center; background: #fee2e2; color: #991b1b; font-weight: 600; font-family: 'DM Mono', monospace;">1.3</td><td style="padding: 8px; text-align: center; background: #fee2e2; color: #991b1b; font-weight: 600; font-family: 'DM Mono', monospace;">1.1</td><td style="padding: 8px; text-align: center; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; background: #f3f4f6;">1.5</td></tr>
              <tr style="border-bottom: 1px solid #eee;"><td style="padding: 10px; color: #1a1a1a; font-weight: 500;">Business Intelligence</td><td style="padding: 8px; text-align: center; background: #fef3c7; color: #78350f; font-weight: 600; font-family: 'DM Mono', monospace;">2.3</td><td style="padding: 8px; text-align: center; background: #fef3c7; color: #78350f; font-weight: 600; font-family: 'DM Mono', monospace;">2.5</td><td style="padding: 8px; text-align: center; background: #fed7aa; color: #7c2d12; font-weight: 600; font-family: 'DM Mono', monospace;">2.4</td><td style="padding: 8px; text-align: center; background: #fef3c7; color: #78350f; font-weight: 600; font-family: 'DM Mono', monospace;">2.0</td><td style="padding: 8px; text-align: center; background: #fed7aa; color: #7c2d12; font-weight: 600; font-family: 'DM Mono', monospace;">2.2</td><td style="padding: 8px; text-align: center; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; background: #f3f4f6;">2.3</td></tr>
              <tr style="border-bottom: 1px solid #eee; background: #f9f9f9;"><td style="padding: 10px; color: #1a1a1a; font-weight: 500;">IT Infrastructure</td><td style="padding: 8px; text-align: center; background: #fed7aa; color: #7c2d12; font-weight: 600; font-family: 'DM Mono', monospace;">2.2</td><td style="padding: 8px; text-align: center; background: #fef3c7; color: #78350f; font-weight: 600; font-family: 'DM Mono', monospace;">2.4</td><td style="padding: 8px; text-align: center; background: #fed7aa; color: #7c2d12; font-weight: 600; font-family: 'DM Mono', monospace;">2.3</td><td style="padding: 8px; text-align: center; background: #fed7aa; color: #7c2d12; font-weight: 600; font-family: 'DM Mono', monospace;">2.2</td><td style="padding: 8px; text-align: center; background: #fed7aa; color: #7c2d12; font-weight: 600; font-family: 'DM Mono', monospace;">2.3</td><td style="padding: 8px; text-align: center; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; background: #f3f4f6;">2.3</td></tr>
              <tr style="background: #f9f9f9; border-top: 2px solid #ddd;"><td style="padding: 10px; color: #1a1a1a; font-weight: 600;">Organization Average</td><td style="padding: 8px; text-align: center; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace;">2.0</td><td style="padding: 8px; text-align: center; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace;">2.2</td><td style="padding: 8px; text-align: center; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace;">2.2</td><td style="padding: 8px; text-align: center; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace;">1.8</td><td style="padding: 8px; text-align: center; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace;">1.8</td><td style="padding: 8px; text-align: center; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace;">2.0</td></tr>
            </tbody>
          </table>
          <div style="margin-top: 20px; font-family: 'DM Mono', monospace; font-size: 10px; display: flex; gap: 16px;">
            <div style="display: flex; align-items: center; gap: 6px;"><div style="width: 16px; height: 16px; background: #fee2e2;"></div><span style="color: #888;">1.0–1.5 (Critical)</span></div>
            <div style="display: flex; align-items: center; gap: 6px;"><div style="width: 16px; height: 16px; background: #fed7aa;"></div><span style="color: #888;">1.6–2.5 (Below Target)</span></div>
            <div style="display: flex; align-items: center; gap: 6px;"><div style="width: 16px; height: 16px; background: #fef3c7;"></div><span style="color: #888;">2.6–3.5 (On Track)</span></div>
            <div style="display: flex; align-items: center; gap: 6px;"><div style="width: 16px; height: 16px; background: #bbf7d0;"></div><span style="color: #888;">3.6–5.0 (Advanced)</span></div>
          </div>
        </div>
        <div class="dlv-doc-footer"><span style="font-size: 11px; color: #888;">Perceptya AI Value Discovery</span><span style="font-size: 11px; color: #888;">Sheet: Capability Assessment</span></div>
      </div>`,
},

'preview-gap-analysis': {
    title: 'Gap Analysis Report.pdf',
    body: `<div class="dlv-page">
        <div class="dlv-sanitized"><div class="dlv-sanitized-stripe">Sanitized client example</div></div>
        <div class="dlv-doc-header"><div class="dlv-doc-brand">PERCEPT<em>Y</em>A</div><div class="dlv-doc-meta"><span>Gap Analysis</span><span>April 2024</span><span class="dlv-doc-badge">Confidential</span></div></div>
        <div style="padding: 32px 24px; border-bottom: 1px solid #ddd;"><div class="dlv-doc-title">Gap Analysis Report</div><div class="dlv-doc-subtitle">Current state vs. Target state across critical dimensions</div></div>
        <div style="padding: 32px 24px;">
          <table class="dlv-table" style="width: 100%; font-size: 12px;">
            <thead><tr style="background: #f9f9f9; border-bottom: 2px solid #ddd;"><th style="text-align: left; padding: 10px; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 11px;">Dimension</th><th style="text-align: left; padding: 10px; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 11px;">Current State</th><th style="text-align: left; padding: 10px; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 11px;">Target State</th><th style="text-align: center; padding: 10px; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 11px;">Severity</th><th style="text-align: center; padding: 10px; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 11px;">Priority</th><th style="text-align: left; padding: 10px; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 11px;">Effort</th></tr></thead>
            <tbody>
              <tr style="border-bottom: 1px solid #eee;"><td style="padding: 10px; color: #1a1a1a; font-weight: 500;">Data Quality</td><td style="padding: 10px; color: #888; font-size: 11px;">Siloed data, manual processes, no DQ standards</td><td style="padding: 10px; color: #888; font-size: 11px;">Automated DQ checks, SLAs, 95%+ accuracy</td><td style="padding: 10px; text-align: center;"><span class="dlv-status orange">HIGH</span></td><td style="padding: 10px; text-align: center; color: #FF6B2B; font-weight: 600; font-family: 'DM Mono', monospace;">1</td><td style="padding: 10px; color: #888;">4–6 months</td></tr>
              <tr style="border-bottom: 1px solid #eee;"><td style="padding: 10px; color: #1a1a1a; font-weight: 500;">Data Governance</td><td style="padding: 10px; color: #888; font-size: 11px;">No formal CoE, no lineage tracking, ad-hoc approvals</td><td style="padding: 10px; color: #888; font-size: 11px;">Formal Data CoE, lineage platform, approval workflows</td><td style="padding: 10px; text-align: center;"><span class="dlv-status orange">HIGH</span></td><td style="padding: 10px; text-align: center; color: #FF6B2B; font-weight: 600; font-family: 'DM Mono', monospace;">2</td><td style="padding: 10px; color: #888;">3–4 months</td></tr>
              <tr style="border-bottom: 1px solid #eee;"><td style="padding: 10px; color: #1a1a1a; font-weight: 500;">Cloud Infrastructure</td><td style="padding: 10px; color: #888; font-size: 11px;">On-premise legacy, limited scalability, high capex</td><td style="padding: 10px; color: #888; font-size: 11px;">Cloud-native (AWS/Azure), serverless, auto-scaling</td><td style="padding: 10px; text-align: center;"><span class="dlv-status orange">HIGH</span></td><td style="padding: 10px; text-align: center; color: #FF6B2B; font-weight: 600; font-family: 'DM Mono', monospace;">1</td><td style="padding: 10px; color: #888;">6–9 months</td></tr>
              <tr style="border-bottom: 1px solid #eee;"><td style="padding: 10px; color: #1a1a1a; font-weight: 500;">Analytics Stack</td><td style="padding: 10px; color: #888; font-size: 11px;">Tableau, scattered SQL, no data transformation layer</td><td style="padding: 10px; color: #888; font-size: 11px;">Modern BI (Looker), dbt pipelines, data modeling</td><td style="padding: 10px; text-align: center;"><span class="dlv-status orange">HIGH</span></td><td style="padding: 10px; text-align: center; color: #FF6B2B; font-weight: 600; font-family: 'DM Mono', monospace;">3</td><td style="padding: 10px; color: #888;">3–5 months</td></tr>
              <tr style="border-bottom: 1px solid #eee;"><td style="padding: 10px; color: #1a1a1a; font-weight: 500;">ML/AI Tooling</td><td style="padding: 10px; color: #888; font-size: 11px;">No MLOps, ad-hoc notebooks, no model registry</td><td style="padding: 10px; color: #888; font-size: 11px;">Model registry, experiment tracking, automated pipelines</td><td style="padding: 10px; text-align: center;"><span class="dlv-status orange">HIGH</span></td><td style="padding: 10px; text-align: center; color: #FF6B2B; font-weight: 600; font-family: 'DM Mono', monospace;">2</td><td style="padding: 10px; color: #888;">4–6 months</td></tr>
              <tr style="border-bottom: 1px solid #eee;"><td style="padding: 10px; color: #1a1a1a; font-weight: 500;">AI/ML Talent</td><td style="padding: 10px; color: #888; font-size: 11px;">0 ML engineers, 2 data scientists, limited upskilling</td><td style="padding: 10px; color: #888; font-size: 11px;">Core team: 4–5 ML engineers, 6–8 data scientists, CoE leads</td><td style="padding: 10px; text-align: center;"><span class="dlv-status orange">HIGH</span></td><td style="padding: 10px; text-align: center; color: #FF6B2B; font-weight: 600; font-family: 'DM Mono', monospace;">1</td><td style="padding: 10px; color: #888;">Ongoing (6–12 mo)</td></tr>
              <tr style="border-bottom: 1px solid #eee;"><td style="padding: 10px; color: #1a1a1a; font-weight: 500;">AI Ethics &amp; Compliance</td><td style="padding: 10px; color: #888; font-size: 11px;">No formal AI governance, no bias audits, GDPR gaps</td><td style="padding: 10px; color: #888; font-size: 11px;">AI governance board, model audit framework, compliance checks</td><td style="padding: 10px; text-align: center;"><span class="dlv-status orange">HIGH</span></td><td style="padding: 10px; text-align: center; color: #16a34a; font-weight: 600; font-family: 'DM Mono', monospace;">4</td><td style="padding: 10px; color: #888;">2–3 months</td></tr>
              <tr style="border-bottom: 1px solid #eee;"><td style="padding: 10px; color: #1a1a1a; font-weight: 500;">Change &amp; Adoption</td><td style="padding: 10px; color: #888; font-size: 11px;">Limited AI literacy, siloed business units, resistance</td><td style="padding: 10px; color: #888; font-size: 11px;">Cross-functional AI literacy, shared KPIs, adoption metrics</td><td style="padding: 10px; text-align: center;"><span class="dlv-status orange">HIGH</span></td><td style="padding: 10px; text-align: center; color: #16a34a; font-weight: 600; font-family: 'DM Mono', monospace;">3</td><td style="padding: 10px; color: #888;">Ongoing (12+ mo)</td></tr>
            </tbody>
          </table>
          <div style="margin-top: 24px; padding: 16px; background: #f9f9f9; border-radius: 4px;">
            <div style="font-family: 'DM Mono', monospace; font-size: 11px; color: #888; margin-bottom: 12px; letter-spacing: 0.08em; text-transform: uppercase; font-weight: 600;">PRIORITIZATION LOGIC</div>
            <p style="font-size: 13px; color: #1a1a1a; margin: 0; line-height: 1.6;">Priorities 1–2 (data quality, cloud, talent hiring) must be addressed in parallel across H1. Priority 3 follows as analytics foundation stabilizes. Priorities 4+ can be concurrent with ongoing operations. All timeline estimates assume dedicated team allocation.</p>
          </div>
        </div>
        <div class="dlv-doc-footer"><span style="font-size: 11px; color: #888;">Perceptya AI Value Discovery</span><span style="font-size: 11px; color: #888;">Page 1 of 1</span></div>
      </div>`,
},

'preview-impact-feasibility': {
    title: 'Impact × Feasibility Matrix.xlsx',
    body: `<div class="dlv-page">
        <div class="dlv-sanitized"><div class="dlv-sanitized-stripe">Sanitized client example</div></div>
        <div class="dlv-doc-header">
          <div class="dlv-doc-brand">PERCEPT<em>Y</em>A</div>
          <div class="dlv-doc-meta">
            <span>Use Case Prioritization Matrix</span>
            <span>May 2024</span>
            <span class="dlv-doc-badge">Confidential</span>
          </div>
        </div>
        <div style="padding: 24px; border-bottom: 1px solid #ddd;">
          <div class="dlv-doc-title">Impact × Feasibility Matrix</div>
          <div class="dlv-doc-subtitle">AI use case prioritization and sequencing strategy</div>
        </div>
        <div style="padding: 24px;">
          <svg viewBox="0 0 750 550" style="width: 100%; margin-bottom: 24px; background: #f9f9f9; border-radius: 4px; display: block;">
            <!-- Grid background -->
            <defs>
              <pattern id="feas-grid" width="75" height="55" patternUnits="userSpaceOnUse">
                <path d="M 75 0 L 0 0 0 55" fill="none" stroke="#eee" stroke-width="1"/>
              </pattern>
            </defs>
            <rect width="750" height="550" fill="url(#feas-grid)"/>

            <!-- Axis lines -->
            <line x1="100" y1="450" x2="700" y2="450" stroke="#1a1a1a" stroke-width="2"/>
            <line x1="100" y1="450" x2="100" y2="50" stroke="#1a1a1a" stroke-width="2"/>

            <!-- Axis labels -->
            <text x="400" y="520" text-anchor="middle" font-family="DM Mono" font-size="12" fill="#1a1a1a" font-weight="600">Technical Feasibility →</text>
            <text x="35" y="250" text-anchor="middle" font-family="DM Mono" font-size="12" fill="#1a1a1a" font-weight="600" transform="rotate(-90 35 250)">Business Impact ($M) →</text>

            <!-- Scale labels -->
            <text x="100" y="475" text-anchor="middle" font-family="DM Mono" font-size="10" fill="#888">Easy</text>
            <text x="700" y="475" text-anchor="middle" font-family="DM Mono" font-size="10" fill="#888">Difficult</text>
            <text x="75" y="460" text-anchor="end" font-family="DM Mono" font-size="10" fill="#888">Low</text>
            <text x="75" y="60" text-anchor="end" font-family="DM Mono" font-size="10" fill="#888">High</text>

            <!-- Quadrant labels -->
            <text x="220" y="85" text-anchor="middle" font-family="DM Mono" font-size="11" fill="#16a34a" font-weight="600" opacity="0.7">Quick Wins</text>
            <text x="580" y="85" text-anchor="middle" font-family="DM Mono" font-size="11" fill="#FF6B2B" font-weight="600" opacity="0.7">Strategic Bets</text>
            <text x="220" y="540" text-anchor="middle" font-family="DM Mono" font-size="11" fill="#888" font-weight="600" opacity="0.5">Low Priority</text>
            <text x="580" y="540" text-anchor="middle" font-family="DM Mono" font-size="11" fill="#0066cc" font-weight="600" opacity="0.7">Moonshots</text>

            <!-- Dividing lines (median lines) -->
            <line x1="400" y1="450" x2="400" y2="50" stroke="#ddd" stroke-width="1" stroke-dasharray="3,3"/>
            <line x1="100" y1="250" x2="700" y2="250" stroke="#ddd" stroke-width="1" stroke-dasharray="3,3"/>

            <!-- Use case dots with labels (sized by estimated value) -->
            <!-- Dynamic Pricing (high impact, high feasibility) - $3.2M -->
            <circle cx="570" cy="150" r="20" fill="#16a34a" opacity="0.3" stroke="#16a34a" stroke-width="2"/>
            <text x="570" y="157" text-anchor="middle" font-family="DM Mono" font-size="10" fill="#1a1a1a" font-weight="600">1</text>
            <text x="570" y="185" text-anchor="middle" font-family="DM Mono" font-size="9" fill="#1a1a1a" font-weight="600">Dynamic Pricing</text>

            <!-- Demand Forecasting (high impact, moderate feasibility) - $2.8M -->
            <circle cx="480" cy="180" r="18" fill="#FF6B2B" opacity="0.3" stroke="#FF6B2B" stroke-width="2"/>
            <text x="480" y="187" text-anchor="middle" font-family="DM Mono" font-size="10" fill="#1a1a1a" font-weight="600">2</text>
            <text x="480" y="215" text-anchor="middle" font-family="DM Mono" font-size="9" fill="#1a1a1a" font-weight="600">Demand Forecast</text>

            <!-- Inventory Optimization (medium impact, high feasibility) - $2.1M -->
            <circle cx="620" cy="220" r="17" fill="#16a34a" opacity="0.2" stroke="#16a34a" stroke-width="2"/>
            <text x="620" y="227" text-anchor="middle" font-family="DM Mono" font-size="10" fill="#1a1a1a" font-weight="600">3</text>
            <text x="620" y="255" text-anchor="middle" font-family="DM Mono" font-size="9" fill="#1a1a1a" font-weight="600">Inventory Opt</text>

            <!-- Personalization Engine (high impact, moderate feasibility) - $2.4M -->
            <circle cx="440" cy="140" r="18" fill="#FF6B2B" opacity="0.25" stroke="#FF6B2B" stroke-width="2"/>
            <text x="440" y="147" text-anchor="middle" font-family="DM Mono" font-size="10" fill="#1a1a1a" font-weight="600">4</text>
            <text x="440" y="175" text-anchor="middle" font-family="DM Mono" font-size="9" fill="#1a1a1a" font-weight="600">Personalization</text>

            <!-- Supply Chain Visibility (medium impact, moderate feasibility) - $1.8M -->
            <circle cx="450" cy="270" r="15" fill="#0066cc" opacity="0.2" stroke="#0066cc" stroke-width="2"/>
            <text x="450" y="277" text-anchor="middle" font-family="DM Mono" font-size="10" fill="#1a1a1a" font-weight="600">5</text>
            <text x="450" y="305" text-anchor="middle" font-family="DM Mono" font-size="9" fill="#1a1a1a; font-weight="600">Supply Chain Vis</text>

            <!-- Churn Prediction (medium impact, moderate-high feasibility) - $1.5M -->
            <circle cx="560" cy="280" r="14" fill="#16a34a" opacity="0.15" stroke="#16a34a" stroke-width="2"/>
            <text x="560" y="287" text-anchor="middle" font-family="DM Mono" font-size="10" fill="#1a1a1a" font-weight="600">6</text>
            <text x="560" y="315" text-anchor="middle" font-family="DM Mono" font-size="9" fill="#1a1a1a; font-weight="600">Churn Predict</text>

            <!-- Store Operations Optimization (low-medium impact, high feasibility) - $1.2M -->
            <circle cx="630" cy="320" r="13" fill="#16a34a" opacity="0.12" stroke="#16a34a" stroke-width="2"/>
            <text x="630" y="327" text-anchor="middle" font-family="DM Mono" font-size="10" fill="#1a1a1a" font-weight="600">7</text>
            <text x="630" y="355" text-anchor="middle" font-family="DM Mono" font-size="9" fill="#1a1a1a; font-weight="600">Store Ops Opt</text>

            <!-- Marketing Mix Optimization (medium-high impact, low feasibility) - $2.6M -->
            <circle cx="280" cy="110" r="18" fill="#0066cc" opacity="0.3" stroke="#0066cc" stroke-width="2"/>
            <text x="280" y="117" text-anchor="middle" font-family="DM Mono" font-size="10" fill="#1a1a1a" font-weight="600">8</text>
            <text x="280" y="145" text-anchor="middle" font-family="DM Mono" font-size="9" fill="#1a1a1a; font-weight="600">Marketing Mix Opt</text>

            <!-- Customer Lifetime Value Prediction (medium impact, moderate feasibility) - $1.3M -->
            <circle cx="380" cy="300" r="13" fill="#16a34a" opacity="0.13" stroke="#16a34a" stroke-width="2"/>
            <text x="380" y="307" text-anchor="middle" font-family="DM Mono" font-size="10" fill="#1a1a1a" font-weight="600">9</text>
            <text x="380" y="335" text-anchor="middle" font-family="DM Mono" font-size="9" fill="#1a1a1a; font-weight="600">CLV Prediction</text>

            <!-- Anomaly Detection (low impact, high feasibility) - $0.8M -->
            <circle cx="680" cy="380" r="12" fill="#888" opacity="0.1" stroke="#888" stroke-width="2"/>
            <text x="680" y="387" text-anchor="middle" font-family="DM Mono" font-size="10" fill="#1a1a1a" font-weight="600">10</text>
            <text x="680" y="415" text-anchor="middle" font-family="DM Mono" font-size="9" fill="#1a1a1a; font-weight="600">Anomaly Detect</text>

            <!-- Generative AI for Customer Service (high impact, low feasibility) - $1.9M -->
            <circle cx="220" cy="200" r="15" fill="#0066cc" opacity="0.25" stroke="#0066cc" stroke-width="2"/>
            <text x="220" y="207" text-anchor="middle" font-family="DM Mono" font-size="10" fill="#1a1a1a" font-weight="600">11</text>
            <text x="220" y="240" text-anchor="middle" font-family="DM Mono" font-size="9" fill="#1a1a1a; font-weight="600">Gen AI Cust Svc</text>

            <!-- Predictive Maintenance (low-medium impact, medium feasibility) - $0.9M -->
            <circle cx="420" cy="380" r="12" fill="#888" opacity="0.1" stroke="#888" stroke-width="2"/>
            <text x="420" y="387" text-anchor="middle" font-family="DM Mono" font-size="10" fill="#1a1a1a" font-weight="600">12</text>
            <text x="420" y="415" text-anchor="middle" font-family="DM Mono" font-size="9" fill="#1a1a1a; font-weight="600">Pred Maintenance</text>
          </svg>

          <div style="margin-bottom: 20px;">
            <table class="dlv-table" style="width: 100%; font-size: 11px;">
              <thead>
                <tr style="background: #f9f9f9; border-bottom: 2px solid #ddd;">
                  <th style="text-align: left; padding: 8px; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 10px;">#</th>
                  <th style="text-align: left; padding: 8px; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 10px;">Use Case</th>
                  <th style="text-align: center; padding: 8px; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 10px;">Impact ($M)</th>
                  <th style="text-align: center; padding: 8px; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 10px;">Feasibility (1-5)</th>
                  <th style="text-align: center; padding: 8px; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 10px;">Priority</th>
                  <th style="text-align: left; padding: 8px; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 10px;">Recommendation</th>
                </tr>
              </thead>
              <tbody>
                <tr style="border-bottom: 1px solid #eee;">
                  <td style="padding: 8px; color: #FF6B2B; font-weight: 600;">1</td>
                  <td style="padding: 8px; color: #1a1a1a;">Dynamic Pricing Engine</td>
                  <td style="padding: 8px; text-align: center; color: #1a1a1a; font-weight: 600;">$3.2</td>
                  <td style="padding: 8px; text-align: center; color: #1a1a1a; font-weight: 600;">4.8</td>
                  <td style="padding: 8px; text-align: center;"><span class="dlv-status green">P0</span></td>
                  <td style="padding: 8px; color: #888;">Quick win. Launch weeks 8–16.</td>
                </tr>
                <tr style="border-bottom: 1px solid #eee;">
                  <td style="padding: 8px; color: #FF6B2B; font-weight: 600;">2</td>
                  <td style="padding: 8px; color: #1a1a1a;">Demand Forecasting</td>
                  <td style="padding: 8px; text-align: center; color: #1a1a1a; font-weight: 600;">$2.8</td>
                  <td style="padding: 8px; text-align: center; color: #1a1a1a; font-weight: 600;">3.6</td>
                  <td style="padding: 8px; text-align: center;"><span class="dlv-status green">P0</span></td>
                  <td style="padding: 8px; color: #888;">Strategic bet. Parallel data build.</td>
                </tr>
                <tr style="border-bottom: 1px solid #eee;">
                  <td style="padding: 8px; color: #FF6B2B; font-weight: 600;">3</td>
                  <td style="padding: 8px; color: #1a1a1a;">Inventory Optimization</td>
                  <td style="padding: 8px; text-align: center; color: #1a1a1a; font-weight: 600;">$2.1</td>
                  <td style="padding: 8px; text-align: center; color: #1a1a1a; font-weight: 600;">4.2</td>
                  <td style="padding: 8px; text-align: center;"><span class="dlv-status green">P1</span></td>
                  <td style="padding: 8px; color: #888;">Quick win. H1 phase 2.</td>
                </tr>
                <tr style="border-bottom: 1px solid #eee;">
                  <td style="padding: 8px; color: #FF6B2B; font-weight: 600;">4</td>
                  <td style="padding: 8px; color: #1a1a1a;">Personalization Engine</td>
                  <td style="padding: 8px; text-align: center; color: #1a1a1a; font-weight: 600;">$2.4</td>
                  <td style="padding: 8px; text-align: center; color: #1a1a1a; font-weight: 600;">3.8</td>
                  <td style="padding: 8px; text-align: center;"><span class="dlv-status orange">P1</span></td>
                  <td style="padding: 8px; color: #888;">Strategic. Requires CDP setup.</td>
                </tr>
                <tr style="border-bottom: 1px solid #eee;">
                  <td style="padding: 8px; color: #FF6B2B; font-weight: 600;">5</td>
                  <td style="padding: 8px; color: #1a1a1a;">Supply Chain Visibility</td>
                  <td style="padding: 8px; text-align: center; color: #1a1a1a; font-weight: 600;">$1.8</td>
                  <td style="padding: 8px; text-align: center; color: #1a1a1a; font-weight: 600;">3.4</td>
                  <td style="padding: 8px; text-align: center;"><span class="dlv-status orange">P2</span></td>
                  <td style="padding: 8px; color: #888;">Moonshot. Consider H2.</td>
                </tr>
                <tr style="border-bottom: 1px solid #eee;">
                  <td style="padding: 8px; color: #FF6B2B; font-weight: 600;">8</td>
                  <td style="padding: 8px; color: #1a1a1a;">Marketing Mix Optimization</td>
                  <td style="padding: 8px; text-align: center; color: #1a1a1a; font-weight: 600;">$2.6</td>
                  <td style="padding: 8px; text-align: center; color: #1a1a1a; font-weight: 600;">2.8</td>
                  <td style="padding: 8px; text-align: center;"><span class="dlv-status orange">P2</span></td>
                  <td style="padding: 8px; color: #888;">High value, complex. H2 start.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="dlv-doc-footer">
          <span style="font-size: 11px; color: #888;">Perceptya AI Value Discovery</span>
          <span style="font-size: 11px; color: #888;">Sheet: Use Case Prioritization</span>
        </div>
      </div>`,
},

'preview-usecase-business-cases': {
    title: 'Use Case Business Cases.pdf',
    body: `<div class="dlv-page">
        <div class="dlv-sanitized"><div class="dlv-sanitized-stripe">Sanitized client example</div></div>
        <div class="dlv-doc-header">
          <div class="dlv-doc-brand">PERCEPT<em>Y</em>A</div>
          <div class="dlv-doc-meta">
            <span>Use Case Business Case</span>
            <span>May 2024</span>
            <span class="dlv-doc-badge">Confidential</span>
          </div>
        </div>
        <div style="padding: 32px 24px; border-bottom: 1px solid #ddd;">
          <div class="dlv-doc-title">Dynamic Pricing Engine</div>
          <div class="dlv-doc-subtitle">Business Case | Financial & Operational Impact</div>
        </div>
        <div style="padding: 32px 24px; font-family: 'Urbanist', sans-serif; color: #1a1a1a; line-height: 1.7;">
          <div style="margin-bottom: 32px;">
            <h3 style="font-size: 13px; color: #888; text-transform: uppercase; letter-spacing: 0.12em; font-family: 'DM Mono', monospace; margin-bottom: 12px; font-weight: 600;">EXECUTIVE SUMMARY</h3>
            <p style="font-size: 14px; margin: 0;">Dynamic pricing powered by machine learning will optimize price points for ~50K SKUs across 240+ stores and e-commerce channels, capturing demand elasticity and competitive dynamics in real-time. Expected impact: $3.2M annual incremental revenue by month 18, driven by 2.1% average margin lift and reduced promotional waste.</p>
          </div>

          <div style="margin-bottom: 32px;">
            <h3 style="font-size: 13px; color: #888; text-transform: uppercase; letter-spacing: 0.12em; font-family: 'DM Mono', monospace; margin-bottom: 12px; font-weight: 600;">PROBLEM STATEMENT</h3>
            <p style="font-size: 14px; margin: 0;">Current pricing is static, set quarterly or seasonally. Competitors adjust prices dynamically in real-time. Perceptya's analysis shows margin recovery of $4.2M+ is achievable through AI-driven price optimization based on demand, inventory, seasonality, and competitive intelligence. Current promotional calendars are 40% inefficient.</p>
          </div>

          <div style="margin-bottom: 32px;">
            <h3 style="font-size: 13px; color: #888; text-transform: uppercase; letter-spacing: 0.12em; font-family: 'DM Mono', monospace; margin-bottom: 12px; font-weight: 600;">PROPOSED SOLUTION</h3>
            <p style="font-size: 14px; margin: 0 0 12px 0;"><strong>Technical approach:</strong> Build a real-time pricing engine integrating demand forecasts (from use case #2), inventory levels, competitive pricing feeds, and seasonality models. Deploy as a recommendation system with guardrails (min/max prices, brand rules), delivered to store & e-comm systems via API.</p>
            <p style="font-size: 14px; margin: 0;"><strong>Phased rollout:</strong> Weeks 8–10 (pilot 5 stores, 1K SKUs), Weeks 11–14 (expand to 50 stores, 10K SKUs), Weeks 15–20 (all stores + e-commerce, full catalog).</p>
          </div>

          <div style="margin-bottom: 32px;">
            <h3 style="font-size: 13px; color: #888; text-transform: uppercase; letter-spacing: 0.12em; font-family: 'DM Mono', monospace; margin-bottom: 12px; font-weight: 600;">EXPECTED IMPACT</h3>
            <table style="width: 100%; margin-bottom: 12px; border-collapse: collapse;">
              <tr style="border-bottom: 1px solid #eee;">
                <td style="padding: 10px; color: #1a1a1a; font-weight: 500;">Metric</td>
                <td style="padding: 10px; color: #1a1a1a; font-weight: 500;">Unit</td>
                <td style="padding: 10px; color: #1a1a1a; font-weight: 500;">Current</td>
                <td style="padding: 10px; color: #1a1a1a; font-weight: 500;">Projected (18 mo)</td>
                <td style="padding: 10px; color: #1a1a1a; font-weight: 500;">Impact</td>
              </tr>
              <tr style="border-bottom: 1px solid #eee;">
                <td style="padding: 10px; color: #1a1a1a;">Gross Margin %</td>
                <td style="padding: 10px; color: #888;">%</td>
                <td style="padding: 10px; color: #1a1a1a;">28.3%</td>
                <td style="padding: 10px; color: #16a34a; font-weight: 600;">30.4%</td>
                <td style="padding: 10px; color: #16a34a; font-weight: 600;">+2.1%</td>
              </tr>
              <tr style="border-bottom: 1px solid #eee;">
                <td style="padding: 10px; color: #1a1a1a;">Annual Revenue Lift</td>
                <td style="padding: 10px; color: #888;">$M</td>
                <td style="padding: 10px; color: #1a1a1a;">—</td>
                <td style="padding: 10px; color: #16a34a; font-weight: 600;">$3.2M</td>
                <td style="padding: 10px; color: #16a34a; font-weight: 600;">$3.2M</td>
              </tr>
              <tr style="border-bottom: 1px solid #eee;">
                <td style="padding: 10px; color: #1a1a1a;">Promotional Efficiency Gain</td>
                <td style="padding: 10px; color: #888;">%</td>
                <td style="padding: 10px; color: #1a1a1a;">60%</td>
                <td style="padding: 10px; color: #16a34a; font-weight: 600;">82%</td>
                <td style="padding: 10px; color: #16a34a; font-weight: 600;">+22%</td>
              </tr>
              <tr>
                <td style="padding: 10px; color: #1a1a1a;">Inventory Turnover Lift</td>
                <td style="padding: 10px; color: #888;">%</td>
                <td style="padding: 10px; color: #1a1a1a;">—</td>
                <td style="padding: 10px; color: #16a34a; font-weight: 600;">+8%</td>
                <td style="padding: 10px; color: #16a34a; font-weight: 600;">+8%</td>
              </tr>
            </table>
          </div>

          <div style="margin-bottom: 32px; padding: 16px; background: #fff5e6; border-left: 2px solid #FF6B2B; border-radius: 4px;">
            <div style="font-family: 'DM Mono', monospace; font-size: 11px; color: #FF6B2B; letter-spacing: 0.08em; text-transform: uppercase; margin-bottom: 8px; font-weight: 600;">FINANCIAL SUMMARY</div>
            <div style="display: grid; grid-template-columns: 1fr 1fr 1fr 1fr; gap: 16px; font-family: 'DM Mono', monospace; font-size: 13px;">
              <div>
                <div style="color: #888; font-size: 10px; margin-bottom: 4px;">INVESTMENT</div>
                <div style="color: #FF6B2B; font-weight: 600; font-size: 16px;">$180K</div>
              </div>
              <div>
                <div style="color: #888; font-size: 10px; margin-bottom: 4px;">ANNUAL RETURN</div>
                <div style="color: #16a34a; font-weight: 600; font-size: 16px;">$3.2M</div>
              </div>
              <div>
                <div style="color: #888; font-size: 10px; margin-bottom: 4px;">PAYBACK PERIOD</div>
                <div style="color: #1a1a1a; font-weight: 600; font-size: 16px;">3.2 weeks</div>
              </div>
              <div>
                <div style="color: #888; font-size: 10px; margin-bottom: 4px;">ROI (18mo)</div>
                <div style="color: #16a34a; font-weight: 600; font-size: 16px;">1680%</div>
              </div>
            </div>
          </div>

          <div style="margin-bottom: 32px;">
            <h3 style="font-size: 13px; color: #888; text-transform: uppercase; letter-spacing: 0.12em; font-family: 'DM Mono', monospace; margin-bottom: 12px; font-weight: 600;">IMPLEMENTATION TIMELINE</h3>
            <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 12px;">
              <div style="border: 1px solid #ddd; padding: 12px; border-radius: 4px;">
                <div style="font-size: 11px; color: #888; font-weight: 600; margin-bottom: 6px;">PHASE 1: PILOT</div>
                <div style="font-size: 12px; color: #1a1a1a; margin-bottom: 4px;">Duration: 3 weeks</div>
                <div style="font-size: 12px; color: #1a1a1a;">Scope: 5 pilot stores, 1K SKUs</div>
              </div>
              <div style="border: 1px solid #ddd; padding: 12px; border-radius: 4px;">
                <div style="font-size: 11px; color: #888; font-weight: 600; margin-bottom: 6px;">PHASE 2: SCALE</div>
                <div style="font-size: 12px; color: #1a1a1a; margin-bottom: 4px;">Duration: 4 weeks</div>
                <div style="font-size: 12px; color: #1a1a1a;">Scope: 50 stores, 10K SKUs</div>
              </div>
              <div style="border: 1px solid #ddd; padding: 12px; border-radius: 4px;">
                <div style="font-size: 11px; color: #888; font-weight: 600; margin-bottom: 6px;">PHASE 3: FULL ROLL</div>
                <div style="font-size: 12px; color: #1a1a1a; margin-bottom: 4px;">Duration: 6 weeks</div>
                <div style="font-size: 12px; color: #1a1a1a;">Scope: All stores + e-commerce</div>
              </div>
            </div>
          </div>

          <div style="margin-bottom: 32px;">
            <h3 style="font-size: 13px; color: #888; text-transform: uppercase; letter-spacing: 0.12em; font-family: 'DM Mono', monospace; margin-bottom: 12px; font-weight: 600;">RISK ASSESSMENT</h3>
            <div style="display: grid; gap: 10px; font-size: 13px;">
              <div>
                <strong style="color: #FF6B2B;">Brand erosion risk:</strong> <span style="color: #888;">Aggressive price drops could signal quality decline. Mitigation: Set brand-aware guardrails; maintain RRP in premium categories.</span>
              </div>
              <div>
                <strong style="color: #FF6B2B;">Data quality risk:</strong> <span style="color: #888;">Dirty competitive or inventory data will skew prices. Mitigation: Validate feeds; implement automated anomaly detection.</span>
              </div>
              <div>
                <strong style="color: #16a34a;">Adoption risk (Low):</strong> <span style="color: #888;">Store teams embrace revenue uplift. User training required but minimal resistance expected.</span>
              </div>
            </div>
          </div>

          <div>
            <h3 style="font-size: 13px; color: #888; text-transform: uppercase; letter-spacing: 0.12em; font-family: 'DM Mono', monospace; margin-bottom: 12px; font-weight: 600;">SUCCESS METRICS</h3>
            <p style="font-size: 13px; color: #1a1a1a; margin: 0; line-height: 1.6;">
              <strong>Primary:</strong> Revenue lift ≥$3M by month 18, Margin improvement ≥2%, Promotional efficiency ≥80%.<br/>
              <strong>Secondary:</strong> Inventory turnover +5%, Stock-out reduction to <2%, Customer willingness to pay uplift measurable via NPS.<br/>
              <strong>Operational:</strong> System uptime ≥99.5%, API latency <500ms, user adoption >90% by week 20.
            </p>
          </div>
        </div>
        <div class="dlv-doc-footer">
          <span style="font-size: 11px; color: #888;">Perceptya AI Value Discovery</span>
          <span style="font-size: 11px; color: #888;">Page 1 of 1</span>
        </div>
      </div>`,
},

'preview-quick-win-roadmap': {
    title: 'Quick Win Roadmap.pptx',
    body: `<div class="dlv-page" style="aspect-ratio: 16/9; display: flex; flex-direction: column; justify-content: space-between;">
        <div class="dlv-sanitized"><div class="dlv-sanitized-stripe">Sanitized client example</div></div>
        <div style="padding: 32px; flex: 1; display: flex; flex-direction: column;">
          <div class="dlv-doc-header" style="margin-bottom: 24px;">
            <div class="dlv-doc-brand">PERCEPT<em>Y</em>A</div>
            <div class="dlv-doc-meta">
              <span>Quick Wins Roadmap</span>
              <span>May 2024</span>
            </div>
          </div>

          <h2 style="font-size: 28px; color: #1a1a1a; margin: 0 0 24px 0; font-weight: 500;">3 Quick Wins — 12 Weeks to Impact</h2>

          <svg viewBox="0 0 900 280" style="width: 100%; margin-bottom: 24px;">
            <!-- Timeline background -->
            <rect x="60" y="40" width="840" height="180" fill="#f9f9f9" rx="4"/>

            <!-- Week markers -->
            <line x1="60" y1="220" x2="900" y2="220" stroke="#ddd" stroke-width="2"/>
            <text x="60" y="245" font-family="DM Mono" font-size="10" fill="#888">Week 1</text>
            <text x="258" y="245" font-family="DM Mono" font-size="10" fill="#888">Week 4</text>
            <text x="456" y="245" font-family="DM Mono" font-size="10" fill="#888">Week 8</text>
            <text x="654" y="245" font-family="DM Mono" font-size="10" fill="#888">Week 12</text>
            <text x="852" y="245" font-family="DM Mono" font-size="10" fill="#888">Week 16</text>

            <!-- Quick Win 1: Dynamic Pricing (Weeks 8–12) -->
            <rect x="480" y="60" width="150" height="40" fill="#16a34a" opacity="0.2" stroke="#16a34a" stroke-width="2" rx="4"/>
            <text x="555" y="78" text-anchor="middle" font-family="Urbanist" font-size="13" fill="#1a1a1a" font-weight="600">Dynamic Pricing</text>
            <text x="555" y="95" text-anchor="middle" font-family="DM Mono" font-size="10" fill="#16a34a" font-weight="600">$3.2M expected</text>
            <text x="555" y="110" text-anchor="middle" font-family="DM Mono" font-size="9" fill="#888">Owner: CMO</text>

            <!-- Quick Win 2: Inventory Optimization (Weeks 6–10) -->
            <rect x="360" y="130" width="140" height="40" fill="#0066cc" opacity="0.2" stroke="#0066cc" stroke-width="2" rx="4"/>
            <text x="430" y="148" text-anchor="middle" font-family="Urbanist" font-size="13" fill="#1a1a1a" font-weight="600">Inventory Opt</text>
            <text x="430" y="165" text-anchor="middle" font-family="DM Mono" font-size="10" fill="#0066cc" font-weight="600">$2.1M expected</text>
            <text x="430" y="180" text-anchor="middle" font-family="DM Mono" font-size="9" fill="#888">Owner: VP Supply</text>

            <!-- Quick Win 3: Churn Prediction (Weeks 10–14) -->
            <rect x="600" y="130" width="140" height="40" fill="#FF6B2B" opacity="0.2" stroke="#FF6B2B" stroke-width="2" rx="4"/>
            <text x="670" y="148" text-anchor="middle" font-family="Urbanist" font-size="13" fill="#1a1a1a" font-weight="600">Churn Predict</text>
            <text x="670" y="165" text-anchor="middle" font-family="DM Mono" font-size="10" fill="#FF6B2B" font-weight="600">$1.5M expected</text>
            <text x="670" y="180" text-anchor="middle" font-family="DM Mono" font-size="9" fill="#888">Owner: Chief CRM</text>

            <!-- Milestones -->
            <circle cx="480" cy="40" r="6" fill="#16a34a"/>
            <circle cx="540" cy="60" r="6" fill="#16a34a"/>
            <circle cx="630" cy="60" r="6" fill="#16a34a"/>

            <circle cx="360" cy="110" r="6" fill="#0066cc"/>
            <circle cx="440" cy="130" r="6" fill="#0066cc"/>
            <circle cx="500" cy="130" r="6" fill="#0066cc"/>

            <circle cx="600" cy="110" r="6" fill="#FF6B2B"/>
            <circle cx="680" cy="130" r="6" fill="#FF6B2B"/>
            <circle cx="740" cy="130" r="6" fill="#FF6B2B"/>
          </svg>

          <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 16px; margin-top: auto;">
            <div style="border: 1px solid #ddd; padding: 12px; border-radius: 4px;">
              <div style="font-family: 'DM Mono', monospace; font-size: 10px; color: #16a34a; font-weight: 600; margin-bottom: 4px;">TOTAL VALUE</div>
              <div style="font-size: 24px; color: #1a1a1a; font-weight: 600;">$6.8M</div>
              <div style="font-family: 'DM Mono', monospace; font-size: 10px; color: #888;">Over 18 months</div>
            </div>
            <div style="border: 1px solid #ddd; padding: 12px; border-radius: 4px;">
              <div style="font-family: 'DM Mono', monospace; font-size: 10px; color: #0066cc; font-weight: 600; margin-bottom: 4px;">COMPLETION</div>
              <div style="font-size: 24px; color: #1a1a1a; font-weight: 600;">Week 14</div>
              <div style="font-family: 'DM Mono', monospace; font-size: 10px; color: #888;">All 3 wins live</div>
            </div>
            <div style="border: 1px solid #ddd; padding: 12px; border-radius: 4px;">
              <div style="font-family: 'DM Mono', monospace; font-size: 10px; color: #FF6B2B; font-weight: 600; margin-bottom: 4px;">TEAM ALLOCATION</div>
              <div style="font-size: 24px; color: #1a1a1a; font-weight: 600;">12 FTE</div>
              <div style="font-family: 'DM Mono', monospace; font-size: 10px; color: #888;">Cross-functional</div>
            </div>
          </div>
        </div>
      </div>`,
},

'preview-architecture-blueprint': {
    title: 'Architecture Blueprint.pdf',
    body: `<div class="dlv-page">
        <div class="dlv-sanitized"><div class="dlv-sanitized-stripe">Sanitized client example</div></div>
        <div class="dlv-doc-header">
          <div class="dlv-doc-brand">PERCEPT<em>Y</em>A</div>
          <div class="dlv-doc-meta">
            <span>Architecture Blueprint</span>
            <span>June 2024</span>
            <span class="dlv-doc-badge">Confidential</span>
          </div>
        </div>
        <div style="padding: 24px; border-bottom: 1px solid #ddd;">
          <div class="dlv-doc-title">Target AI Architecture</div>
          <div class="dlv-doc-subtitle">18–36 month modernization roadmap</div>
        </div>
        <div style="padding: 24px;">
          <svg viewBox="0 0 800 600" style="width: 100%; display: block; margin-bottom: 24px;">
            <!-- Layer labels -->
            <text x="20" y="120" font-family="DM Mono" font-size="10" fill="#888" font-weight="600">DATA SOURCES</text>
            <text x="20" y="190" font-family="DM Mono" font-size="10" fill="#888" font-weight="600">INGESTION</text>
            <text x="20" y="260" font-family="DM Mono" font-size="10" fill="#888" font-weight="600">STORAGE</text>
            <text x="20" y="340" font-family="DM Mono" font-size="10" fill="#888" font-weight="600">PROCESSING</text>
            <text x="20" y="420" font-family="DM Mono" font-size="10" fill="#888" font-weight="600">ML/AI LAYER</text>
            <text x="20" y="500" font-family="DM Mono" font-size="10" fill="#888" font-weight="600">AGENTS</text>
            <text x="20" y="570" font-family="DM Mono" font-size="10" fill="#888" font-weight="600">APPLICATIONS</text>

            <!-- Data Sources Layer -->
            <rect x="100" y="100" width="120" height="40" fill="#FF6B2B" opacity="0.15" stroke="#FF6B2B" stroke-width="1" rx="3"/>
            <text x="160" y="130" text-anchor="middle" font-family="Urbanist" font-size="11" fill="#1a1a1a" font-weight="600">ERP</text>

            <rect x="250" y="100" width="120" height="40" fill="#FF6B2B" opacity="0.15" stroke="#FF6B2B" stroke-width="1" rx="3"/>
            <text x="310" y="130" text-anchor="middle" font-family="Urbanist" font-size="11" fill="#1a1a1a" font-weight="600">POS</text>

            <rect x="400" y="100" width="120" height="40" fill="#FF6B2B" opacity="0.15" stroke="#FF6B2B" stroke-width="1" rx="3"/>
            <text x="460" y="130" text-anchor="middle" font-family="Urbanist" font-size="11" fill="#1a1a1a" font-weight="600">CRM</text>

            <rect x="550" y="100" width="120" height="40" fill="#FF6B2B" opacity="0.15" stroke="#FF6B2B" stroke-width="1" rx="3"/>
            <text x="610" y="130" text-anchor="middle" font-family="Urbanist" font-size="11" fill="#1a1a1a" font-weight="600">E-commerce</text>

            <!-- Arrows down from sources -->
            <line x1="160" y1="140" x2="160" y2="170" stroke="#FF6B2B" stroke-width="1.5" marker-end="url(#arrowhead)"/>
            <line x1="310" y1="140" x2="310" y2="170" stroke="#FF6B2B" stroke-width="1.5"/>
            <line x1="460" y1="140" x2="460" y2="170" stroke="#FF6B2B" stroke-width="1.5"/>
            <line x1="610" y1="140" x2="610" y2="170" stroke="#FF6B2B" stroke-width="1.5"/>

            <!-- Ingestion Layer -->
            <rect x="100" y="170" width="85" height="35" fill="#0066cc" opacity="0.15" stroke="#0066cc" stroke-width="1" rx="3"/>
            <text x="142.5" y="193" text-anchor="middle" font-family="DM Mono" font-size="9" fill="#1a1a1a" font-weight="600">Kafka</text>

            <rect x="217" y="170" width="85" height="35" fill="#0066cc" opacity="0.15" stroke="#0066cc" stroke-width="1" rx="3"/>
            <text x="259.5" y="193" text-anchor="middle" font-family="DM Mono" font-size="9" fill="#1a1a1a" font-weight="600">APIs</text>

            <rect x="334" y="170" width="85" height="35" fill="#0066cc" opacity="0.15" stroke="#0066cc" stroke-width="1" rx="3"/>
            <text x="376.5" y="193" text-anchor="middle" font-family="DM Mono" font-size="9" fill="#1a1a1a" font-weight="600">CDC</text>

            <rect x="451" y="170" width="85" height="35" fill="#0066cc" opacity="0.15" stroke="#0066cc" stroke-width="1" rx="3"/>
            <text x="493.5" y="193" text-anchor="middle" font-family="DM Mono" font-size="9" fill="#1a1a1a; font-weight="600">Stream</text>

            <rect x="568" y="170" width="85" height="35" fill="#0066cc" opacity="0.15" stroke="#0066cc" stroke-width="1" rx="3"/>
            <text x="610.5" y="193" text-anchor="middle" font-family="DM Mono" font-size="9" fill="#1a1a1a; font-weight="600">Batch</text>

            <!-- Arrows down to storage -->
            <line x1="310" y1="205" x2="310" y2="240" stroke="#0066cc" stroke-width="1.5"/>

            <!-- Storage Layer (Lakehouse) -->
            <rect x="100" y="240" width="420" height="50" fill="#16a34a" opacity="0.15" stroke="#16a34a" stroke-width="2" rx="3"/>
            <text x="160" y="255" font-family="DM Mono" font-size="10" fill="#1a1a1a; font-weight="600">BRONZE</text>
            <text x="310" y="255" font-family="DM Mono" font-size="10" fill="#1a1a1a; font-weight="600">SILVER</text>
            <text x="420" y="255" font-family="DM Mono" font-size="10" fill="#1a1a1a; font-weight="600">GOLD</text>
            <text x="310" y="280" text-anchor="middle" font-family="Urbanist" font-size="9" fill="#1a1a1a;">Data Lake (S3 / Delta Lake)</text>
            <line x1="165" y1="240" x2="165" y2="290"/>
            <line x1="310" y1="240" x2="310" y2="290"/>
            <line x1="415" y1="240" x2="415" y2="290"/>

            <!-- Processing Layer -->
            <rect x="100" y="320" width="100" height="35" fill="#8b5cf6" opacity="0.15" stroke="#8b5cf6" stroke-width="1" rx="3"/>
            <text x="150" y="343" text-anchor="middle" font-family="DM Mono" font-size="9" fill="#1a1a1a; font-weight="600">Spark</text>

            <rect x="230" y="320" width="100" height="35" fill="#8b5cf6" opacity="0.15" stroke="#8b5cf6" stroke-width="1" rx="3"/>
            <text x="280" y="343" text-anchor="middle" font-family="DM Mono" font-size="9" fill="#1a1a1a; font-weight="600">dbt</text>

            <rect x="360" y="320" width="100" height="35" fill="#8b5cf6" opacity="0.15" stroke="#8b5cf6" stroke-width="1" rx="3"/>
            <text x="410" y="343" text-anchor="middle" font-family="DM Mono" font-size="9" fill="#1a1a1a; font-weight="600">SQL</text>

            <!-- Arrows down -->
            <line x1="280" y1="290" x2="280" y2="320" stroke="#16a34a" stroke-width="1.5"/>

            <!-- ML/AI Layer -->
            <rect x="100" y="400" width="95" height="35" fill="#FF6B2B" opacity="0.15" stroke="#FF6B2B" stroke-width="1" rx="3"/>
            <text x="147.5" y="423" text-anchor="middle" font-family="DM Mono" font-size="9" fill="#1a1a1a; font-weight="600">Feature Store</text>

            <rect x="225" y="400" width="95" height="35" fill="#FF6B2B" opacity="0.15" stroke="#FF6B2B" stroke-width="1" rx="3"/>
            <text x="272.5" y="423" text-anchor="middle" font-family="DM Mono" font-size="9" fill="#1a1a1a; font-weight="600">Model Registry</text>

            <rect x="350" y="400" width="95" height="35" fill="#FF6B2B" opacity="0.15" stroke="#FF6B2B" stroke-width="1" rx="3"/>
            <text x="397.5" y="423" text-anchor="middle" font-family="DM Mono" font-size="9" fill="#1a1a1a; font-weight="600">Model Serving</text>

            <!-- Arrows down -->
            <line x1="280" y1="355" x2="280" y2="400" stroke="#8b5cf6" stroke-width="1.5"/>

            <!-- Agent Layer -->
            <rect x="100" y="480" width="100" height="35" fill="#0066cc" opacity="0.15" stroke="#0066cc" stroke-width="1" rx="3"/>
            <text x="150" y="503" text-anchor="middle" font-family="DM Mono" font-size="9" fill="#1a1a1a; font-weight="600">Orchestrator</text>

            <rect x="230" y="480" width="100" height="35" fill="#0066cc" opacity="0.15" stroke="#0066cc" stroke-width="1" rx="3"/>
            <text x="280" y="503" text-anchor="middle" font-family="DM Mono" font-size="9" fill="#1a1a1a; font-weight="600">AI Agents</text>

            <rect x="360" y="480" width="100" height="35" fill="#0066cc" opacity="0.15" stroke="#0066cc" stroke-width="1" rx="3"/>
            <text x="410" y="503" text-anchor="middle" font-family="DM Mono" font-size="9" fill="#1a1a1a; font-weight="600">Guardrails</text>

            <!-- Arrows down -->
            <line x1="280" y1="435" x2="280" y2="480" stroke="#FF6B2B" stroke-width="1.5"/>

            <!-- Applications -->
            <rect x="100" y="550" width="70" height="30" fill="#16a34a" opacity="0.15" stroke="#16a34a" stroke-width="1" rx="3"/>
            <text x="135" y="570" text-anchor="middle" font-family="DM Mono" font-size="8" fill="#1a1a1a; font-weight="600">APIs</text>

            <rect x="200" y="550" width="70" height="30" fill="#16a34a" opacity="0.15" stroke="#16a34a" stroke-width="1" rx="3"/>
            <text x="235" y="570" text-anchor="middle" font-family="DM Mono" font-size="8" fill="#1a1a1a; font-weight="600">Dashboards</text>

            <rect x="300" y="550" width="70" height="30" fill="#16a34a" opacity="0.15" stroke="#16a34a" stroke-width="1" rx="3"/>
            <text x="335" y="570" text-anchor="middle" font-family="DM Mono" font-size="8" fill="#1a1a1a; font-weight="600">Mobile Apps</text>

            <rect x="400" y="550" width="70" height="30" fill="#16a34a" opacity="0.15" stroke="#16a34a" stroke-width="1" rx="3"/>
            <text x="435" y="570" text-anchor="middle" font-family="DM Mono" font-size="8" fill="#1a1a1a; font-weight="600">Integrations</text>

            <!-- Arrow definitions -->
            <defs>
              <marker id="arrowhead" markerWidth="10" markerHeight="10" refX="9" refY="3" orient="auto">
                <polygon points="0 0, 10 3, 0 6" fill="#FF6B2B"/>
              </marker>
            </defs>

            <!-- Arrows up from agents -->
            <line x1="280" y1="515" x2="280" y2="550" stroke="#0066cc" stroke-width="1.5"/>
          </svg>

          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 16px; font-size: 12px;">
            <div>
              <h4 style="font-family: 'DM Mono', monospace; font-size: 11px; color: #888; margin: 0 0 8px 0; text-transform: uppercase; font-weight: 600;">H1: FOUNDATION</h4>
              <ul style="margin: 0; padding-left: 16px; color: #1a1a1a;">
                <li>Cloud migration (AWS) + IAM</li>
                <li>Data ingestion pipelines (Kafka + APIs)</li>
                <li>Lakehouse setup (Bronze/Silver/Gold)</li>
                <li>dbt + Spark for processing</li>
              </ul>
            </div>
            <div>
              <h4 style="font-family: 'DM Mono', monospace; font-size: 11px; color: #888; margin: 0 0 8px 0; text-transform: uppercase; font-weight: 600;">H2–H3: SCALE</h4>
              <ul style="margin: 0; padding-left: 16px; color: #1a1a1a;">
                <li>Feature store + model registry</li>
                <li>First 3 ML models to production</li>
                <li>Agent orchestration framework</li>
                <li>API + dashboard layer for apps</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="dlv-doc-footer">
          <span style="font-size: 11px; color: #888;">Perceptya AI Value Discovery</span>
          <span style="font-size: 11px; color: #888;">Page 1 of 1</span>
        </div>
      </div>`,
},

'preview-financial-impact': {
    title: 'Financial Impact Model.xlsx',
    body: `<div class="dlv-page">
        <div class="dlv-sanitized"><div class="dlv-sanitized-stripe">Sanitized client example</div></div>
        <div class="dlv-doc-header">
          <div class="dlv-doc-brand">PERCEPT<em>Y</em>A</div>
          <div class="dlv-doc-meta">
            <span>Financial Impact Model</span>
            <span>June 2024</span>
            <span class="dlv-doc-badge">Confidential</span>
          </div>
        </div>
        <div style="padding: 24px; border-bottom: 1px solid #ddd;">
          <div class="dlv-doc-title">3-Year Financial Projection</div>
          <div class="dlv-doc-subtitle">Investment vs. Return Analysis | ROI & NPV</div>
        </div>
        <div style="padding: 16px 24px; overflow-x: auto;">
          <table class="dlv-table" style="width: 100%; font-size: 11px; border-collapse: collapse;">
            <thead>
              <tr style="background: #f9f9f9; border-bottom: 2px solid #ddd;">
                <th style="text-align: left; padding: 8px; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 10px; min-width: 150px;">Use Case / Component</th>
                <th style="text-align: right; padding: 8px; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 10px;">Y1 Invest</th>
                <th style="text-align: right; padding: 8px; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 10px;">Y1 Return</th>
                <th style="text-align: right; padding: 8px; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 10px;">Y2 Invest</th>
                <th style="text-align: right; padding: 8px; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 10px;">Y2 Return</th>
                <th style="text-align: right; padding: 8px; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 10px;">Y3 Invest</th>
                <th style="text-align: right; padding: 8px; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 10px;">Y3 Return</th>
                <th style="text-align: right; padding: 8px; color: #1a1a1a; font-weight: 600; font-family: 'DM Mono', monospace; font-size: 10px;">Cum ROI</th>
              </tr>
            </thead>
            <tbody>
              <tr style="border-bottom: 1px solid #eee;">
                <td style="padding: 8px; color: #1a1a1a; font-weight: 500;">Dynamic Pricing</td>
                <td style="padding: 8px; text-align: right; color: #1a1a1a;">$180K</td>
                <td style="padding: 8px; text-align: right; color: #16a34a; font-weight: 600;">$3.2M</td>
                <td style="padding: 8px; text-align: right; color: #1a1a1a;">$80K</td>
                <td style="padding: 8px; text-align: right; color: #16a34a; font-weight: 600;">$3.8M</td>
                <td style="padding: 8px; text-align: right; color: #1a1a1a;">$60K</td>
                <td style="padding: 8px; text-align: right; color: #16a34a; font-weight: 600;">$4.2M</td>
                <td style="padding: 8px; text-align: right; color: #16a34a; font-weight: 600;">2,180%</td>
              </tr>
              <tr style="border-bottom: 1px solid #eee;">
                <td style="padding: 8px; color: #1a1a1a; font-weight: 500;">Demand Forecasting</td>
                <td style="padding: 8px; text-align: right; color: #1a1a1a;">$240K</td>
                <td style="padding: 8px; text-align: right; color: #16a34a; font-weight: 600;">$2.8M</td>
                <td style="padding: 8px; text-align: right; color: #1a1a1a;">$120K</td>
                <td style="padding: 8px; text-align: right; color: #16a34a; font-weight: 600;">$3.1M</td>
                <td style="padding: 8px; text-align: right; color: #1a1a1a;">$100K</td>
                <td style="padding: 8px; text-align: right; color: #16a34a; font-weight: 600;">$3.4M</td>
                <td style="padding: 8px; text-align: right; color: #16a34a; font-weight: 600;">1,150%</td>
              </tr>
              <tr style="border-bottom: 1px solid #eee;">
                <td style="padding: 8px; color: #1a1a1a; font-weight: 500;">Inventory Optimization</td>
                <td style="padding: 8px; text-align: right; color: #1a1a1a;">$160K</td>
                <td style="padding: 8px; text-align: right; color: #16a34a; font-weight: 600;">$2.1M</td>
                <td style="padding: 8px; text-align: right; color: #1a1a1a;">$70K</td>
                <td style="padding: 8px; text-align: right; color: #16a34a; font-weight: 600;">$2.4M</td>
                <td style="padding: 8px; text-align: right; color: #1a1a1a;">$50K</td>
                <td style="padding: 8px; text-align: right; color: #16a34a; font-weight: 600;">$2.6M</td>
                <td style="padding: 8px; text-align: right; color: #16a34a; font-weight: 600;">1,255%</td>
              </tr>
              <tr style="border-bottom: 1px solid #eee;">
                <td style="padding: 8px; color: #1a1a1a; font-weight: 500;">Personalization Engine</td>
                <td style="padding: 8px; text-align: right; color: #1a1a1a;">$280K</td>
                <td style="padding: 8px; text-align: right; color: #16a34a; font-weight: 600;">$1.2M</td>
                <td style="padding: 8px; text-align: right; color: #1a1a1a;">$150K</td>
                <td style="padding: 8px; text-align: right; color: #16a34a; font-weight: 600;">$2.4M</td>
                <td style="padding: 8px; text-align: right; color: #1a1a1a;">$100K</td>
                <td style="padding: 8px; text-align: right; color: #16a34a; font-weight: 600;">$2.4M</td>
                <td style="padding: 8px; text-align: right; color: #16a34a; font-weight: 600;">670%</td>
              </tr>
              <tr style="border-bottom: 1px solid #eee;">
                <td style="padding: 8px; color: #1a1a1a; font-weight: 500;">Churn Prediction</td>
                <td style="padding: 8px; text-align: right; color: #1a1a1a;">$200K</td>
                <td style="padding: 8px; text-align: right; color: #16a34a; font-weight: 600;">$1.5M</td>
                <td style="padding: 8px; text-align: right; color: #1a1a1a;">$100K</td>
                <td style="padding: 8px; text-align: right; color: #16a34a; font-weight: 600;">$1.8M</td>
                <td style="padding: 8px; text-align: right; color: #1a1a1a;">$80K</td>
                <td style="padding: 8px; text-align: right; color: #16a34a; font-weight: 600;">$1.9M</td>
                <td style="padding: 8px; text-align: right; color: #16a34a; font-weight: 600;">620%</td>
              </tr>
              <tr style="border-bottom: 1px solid #eee;">
                <td style="padding: 8px; color: #1a1a1a; font-weight: 500;">Other Use Cases (3)</td>
                <td style="padding: 8px; text-align: right; color: #1a1a1a;">$420K</td>
                <td style="padding: 8px; text-align: right; color: #16a34a; font-weight: 600;">$1.8M</td>
                <td style="padding: 8px; text-align: right; color: #1a1a1a;">$200K</td>
                <td style="padding: 8px; text-align: right; color: #16a34a; font-weight: 600;">$2.1M</td>
                <td style="padding: 8px; text-align: right; color: #1a1a1a;">$180K</td>
                <td style="padding: 8px; text-align: right; color: #16a34a; font-weight: 600;">$2.4M</td>
                <td style="padding: 8px; text-align: right; color: #16a34a; font-weight: 600;">520%</td>
              </tr>
              <tr style="border-bottom: 1px solid #eee;">
                <td style="padding: 8px; color: #1a1a1a; font-weight: 500;">Data Foundation (Lakehouse)</td>
                <td style="padding: 8px; text-align: right; color: #1a1a1a;">$380K</td>
                <td style="padding: 8px; text-align: right; color: #16a34a; font-weight: 600;">$400K</td>
                <td style="padding: 8px; text-align: right; color: #1a1a1a;">$200K</td>
                <td style="padding: 8px; text-align: right; color: #16a34a; font-weight: 600;">$800K</td>
                <td style="padding: 8px; text-align: right; color: #1a1a1a;">$150K</td>
                <td style="padding: 8px; text-align: right; color: #16a34a; font-weight: 600;">$1.0M</td>
                <td style="padding: 8px; text-align: right; color: #16a34a; font-weight: 600;">260%</td>
              </tr>
              <tr style="border-bottom: 1px solid #eee;">
                <td style="padding: 8px; color: #1a1a1a; font-weight: 500;">Governance & CoE</td>
                <td style="padding: 8px; text-align: right; color: #1a1a1a;">$320K</td>
                <td style="padding: 8px; text-align: right; color: #16a34a; font-weight: 600;">$0</td>
                <td style="padding: 8px; text-align: right; color: #1a1a1a;">$200K</td>
                <td style="padding: 8px; text-align: right; color: #16a34a; font-weight: 600;">$200K</td>
                <td style="padding: 8px; text-align: right; color: #1a1a1a;">$200K</td>
                <td style="padding: 8px; text-align: right; color: #16a34a; font-weight: 600;">$300K</td>
                <td style="padding: 8px; text-align: right; color: #888;">N/A</td>
              </tr>
              <tr style="background: #f9f9f9; border-top: 2px solid #ddd; font-weight: 600;">
                <td style="padding: 8px; color: #1a1a1a;">TOTAL CUMULATIVE</td>
                <td style="padding: 8px; text-align: right; color: #FF6B2B;">$2.18M</td>
                <td style="padding: 8px; text-align: right; color: #16a34a;">$12.8M</td>
                <td style="padding: 8px; text-align: right; color: #FF6B2B;">$1.04M</td>
                <td style="padding: 8px; text-align: right; color: #16a34a;">$15.6M</td>
                <td style="padding: 8px; text-align: right; color: #FF6B2B;">$0.92M</td>
                <td style="padding: 8px; text-align: right; color: #16a34a;">$17.9M</td>
                <td style="padding: 8px; text-align: right; color: #16a34a; font-weight: 600;">625%</td>
              </tr>
            </tbody>
          </table>

          <div style="margin-top: 24px;">
            <svg viewBox="0 0 700 300" style="width: 100%; display: block;">
              <!-- Axes -->
              <line x1="60" y1="250" x2="660" y2="250" stroke="#1a1a1a" stroke-width="2"/>
              <line x1="60" y1="250" x2="60" y2="30" stroke="#1a1a1a" stroke-width="2"/>

              <!-- Grid -->
              <line x1="60" y1="150" x2="660" y2="150" stroke="#eee" stroke-width="1" stroke-dasharray="2,2"/>

              <!-- Labels -->
              <text x="350" y="290" text-anchor="middle" font-family="DM Mono" font-size="11" fill="#1a1a1a" font-weight="600">Months</text>
              <text x="30" y="140" text-anchor="middle" font-family="DM Mono" font-size="11" fill="#1a1a1a" font-weight="600" transform="rotate(-90 30 140)">Cumulative $</text>

              <!-- Investment line (red) -->
              <polyline points="60,240 140,230 220,215 300,205 380,195 460,185 540,178 620,172" fill="none" stroke="#FF6B2B" stroke-width="2.5"/>

              <!-- Return line (green) -->
              <polyline points="60,248 140,210 220,160 300,110 380,85 460,60 540,50 620,48" fill="none" stroke="#16a34a" stroke-width="2.5"/>

              <!-- Breakeven point -->
              <circle cx="220" cy="175" r="4" fill="#FF6B2B"/>
              <text x="220" y="195" text-anchor="middle" font-family="DM Mono" font-size="9" fill="#FF6B2B" font-weight="600">Breakeven</text>
              <text x="220" y="210" text-anchor="middle" font-family="DM Mono" font-size="8" fill="#888;">Month 7</text>

              <!-- Legend -->
              <line x1="480" y1="40" x2="520" y2="40" stroke="#FF6B2B" stroke-width="2.5"/>
              <text x="530" y="45" font-family="DM Mono" font-size="10" fill="#FF6B2B" font-weight="600">Cumulative Investment</text>

              <line x1="480" y1="65" x2="520" y2="65" stroke="#16a34a" stroke-width="2.5"/>
              <text x="530" y="70" font-family="DM Mono" font-size="10" fill="#16a34a" font-weight="600">Cumulative Return</text>
            </svg>
          </div>

          <div style="margin-top: 20px; padding: 12px; background: #f9f9f9; border-radius: 4px; font-size: 12px;">
            <strong style="color: #1a1a1a;">Key Metrics:</strong> Cum. Investment: $4.14M | Cum. Return: $46.3M | NPV (10% discount): $18.6M | Payback: Month 7 | 3-Year ROI: 625%
          </div>
        </div>
        <div class="dlv-doc-footer">
          <span style="font-size: 11px; color: #888;">Perceptya AI Value Discovery</span>
          <span style="font-size: 11px; color: #888;">Sheet: 3-Year Financial Model</span>
        </div>
      </div>`,
},

'preview-18month-roadmap': {
    title: '18-Month Roadmap.pptx',
    body: `<div class="dlv-page" style="aspect-ratio: 16/9; display: flex; flex-direction: column;">
        <div class="dlv-sanitized"><div class="dlv-sanitized-stripe">Sanitized client example</div></div>
        <div style="padding: 28px; flex: 1; display: flex; flex-direction: column; justify-content: space-between;">
          <div class="dlv-doc-header" style="margin-bottom: 20px;">
            <div class="dlv-doc-brand">PERCEPT<em>Y</em>A</div>
            <div class="dlv-doc-meta">
              <span>18-Month Roadmap</span>
              <span>June 2024</span>
            </div>
          </div>

          <h2 style="font-size: 26px; color: #1a1a1a; margin: 0 0 20px 0; font-weight: 500;">AI Value Realization: H1 · H2 · H3</h2>

          <svg viewBox="0 0 950 350" style="width: 100%; display: block; margin-bottom: 20px;">
            <!-- Horizons background -->
            <rect x="50" y="40" width="280" height="250" fill="#16a34a" opacity="0.1" rx="4"/>
            <rect x="350" y="40" width="280" height="250" fill="#0066cc" opacity="0.1" rx="4"/>
            <rect x="650" y="40" width="280" height="250" fill="#FF6B2B" opacity="0.1" rx="4"/>

            <!-- Horizon labels -->
            <text x="190" y="25" text-anchor="middle" font-family="Urbanist" font-size="14" fill="#16a34a" font-weight="600">H1: FOUNDATION</text>
            <text x="190" y="42" text-anchor="middle" font-family="DM Mono" font-size="9" fill="#888;">(Months 1–6)</text>

            <text x="490" y="25" text-anchor="middle" font-family="Urbanist" font-size="14" fill="#0066cc" font-weight="600">H2: SCALE</text>
            <text x="490" y="42" text-anchor="middle" font-family="DM Mono" font-size="9" fill="#888;">(Months 7–12)</text>

            <text x="790" y="25" text-anchor="middle" font-family="Urbanist" font-size="14" fill="#FF6B2B" font-weight="600">H3: OPTIMIZE</text>
            <text x="790" y="42" text-anchor="middle" font-family="DM Mono" font-size="9" fill="#888;">(Months 13–18)</text>

            <!-- Swim lanes -->
            <!-- Data Foundation -->
            <text x="60" y="80" font-family="DM Mono" font-size="10" fill="#888; font-weight="600;">Data Foundation</text>
            <rect x="50" y="85" width="880" height="45" fill="none" stroke="#eee" stroke-width="1"/>

            <rect x="60" y="92" width="260" height="30" fill="#16a34a" opacity="0.3" stroke="#16a34a" stroke-width="2" rx="2"/>
            <text x="190" y="112" text-anchor="middle" font-family="DM Mono" font-size="9" fill="#1a1a1a; font-weight="600;">Cloud + Lakehouse</text>

            <rect x="360" y="92" width="260" height="30" fill="#16a34a" opacity="0.2" stroke="#16a34a" stroke-width="1" rx="2"/>
            <text x="490" y="112" text-anchor="middle" font-family="DM Mono" font-size="8" fill="#1a1a1a;">Governance + CoE</text>

            <rect x="660" y="92" width="260" height="30" fill="#16a34a" opacity="0.15" stroke="#16a34a" stroke-width="1" rx="2"/>
            <text x="790" y="112" text-anchor="middle" font-family="DM Mono" font-size="8" fill="#888;">Optimization</text>

            <!-- Use Cases -->
            <text x="60" y="155" font-family="DM Mono" font-size="10" fill="#888; font-weight="600;">Use Cases</text>
            <rect x="50" y="160" width="880" height="45" fill="none" stroke="#eee" stroke-width="1"/>

            <rect x="60" y="167" width="130" height="30" fill="#0066cc" opacity="0.25" stroke="#0066cc" stroke-width="2" rx="2"/>
            <text x="125" y="187" text-anchor="middle" font-family="DM Mono" font-size="8" fill="#1a1a1a; font-weight="600;">Dynamic Pricing</text>

            <rect x="200" y="167" width="120" height="30" fill="#0066cc" opacity="0.2" stroke="#0066cc" stroke-width="2" rx="2"/>
            <text x="260" y="187" text-anchor="middle" font-family="DM Mono" font-size="8" fill="#1a1a1a;">Inventory</text>

            <rect x="360" y="167" width="130" height="30" fill="#0066cc" opacity="0.25" stroke="#0066cc" stroke-width="2" rx="2"/>
            <text x="425" y="187" text-anchor="middle" font-family="DM Mono" font-size="8" fill="#1a1a1a; font-weight="600;">Demand Forecast</text>

            <rect x="510" y="167" width="100" height="30" fill="#0066cc" opacity="0.2" stroke="#0066cc" stroke-width="1" rx="2"/>
            <text x="560" y="187" text-anchor="middle" font-family="DM Mono" font-size="8" fill="#1a1a1a;">Personalization</text>

            <rect x="660" y="167" width="120" height="30" fill="#0066cc" opacity="0.15" stroke="#0066cc" stroke-width="1" rx="2"/>
            <text x="720" y="187" text-anchor="middle" font-family="DM Mono" font-size="8" fill="#888;">Churn Predict</text>

            <rect x="820" y="167" width="110" height="30" fill="#0066cc" opacity="0.15" stroke="#0066cc" stroke-width="1" rx="2"/>
            <text x="875" y="187" text-anchor="middle" font-family="DM Mono" font-size="8" fill="#888;">+ 2 More</text>

            <!-- Agents -->
            <text x="60" y="230" font-family="DM Mono" font-size="10" fill="#888; font-weight="600;">Agent Architecture</text>
            <rect x="50" y="235" width="880" height="45" fill="none" stroke="#eee" stroke-width="1"/>

            <rect x="360" y="242" width="260" height="30" fill="#FF6B2B" opacity="0.25" stroke="#FF6B2B" stroke-width="2" rx="2"/>
            <text x="490" y="262" text-anchor="middle" font-family="DM Mono" font-size="9" fill="#1a1a1a; font-weight="600;">Orchestrator + Agents</text>

            <rect x="660" y="242" width="260" height="30" fill="#FF6B2B" opacity="0.2" stroke="#FF6B2B" stroke-width="1" rx="2"/>
            <text x="790" y="262" text-anchor="middle" font-family="DM Mono" font-size="8" fill="#1a1a1a;">LLM Integration</text>

            <!-- Governance -->
            <text x="60" y="305" font-family="DM Mono" font-size="10" fill="#888; font-weight="600;">Governance</text>
            <rect x="50" y="310" width="880" height="45" fill="none" stroke="#eee" stroke-width="1"/>

            <rect x="60" y="317" width="260" height="30" fill="#8b5cf6" opacity="0.2" stroke="#8b5cf6" stroke-width="2" rx="2"/>
            <text x="190" y="337" text-anchor="middle" font-family="DM Mono" font-size="8" fill="#1a1a1a;">Frameworks + Policies</text>

            <rect x="360" y="317" width="260" height="30" fill="#8b5cf6" opacity="0.2" stroke="#8b5cf6" stroke-width="2" rx="2"/>
            <text x="490" y="337" text-anchor="middle" font-family="DM Mono" font-size="8" fill="#1a1a1a;">Model Audit + Guardrails</text>

            <rect x="660" y="317" width="260" height="30" fill="#8b5cf6" opacity="0.15" stroke="#8b5cf6" stroke-width="1" rx="2"/>
            <text x="790" y="337" text-anchor="middle" font-family="DM Mono" font-size="8" fill="#888;">Continuous Compliance</text>

            <!-- Milestones -->
            <circle cx="190" cy="55" r="5" fill="#16a34a"/>
            <circle cx="490" cy="55" r="5" fill="#0066cc"/>
            <circle cx="790" cy="55" r="5" fill="#FF6B2B"/>
          </svg>

          <div style="display: grid; grid-template-columns: 1fr 1fr 1fr 1fr; gap: 12px; font-size: 11px;">
            <div style="border: 1px solid #16a34a; padding: 8px; border-radius: 3px; text-align: center;">
              <div style="font-weight: 600; color: #16a34a; margin-bottom: 2px;">Data Readiness</div>
              <div style="color: #888; font-size: 9px;">Complete in H1</div>
            </div>
            <div style="border: 1px solid #0066cc; padding: 8px; border-radius: 3px; text-align: center;">
              <div style="font-weight: 600; color: #0066cc; margin-bottom: 2px;">3 Core Use Cases</div>
              <div style="color: #888; font-size: 9px;">Live by end H2</div>
            </div>
            <div style="border: 1px solid #FF6B2B; padding: 8px; border-radius: 3px; text-align: center;">
              <div style="font-weight: 600; color: #FF6B2B; margin-bottom: 2px;">Agent Deployment</div>
              <div style="color: #888; font-size: 9px;">H2 pilot, H3 scale</div>
            </div>
            <div style="border: 1px solid #8b5cf6; padding: 8px; border-radius: 3px; text-align: center;">
              <div style="font-weight: 600; color: #8b5cf6; margin-bottom: 2px;">Value Realization</div>
              <div style="color: #888; font-size: 9px;">$6.8M by month 14</div>
            </div>
          </div>
        </div>
      </div>`,
},

'preview-lakehouse-architecture': {
    title: 'lakehouse-architecture.pdf',
    body: `<div class="dlv-page">
        <div class="dlv-sanitized"><div class="dlv-sanitized-stripe">Sanitized client example</div></div>

        <div class="dlv-doc-header">
          <div class="dlv-doc-brand">PERCEPT<em>Y</em>A</div>
          <div class="dlv-doc-meta">
            <div class="dlv-doc-badge">Confidential</div>
            <div class="dlv-doc-meta-text">September 2024</div>
          </div>
        </div>

        <h1 class="dlv-doc-title">Lakehouse Architecture Blueprint</h1>
        <p class="dlv-doc-subtitle">Data Foundation Modernization — Module A</p>

        <div class="dlv-arch-section">
          <div class="dlv-arch-title">Modern Lakehouse for Financial Services</div>
          <svg viewBox="0 0 700 320" style="width: 100%; height: auto; background: rgba(255,255,255,0.02);">
            <!-- Data Sources Layer -->
            <g>
              <rect x="10" y="10" width="100" height="45" fill="rgba(255,107,43,0.1)" stroke="#FF6B2B" stroke-width="1.5" rx="3"/>
              <text x="60" y="42" font-size="11" font-weight="500" text-anchor="middle" fill="#fff">Core Banking</text>
            </g>
            <g>
              <rect x="120" y="10" width="100" height="45" fill="rgba(255,107,43,0.1)" stroke="#FF6B2B" stroke-width="1.5" rx="3"/>
              <text x="170" y="42" font-size="11" font-weight="500" text-anchor="middle" fill="#fff">CRM</text>
            </g>
            <g>
              <rect x="230" y="10" width="100" height="45" fill="rgba(255,107,43,0.1)" stroke="#FF6B2B" stroke-width="1.5" rx="3"/>
              <text x="280" y="42" font-size="11" font-weight="500" text-anchor="middle" fill="#fff">Market Data</text>
            </g>
            <g>
              <rect x="340" y="10" width="100" height="45" fill="rgba(255,107,43,0.1)" stroke="#FF6B2B" stroke-width="1.5" rx="3"/>
              <text x="390" y="42" font-size="11" font-weight="500" text-anchor="middle" fill="#fff">Regulatory</text>
            </g>
            <g>
              <rect x="450" y="10" width="100" height="45" fill="rgba(255,107,43,0.1)" stroke="#FF6B2B" stroke-width="1.5" rx="3"/>
              <text x="500" y="42" font-size="11" font-weight="500" text-anchor="middle" fill="#fff">Transactions</text>
            </g>

            <!-- Ingestion Layer -->
            <g>
              <rect x="10" y="80" width="85" height="40" fill="rgba(22,163,74,0.1)" stroke="#16a34a" stroke-width="1.5" rx="3"/>
              <text x="52.5" y="108" font-size="10" font-weight="500" text-anchor="middle" fill="#fff">Kafka</text>
            </g>
            <g>
              <rect x="105" y="80" width="85" height="40" fill="rgba(22,163,74,0.1)" stroke="#16a34a" stroke-width="1.5" rx="3"/>
              <text x="147.5" y="108" font-size="10" font-weight="500" text-anchor="middle" fill="#fff">CDC</text>
            </g>
            <g>
              <rect x="200" y="80" width="100" height="40" fill="rgba(22,163,74,0.1)" stroke="#16a34a" stroke-width="1.5" rx="3"/>
              <text x="250" y="108" font-size="10" font-weight="500" text-anchor="middle" fill="#fff">API Gateway</text>
            </g>

            <!-- Lakehouse Layers -->
            <g>
              <rect x="20" y="150" width="110" height="50" fill="rgba(30,30,30,0.8)" stroke="rgba(255,255,255,0.15)" stroke-width="1.5" rx="3"/>
              <text x="75" y="170" font-size="11" font-weight="500" text-anchor="middle" fill="#fff">Bronze</text>
              <text x="75" y="185" font-size="9" text-anchor="middle" fill="#888">Raw Data</text>
            </g>
            <g>
              <rect x="145" y="150" width="110" height="50" fill="rgba(30,30,30,0.8)" stroke="rgba(255,255,255,0.15)" stroke-width="1.5" rx="3"/>
              <text x="200" y="170" font-size="11" font-weight="500" text-anchor="middle" fill="#fff">Silver</text>
              <text x="200" y="185" font-size="9" text-anchor="middle" fill="#888">Cleaned</text>
            </g>
            <g>
              <rect x="270" y="150" width="110" height="50" fill="rgba(30,30,30,0.8)" stroke="rgba(255,255,255,0.15)" stroke-width="1.5" rx="3"/>
              <text x="325" y="170" font-size="11" font-weight="500" text-anchor="middle" fill="#fff">Gold</text>
              <text x="325" y="185" font-size="9" text-anchor="middle" fill="#888">Business-Ready</text>
            </g>

            <!-- Consumption Layer -->
            <g>
              <rect x="20" y="230" width="80" height="40" fill="rgba(255,107,43,0.1)" stroke="#FF6B2B" stroke-width="1.5" rx="3"/>
              <text x="60" y="258" font-size="10" font-weight="500" text-anchor="middle" fill="#fff">Feature Store</text>
            </g>
            <g>
              <rect x="110" y="230" width="80" height="40" fill="rgba(255,107,43,0.1)" stroke="#FF6B2B" stroke-width="1.5" rx="3"/>
              <text x="150" y="258" font-size="10" font-weight="500" text-anchor="middle" fill="#fff">BI/Analytics</text>
            </g>
            <g>
              <rect x="200" y="230" width="80" height="40" fill="rgba(255,107,43,0.1)" stroke="#FF6B2B" stroke-width="1.5" rx="3"/>
              <text x="240" y="258" font-size="10" font-weight="500" text-anchor="middle" fill="#fff">AI/ML</text>
            </g>
            <g>
              <rect x="290" y="230" width="80" height="40" fill="rgba(255,107,43,0.1)" stroke="#FF6B2B" stroke-width="1.5" rx="3"/>
              <text x="330" y="258" font-size="10" font-weight="500" text-anchor="middle" fill="#fff">Reporting</text>
            </g>

            <!-- Support Components -->
            <g>
              <rect x="410" y="150" width="95" height="40" fill="rgba(255,107,43,0.08)" stroke="rgba(255,107,43,0.3)" stroke-width="1" rx="3"/>
              <text x="457.5" y="165" font-size="10" font-weight="500" text-anchor="middle" fill="#FF6B2B">Data Catalog</text>
              <text x="457.5" y="180" font-size="8" text-anchor="middle" fill="#888">Lineage &amp; Metadata</text>
            </g>
            <g>
              <rect x="520" y="150" width="95" height="40" fill="rgba(22,163,74,0.08)" stroke="rgba(22,163,74,0.3)" stroke-width="1" rx="3"/>
              <text x="567.5" y="165" font-size="10" font-weight="500" text-anchor="middle" fill="#16a34a">Quality Engine</text>
              <text x="567.5" y="180" font-size="8" text-anchor="middle" fill="#888">Validation &amp; Monitoring</text>
            </g>
            <g>
              <rect x="630" y="150" width="60" height="40" fill="rgba(107,114,128,0.08)" stroke="rgba(107,114,128,0.3)" stroke-width="1" rx="3"/>
              <text x="660" y="165" font-size="9" font-weight="500" text-anchor="middle" fill="#aaa">Access</text>
              <text x="660" y="178" font-size="8" text-anchor="middle" fill="#888">Control</text>
            </g>
          </svg>
        </div>

        <h2 class="dlv-section-title">Key Design Principles</h2>
        <p style="font-size: 13px; color: #ddd; line-height: 1.6; margin-bottom: 16px;">
          <strong style="color: #fff;">Bronze Layer:</strong> Raw, unaltered data ingested from all sources with full lineage tracking.<br>
          <strong style="color: #fff;">Silver Layer:</strong> Cleaned, deduplicated, conformed data with data quality gates and reconciliation.<br>
          <strong style="color: #fff;">Gold Layer:</strong> Business-ready tables, aggregations, and feature sets optimized for consumption by AI/ML, BI, and reporting systems.
        </p>

        <h2 class="dlv-section-title">Governance & Monitoring</h2>
        <table class="dlv-table">
          <thead>
            <tr>
              <th>Component</th>
              <th>Purpose</th>
              <th>Technology</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Data Catalog</strong></td>
              <td>Centralized metadata, lineage, and search across all assets</td>
              <td class="num">Apache Atlas / Custom</td>
            </tr>
            <tr>
              <td><strong>Quality Engine</strong></td>
              <td>Automated data quality checks, anomaly detection, SLA monitoring</td>
              <td class="num">Great Expectations</td>
            </tr>
            <tr>
              <td><strong>Access Control</strong></td>
              <td>Role-based access, PII masking, encryption at rest &amp; in transit</td>
              <td class="num">Apache Ranger / Cloud IAM</td>
            </tr>
          </tbody>
        </table>

        <div class="dlv-doc-footer">
          <span>PERCEPT<em>Y</em>A — Data Foundation Modernization</span>
          <span>Page 1 of 1</span>
        </div>
      </div>`,
},

'preview-data-catalog': {
    title: 'data-catalog-ui.platform',
    body: `<div class="dlv-page">
        <div class="dlv-sanitized"><div class="dlv-sanitized-stripe">Sanitized client example</div></div>

        <div class="dlv-doc-header">
          <div class="dlv-doc-brand">PERCEPT<em>Y</em>A</div>
          <div class="dlv-doc-meta">
            <div class="dlv-doc-badge">Platform Demo</div>
            <div class="dlv-doc-meta-text">Data Catalog</div>
          </div>
        </div>

        <h1 class="dlv-doc-title">Data Catalog Platform</h1>
        <p class="dlv-doc-subtitle">Live Asset Registry & Governance Dashboard</p>

        <table class="dlv-table">
          <thead>
            <tr>
              <th>Asset Name</th>
              <th>Schema</th>
              <th>Owner</th>
              <th>Classification</th>
              <th>Quality Score</th>
              <th>Last Updated</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>customer_profiles</strong></td>
              <td class="num">47 cols</td>
              <td>Data Eng Team</td>
              <td><span class="uc-tag">PII</span> <span class="uc-tag">Critical</span></td>
              <td><span class="positive">98.7%</span></td>
              <td class="num">2m ago</td>
            </tr>
            <tr>
              <td><strong>transaction_history</strong></td>
              <td class="num">23 cols</td>
              <td>Finance Analytics</td>
              <td><span class="uc-tag">Critical</span> <span class="uc-tag">Governed</span></td>
              <td><span class="positive">99.2%</span></td>
              <td class="num">5m ago</td>
            </tr>
            <tr>
              <td><strong>credit_risk_scores</strong></td>
              <td class="num">15 cols</td>
              <td>Risk Analytics</td>
              <td><span class="uc-tag">ML Output</span> <span class="uc-tag">Governed</span></td>
              <td><span class="positive">97.4%</span></td>
              <td class="num">8m ago</td>
            </tr>
            <tr>
              <td><strong>market_positions</strong></td>
              <td class="num">31 cols</td>
              <td>Trading Desk</td>
              <td><span class="uc-tag">Critical</span></td>
              <td><span class="positive">96.8%</span></td>
              <td class="num">12m ago</td>
            </tr>
            <tr>
              <td><strong>regulatory_reports</strong></td>
              <td class="num">18 cols</td>
              <td>Compliance</td>
              <td><span class="uc-tag">Audit Trail</span> <span class="uc-tag">Governed</span></td>
              <td><span class="positive">99.9%</span></td>
              <td class="num">1h ago</td>
            </tr>
            <tr>
              <td><strong>customer_segment_features</strong></td>
              <td class="num">#26 cols</td>
              <td>Data Science</td>
              <td><span class="uc-tag">Feature Store</span></td>
              <td><span class="positive">98.1%</span></td>
              <td class="num">3m ago</td>
            </tr>
            <tr>
              <td><strong>branch_performance_kpis</strong></td>
              <td class="num">12 cols</td>
              <td>Operations</td>
              <td><span class="uc-tag">Dashboard</span></td>
              <td><span class="positive">97.9%</span></td>
              <td class="num">15m ago</td>
            </tr>
            <tr>
              <td><strong>loan_origination_pipeline</strong></td>
              <td class="num">34 cols</td>
              <td>Lending Platform</td>
              <td><span class="uc-tag">ML Input</span> <span class="uc-tag">PII</span></td>
              <td><span class="positive">98.3%</span></td>
              <td class="num">7m ago</td>
            </tr>
            <tr>
              <td><strong>fx_rate_cache</strong></td>
              <td class="num">8 cols</td>
              <td>Treasury</td>
              <td><span class="uc-tag">Real-time</span></td>
              <td><span class="positive">99.8%</span></td>
              <td class="num">1m ago</td>
            </tr>
            <tr>
              <td><strong>fraud_detection_features</strong></td>
              <td class="num">42 cols</td>
              <td>AML/Fraud Team</td>
              <td><span class="uc-tag">ML Output</span> <span class="uc-tag">Governed</span></td>
              <td><span class="positive">99.1%</span></td>
              <td class="num">4m ago</td>
            </tr>
          </tbody>
        </table>

        <div class="dlv-doc-footer">
          <span>PERCEPT<em>Y</em>A — Data Catalog</span>
          <span>10 Assets Indexed • 98.7% Avg Quality</span>
        </div>
      </div>`,
},

'preview-pipeline-monitoring': {
    title: 'pipeline-monitoring-dashboard.live',
    body: `<div class="dlv-page">
        <div class="dlv-sanitized"><div class="dlv-sanitized-stripe">Sanitized client example</div></div>

        <div class="dlv-doc-header">
          <div class="dlv-doc-brand">PERCEPT<em>Y</em>A</div>
          <div class="dlv-doc-meta">
            <div class="dlv-doc-badge">Live</div>
            <div class="dlv-doc-meta-text">Now</div>
          </div>
        </div>

        <h1 class="dlv-doc-title">Pipeline Monitoring Dashboard</h1>
        <p class="dlv-doc-subtitle">Data Integration & Processing Health</p>

        <div class="dlv-kpi-row">
          <div class="dlv-kpi">
            <div class="dlv-kpi-value accent">47</div>
            <div class="dlv-kpi-label">Pipelines Active</div>
            <div class="dlv-kpi-delta">+3 this week</div>
          </div>
          <div class="dlv-kpi">
            <div class="dlv-kpi-value positive">98.2%</div>
            <div class="dlv-kpi-label">Success Rate</div>
            <div class="dlv-kpi-delta">↑ 0.4% vs last week</div>
          </div>
          <div class="dlv-kpi">
            <div class="dlv-kpi-value">2.3s</div>
            <div class="dlv-kpi-label">Avg Latency</div>
            <div class="dlv-kpi-delta negative">↑ 200ms (P95: 8.1s)</div>
          </div>
          <div class="dlv-kpi">
            <div class="dlv-kpi-value positive">12m</div>
            <div class="dlv-kpi-label">Data Freshness</div>
            <div class="dlv-kpi-delta">Max acceptable: 1h</div>
          </div>
        </div>

        <h2 class="dlv-section-title">30-Day Success Trend</h2>
        <div class="dlv-chart">
          <svg viewBox="0 0 650 200" style="width: 100%; height: auto;">
            <defs>
              <linearGradient id="successGrad" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" style="stop-color:#16a34a;stop-opacity:0.3" />
                <stop offset="100%" style="stop-color:#16a34a;stop-opacity:0.05" />
              </linearGradient>
            </defs>
            <polyline points="20,50 48,48 76,52 104,46 132,44 160,49 188,45 216,51 244,47 272,42 300,40 328,45 356,43 384,48 412,46 440,44 468,50 496,48 524,52 552,49 580,44 608,46" fill="none" stroke="#16a34a" stroke-width="2.5"/>
            <polygon points="20,50 48,48 76,52 104,46 132,44 160,49 188,45 216,51 244,47 272,42 300,40 328,45 356,43 384,48 412,46 440,44 468,50 496,48 524,52 552,49 580,44 608,46 608,180 20,180" fill="url(#successGrad)"/>
            <line x1="20" y1="180" x2="608" y2="180" stroke="rgba(255,255,255,0.1)" stroke-width="1"/>
            <text x="620" y="50" font-size="10" fill="#16a34a" font-weight="500">98.2%</text>
          </svg>
        </div>

        <h2 class="dlv-section-title">Recent Pipeline Runs</h2>
        <table class="dlv-table">
          <thead>
            <tr>
              <th>Pipeline Name</th>
              <th>Status</th>
              <th>Duration</th>
              <th>Records Processed</th>
              <th>Last Run</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>core_banking_ingest</strong></td>
              <td><span class="dlv-status green">Success</span></td>
              <td class="num">18.4s</td>
              <td class="positive">2.1M</td>
              <td class="num">2m ago</td>
            </tr>
            <tr>
              <td><strong>crm_data_sync</strong></td>
              <td><span class="dlv-status green">Success</span></td>
              <td class="num">45.2s</td>
              <td class="positive">840K</td>
              <td class="num">5m ago</td>
            </tr>
            <tr>
              <td><strong>market_data_feed</strong></td>
              <td><span class="dlv-status green">Running</span></td>
              <td class="num">3.1s</td>
              <td class="positive">156K</td>
              <td class="num">Now</td>
            </tr>
            <tr>
              <td><strong>customer_aggregation</strong></td>
              <td><span class="dlv-status green">Success</span></td>
              <td class="num">92.8s</td>
              <td class="positive">3.2M</td>
              <td class="num">12m ago</td>
            </tr>
            <tr>
              <td><strong>feature_store_refresh</strong></td>
              <td><span class="dlv-status green">Success</span></td>
              <td class="num">127.3s</td>
              <td class="positive">5.6M</td>
              <td class="num">28m ago</td>
            </tr>
          </tbody>
        </table>

        <div class="dlv-doc-footer">
          <span>PERCEPT<em>Y</em>A — Pipeline Monitoring</span>
          <span>Last updated: 2 minutes ago</span>
        </div>
      </div>`,
},

'preview-model-performance': {
    title: 'model-performance-dashboard.live',
    body: `<div class="dlv-page">
        <div class="dlv-sanitized"><div class="dlv-sanitized-stripe">Sanitized client example</div></div>

        <div class="dlv-doc-header">
          <div class="dlv-doc-brand">PERCEPT<em>Y</em>A</div>
          <div class="dlv-doc-meta">
            <div class="dlv-doc-badge">Live</div>
            <div class="dlv-doc-meta-text">ML Ops</div>
          </div>
        </div>

        <h1 class="dlv-doc-title">Model Performance Dashboard</h1>
        <p class="dlv-doc-subtitle">Logistics ML Models — Production Monitoring</p>

        <div class="dlv-kpi-row">
          <div class="dlv-kpi">
            <div class="dlv-kpi-value accent">5</div>
            <div class="dlv-kpi-label">Models in Production</div>
            <div class="dlv-kpi-delta">All healthy</div>
          </div>
          <div class="dlv-kpi">
            <div class="dlv-kpi-value positive">94.2%</div>
            <div class="dlv-kpi-label">Avg Accuracy</div>
            <div class="dlv-kpi-delta">↑ 2.1% vs baseline</div>
          </div>
          <div class="dlv-kpi">
            <div class="dlv-kpi-value">1.2M</div>
            <div class="dlv-kpi-label">Predictions/Day</div>
            <div class="dlv-kpi-delta">↑ 18% week-over-week</div>
          </div>
          <div class="dlv-kpi">
            <div class="dlv-kpi-value accent">2</div>
            <div class="dlv-kpi-label">Drift Alerts</div>
            <div class="dlv-kpi-delta">Route Opt, ETA</div>
          </div>
        </div>

        <h2 class="dlv-section-title">Model Accuracy — Last 90 Days</h2>
        <div class="dlv-chart">
          <svg viewBox="0 0 650 220" style="width: 100%; height: auto;">
            <defs>
              <linearGradient id="acc1" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" style="stop-color:#FF6B2B;stop-opacity:0.25" />
                <stop offset="100%" style="stop-color:#FF6B2B;stop-opacity:0.05" />
              </linearGradient>
            </defs>
            <!-- Route Optimization (orange) -->
            <polyline points="20,80 70,78 120,82 170,76 220,74 270,79 320,75 370,72 420,78 470,76 520,80 570,77 620,81" fill="none" stroke="#FF6B2B" stroke-width="2.5"/>
            <polygon points="20,80 70,78 120,82 170,76 220,74 270,79 320,75 370,72 420,78 470,76 520,80 570,77 620,81 620,200 20,200" fill="url(#acc1)" opacity="0.3"/>

            <!-- Demand Forecast (green, higher) -->
            <polyline points="20,45 70,48 120,44 170,50 220,46 270,44 320,48 370,42 420,45 470,49 520,46 570,44 620,47" fill="none" stroke="#16a34a" stroke-width="2.5"/>

            <!-- ETA Prediction (light, lower) -->
            <polyline points="20,120 70,122 120,118 170,125 220,120 270,119 320,123 370,117 420,121 470,124 520,120 570,118 620,123" fill="none" stroke="#888" stroke-width="2" stroke-dasharray="4,2"/>

            <line x1="20" y1="200" x2="620" y2="200" stroke="rgba(255,255,255,0.1)" stroke-width="1"/>
            <text x="630" y="48" font-size="9" fill="#16a34a">Demand</text>
            <text x="630" y="82" font-size="9" fill="#FF6B2B">Route</text>
            <text x="630" y="123" font-size="9" fill="#888">ETA</text>
          </svg>
        </div>

        <h2 class="dlv-section-title">Production Models</h2>
        <table class="dlv-table">
          <thead>
            <tr>
              <th>Model Name</th>
              <th>Version</th>
              <th>Accuracy</th>
              <th>Latency (ms)</th>
              <th>Predictions/Day</th>
              <th>Status</th>
              <th>Last Retrained</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Route Optimization</strong></td>
              <td class="num">v2.1.4</td>
              <td class="positive">95.2%</td>
              <td class="num">142</td>
              <td class="positive">280K</td>
              <td><span class="dlv-status green">Active</span></td>
              <td class="num">2 days ago</td>
            </tr>
            <tr>
              <td><strong>Demand Forecast</strong></td>
              <td class="num">v1.8.2</td>
              <td class="positive">93.8%</td>
              <td class="num">89</td>
              <td class="positive">160K</td>
              <td><span class="dlv-status green">Active</span></td>
              <td class="num">5 days ago</td>
            </tr>
            <tr>
              <td><strong>ETA Prediction</strong></td>
              <td class="num">v3.0.1</td>
              <td class="positive">94.1%</td>
              <td class="num">178</td>
              <td class="positive">420K</td>
              <td><span class="dlv-status orange">Drift Alert</span></td>
              <td class="num">12 days ago</td>
            </tr>
            <tr>
              <td><strong>Warehouse Allocation</strong></td>
              <td class="num">v1.5.3</td>
              <td class="positive">92.9%</td>
              <td class="num">156</td>
              <td class="positive">215K</td>
              <td><span class="dlv-status green">Active</span></td>
              <td class="num">8 days ago</td>
            </tr>
            <tr>
              <td><strong>Anomaly Detection</strong></td>
              <td class="num">v2.3.0</td>
              <td class="positive">96.4%</td>
              <td class="num">67</td>
              <td class="positive">125K</td>
              <td><span class="dlv-status orange">Drift Alert</span></td>
              <td class="num">3 days ago</td>
            </tr>
          </tbody>
        </table>

        <div class="dlv-doc-footer">
          <span>PERCEPT<em>Y</em>A — Model Performance</span>
          <span>Last updated: 3 minutes ago</span>
        </div>
      </div>`,
},

'preview-mlops-pipeline': {
    title: 'mlops-pipeline-architecture.pdf',
    body: `<div class="dlv-page">
        <div class="dlv-sanitized"><div class="dlv-sanitized-stripe">Sanitized client example</div></div>

        <div class="dlv-doc-header">
          <div class="dlv-doc-brand">PERCEPT<em>Y</em>A</div>
          <div class="dlv-doc-meta">
            <div class="dlv-doc-badge">Confidential</div>
            <div class="dlv-doc-meta-text">February 2025</div>
          </div>
        </div>

        <h1 class="dlv-doc-title">MLOps Pipeline Architecture</h1>
        <p class="dlv-doc-subtitle">Priority Use Case Implementation — Module B</p>

        <div class="dlv-arch-section">
          <div class="dlv-arch-title">ML Continuous Deployment Flow</div>
          <svg viewBox="0 0 700 160" style="width: 100%; height: auto;">
            <!-- Data Prep -->
            <g>
              <rect x="10" y="40" width="90" height="50" fill="rgba(22,163,74,0.1)" stroke="#16a34a" stroke-width="1.5" rx="3"/>
              <text x="55" y="62" font-size="11" font-weight="500" text-anchor="middle" fill="#fff">Data Prep</text>
              <text x="55" y="78" font-size="9" text-anchor="middle" fill="#888">ETL</text>
            </g>
            <line x1="100" y1="65" x2="120" y2="65" stroke="#888" stroke-width="1.5"/>
            <text x="110" y="60" font-size="8" fill="#888">raw</text>

            <!-- Feature Engineering -->
            <g>
              <rect x="120" y="40" width="90" height="50" fill="rgba(22,163,74,0.1)" stroke="#16a34a" stroke-width="1.5" rx="3"/>
              <text x="165" y="62" font-size="11" font-weight="500" text-anchor="middle" fill="#fff">Feature Eng</text>
              <text x="165" y="78" font-size="9" text-anchor="middle" fill="#888">Vectors</text>
            </g>
            <line x1="210" y1="65" x2="230" y2="65" stroke="#888" stroke-width="1.5"/>
            <text x="220" y="60" font-size="8" fill="#888">feats</text>

            <!-- Training -->
            <g>
              <rect x="230" y="40" width="90" height="50" fill="rgba(255,107,43,0.1)" stroke="#FF6B2B" stroke-width="1.5" rx="3"/>
              <text x="275" y="62" font-size="11" font-weight="500" text-anchor="middle" fill="#fff">Training</text>
              <text x="275" y="78" font-size="9" text-anchor="middle" fill="#888">Tuning</text>
            </g>
            <line x1="320" y1="65" x2="340" y2="65" stroke="#888" stroke-width="1.5"/>
            <text x="330" y="60" font-size="8" fill="#888">model</text>

            <!-- Validation -->
            <g>
              <rect x="340" y="40" width="90" height="50" fill="rgba(255,107,43,0.1)" stroke="#FF6B2B" stroke-width="1.5" rx="3"/>
              <text x="385" y="62" font-size="11" font-weight="500" text-anchor="middle" fill="#fff">Validation</text>
              <text x="385" y="78" font-size="9" text-anchor="middle" fill="#888">Test Set</text>
            </g>
            <line x1="430" y1="65" x2="450" y2="65" stroke="#888" stroke-width="1.5"/>
            <text x="440" y="60" font-size="8" fill="#888">metrics</text>

            <!-- Registry -->
            <g>
              <rect x="450" y="40" width="90" height="50" fill="rgba(107,114,128,0.1)" stroke="rgba(107,114,128,0.5)" stroke-width="1.5" rx="3"/>
              <text x="495" y="62" font-size="11" font-weight="500" text-anchor="middle" fill="#fff">Registry</text>
              <text x="495" y="78" font-size="9" text-anchor="middle" fill="#888">Version</text>
            </g>
            <line x1="540" y1="65" x2="560" y2="65" stroke="#888" stroke-width="1.5"/>
            <text x="550" y="60" font-size="8" fill="#888">approved</text>

            <!-- Deployment -->
            <g>
              <rect x="560" y="40" width="90" height="50" fill="rgba(22,163,74,0.1)" stroke="#16a34a" stroke-width="1.5" rx="3"/>
              <text x="605" y="62" font-size="11" font-weight="500" text-anchor="middle" fill="#fff">Deployment</text>
              <text x="605" y="78" font-size="9" text-anchor="middle" fill="#888">Prod</text>
            </g>

            <!-- Monitoring Loop -->
            <path d="M 605 90 L 605 110 L 275 110 L 275 90" fill="none" stroke="#FF6B2B" stroke-width="2" stroke-dasharray="4,2" marker-end="url(#arrowhead)"/>
            <text x="440" y="125" font-size="10" fill="#FF6B2B" font-weight="500" text-anchor="middle">Monitoring & Retrain Loop</text>
          </svg>
        </div>

        <h2 class="dlv-section-title">CI/CD Pipeline Stages</h2>
        <table class="dlv-table">
          <thead>
            <tr>
              <th>Stage</th>
              <th>Trigger</th>
              <th>SLA</th>
              <th>Owner</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Code Commit</strong></td>
              <td class="num">Git push to branch</td>
              <td class="num">Immediate</td>
              <td>ML Engineers</td>
            </tr>
            <tr>
              <td><strong>Unit Tests</strong></td>
              <td class="num">Auto on commit</td>
              <td class="num">5 min</td>
              <td>ML Engineers</td>
            </tr>
            <tr>
              <td><strong>Feature Build</strong></td>
              <td class="num">Test pass</td>
              <td class="num">15 min</td>
              <td>Data Eng</td>
            </tr>
            <tr>
              <td><strong>Model Training</strong></td>
              <td class="num">Feature ready</td>
              <td class="num">60 min</td>
              <td>ML Ops</td>
            </tr>
            <tr>
              <td><strong>Validation &amp; Approval</strong></td>
              <td class="num">Training done</td>
              <td class="num">30 min</td>
              <td>Data Science Lead</td>
            </tr>
            <tr>
              <td><strong>Staging Deploy</strong></td>
              <td class="num">Approved</td>
              <td class="num">10 min</td>
              <td>ML Ops</td>
            </tr>
            <tr>
              <td><strong>Production Deploy</strong></td>
              <td class="num">Manual OR schedule</td>
              <td class="num">5 min</td>
              <td>ML Ops / Platform</td>
            </tr>
          </tbody>
        </table>

        <h2 class="dlv-section-title">Model Governance & Approval</h2>
        <p style="font-size: 13px; color: #ddd; line-height: 1.6; margin-bottom: 12px;">
          <strong style="color: #fff;">Approval Gates:</strong> A/B testing protocol requires 2-week shadow period in production before full rollout. Rollback procedures enable instant model revert if drift exceeds SLA. All model versions tracked in ML Registry with full lineage and data versioning.
        </p>

        <div class="dlv-doc-footer">
          <span>PERCEPT<em>Y</em>A — MLOps Pipeline</span>
          <span>Page 1 of 2</span>
        </div>
      </div>`,
},

'preview-adoption-playbook': {
    title: 'adoption-playbook.pdf',
    body: `<div class="dlv-page">
        <div class="dlv-sanitized"><div class="dlv-sanitized-stripe">Sanitized client example</div></div>

        <div class="dlv-doc-header">
          <div class="dlv-doc-brand">PERCEPT<em>Y</em>A</div>
          <div class="dlv-doc-meta">
            <div class="dlv-doc-badge">Confidential</div>
            <div class="dlv-doc-meta-text">March 2025</div>
          </div>
        </div>

        <h1 class="dlv-doc-title">AI Use Case Adoption Playbook</h1>
        <p class="dlv-doc-subtitle">Change Management & User Enablement — Module B</p>

        <h2 class="dlv-section-title">Stakeholder Influence & Impact Map</h2>
        <div class="dlv-chart">
          <svg viewBox="0 0 600 280" style="width: 100%; height: auto;">
            <!-- Quadrant lines -->
            <line x1="300" y1="40" x2="300" y2="250" stroke="rgba(255,255,255,0.1)" stroke-width="1"/>
            <line x1="50" y1="145" x2="550" y2="145" stroke="rgba(255,255,255,0.1)" stroke-width="1"/>

            <!-- Labels -->
            <text x="520" y="60" font-size="10" fill="#888" font-weight="500">High Influence</text>
            <text x="520" y="250" font-size="10" fill="#888" font-weight="500">Low Influence</text>
            <text x="60" y="25" font-size="10" fill="#888" font-weight="500">High Impact</text>
            <text x="490" y="25" font-size="10" fill="#888" font-weight="500">Low Impact</text>

            <!-- Stakeholders -->
            <g>
              <circle cx="400" cy="70" r="18" fill="rgba(255,107,43,0.2)" stroke="#FF6B2B" stroke-width="1.5"/>
              <text x="400" y="76" font-size="11" font-weight="500" text-anchor="middle" fill="#fff">C-Suite</text>
              <text x="400" y="102" font-size="9" text-anchor="middle" fill="#888">Executive Sponsor</text>
            </g>

            <g>
              <circle cx="450" cy="110" r="16" fill="rgba(22,163,74,0.2)" stroke="#16a34a" stroke-width="1.5"/>
              <text x="450" y="116" font-size="11" font-weight="500" text-anchor="middle" fill="#fff">Operations</text>
              <text x="450" y="142" font-size="9" text-anchor="middle" fill="#888">End Users</text>
            </g>

            <g>
              <circle cx="350" cy="85" r="15" fill="rgba(22,163,74,0.2)" stroke="#16a34a" stroke-width="1.5"/>
              <text x="350" y="91" font-size="11" font-weight="500" text-anchor="middle" fill="#fff">IT/Platform</text>
              <text x="350" y="117" font-size="9" text-anchor="middle" fill="#888">Internal</text>
            </g>

            <g>
              <circle cx="320" cy="140" r="14" fill="rgba(107,114,128,0.2)" stroke="rgba(107,114,128,0.5)" stroke-width="1.5"/>
              <text x="320" y="145" font-size="10" font-weight="500" text-anchor="middle" fill="#aaa">Finance</text>
              <text x="320" y="170" font-size="8" text-anchor="middle" fill="#888">Approval</text>
            </g>

            <g>
              <circle cx="250" cy="120" r="13" fill="rgba(107,114,128,0.15)" stroke="rgba(107,114,128,0.4)" stroke-width="1.5"/>
              <text x="250" y="125" font-size="10" font-weight="500" text-anchor="middle" fill="#999">HR/Training</text>
              <text x="250" y="150" font-size="8" text-anchor="middle" fill="#888">Support</text>
            </g>
          </svg>
        </div>

        <h2 class="dlv-section-title">Training Schedule</h2>
        <table class="dlv-table">
          <thead>
            <tr>
              <th>Role</th>
              <th>Module</th>
              <th>Duration</th>
              <th>Format</th>
              <th>Schedule</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>C-Suite / Sponsors</strong></td>
              <td>Business Impact &amp; ROI</td>
              <td class="num">1.5h</td>
              <td>Live Session</td>
              <td>Week 1</td>
            </tr>
            <tr>
              <td><strong>Operations Managers</strong></td>
              <td>How to Use the System</td>
              <td class="num">3h</td>
              <td>Workshop</td>
              <td>Week 2</td>
            </tr>
            <tr>
              <td><strong>End Users</strong></td>
              <td>Hands-On Training</td>
              <td class="num">2h</td>
              <td>In-person + Recorded</td>
              <td>Week 2–3</td>
            </tr>
            <tr>
              <td><strong>IT Support</strong></td>
              <td>Technical Architecture</td>
              <td class="num">4h</td>
              <td>Deep Dive</td>
              <td>Week 1</td>
            </tr>
            <tr>
              <td><strong>Data Teams</strong></td>
              <td>Data Governance &amp; Pipelines</td>
              <td class="num">3h</td>
              <td>Technical Workshop</td>
              <td>Week 1–2</td>
            </tr>
          </tbody>
        </table>

        <h2 class="dlv-section-title">Adoption Metrics & Targets</h2>
        <table class="dlv-table">
          <thead>
            <tr>
              <th>KPI</th>
              <th>Baseline</th>
              <th>Target (30 days)</th>
              <th>Measurement</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>System Access Rate</strong></td>
              <td class="num">—</td>
              <td class="positive">95%+ of users</td>
              <td>Login audit</td>
            </tr>
            <tr>
              <td><strong>Daily Active Users</strong></td>
              <td class="num">—</td>
              <td class="positive">75%+ adoption</td>
              <td>Dashboard analytics</td>
            </tr>
            <tr>
              <td><strong>User Satisfaction (NPS)</strong></td>
              <td class="num">—</td>
              <td class="positive">40+ NPS</td>
              <td>Post-training survey</td>
            </tr>
            <tr>
              <td><strong>Support Ticket Reduction</strong></td>
              <td class="num">—</td>
              <td class="positive">60% drop by week 4</td>
              <td>Support queue data</td>
            </tr>
            <tr>
              <td><strong>Time-to-Competency</strong></td>
              <td class="num">—</td>
              <td class="positive">2 weeks avg</td>
              <td>Trainer assessment</td>
            </tr>
          </tbody>
        </table>

        <h2 class="dlv-section-title">Communication Plan</h2>
        <table class="dlv-table">
          <thead>
            <tr>
              <th>Audience</th>
              <th>Channel</th>
              <th>Frequency</th>
              <th>Key Messages</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>C-Suite</strong></td>
              <td>Executive Briefing</td>
              <td class="num">Weekly</td>
              <td>ROI progress, risks, escalations</td>
            </tr>
            <tr>
              <td><strong>Operations</strong></td>
              <td>Email + Slack Updates</td>
              <td class="num">2x/week</td>
              <td>Features, wins, training dates</td>
            </tr>
            <tr>
              <td><strong>End Users</strong></td>
              <td>In-app Tips + Office Hours</td>
              <td class="num">Daily tips, Weekly Q&amp;A</td>
              <td>How-tos, best practices, success stories</td>
            </tr>
            <tr>
              <td><strong>All Staff</strong></td>
              <td>Company Newsletter</td>
              <td class="num">Bi-weekly</td>
              <td>Project milestones, impact stories</td>
            </tr>
          </tbody>
        </table>

        <div class="dlv-doc-footer">
          <span>PERCEPT<em>Y</em>A — Adoption Playbook</span>
          <span>Page 1 of 1</span>
        </div>
      </div>`,
},

'preview-agent-architecture': {
    title: 'agent-architecture-blueprint.pdf',
    body: `<div class="dlv-page">
        <div class="dlv-sanitized"><div class="dlv-sanitized-stripe">Sanitized client example</div></div>

        <div class="dlv-doc-header">
          <div class="dlv-doc-brand">PERCEPT<em>Y</em>A</div>
          <div class="dlv-doc-meta">
            <div class="dlv-doc-badge">Confidential</div>
            <div class="dlv-doc-meta-text">April 2025</div>
          </div>
        </div>

        <h1 class="dlv-doc-title">Multi-Agent Architecture Blueprint</h1>
        <p class="dlv-doc-subtitle">AI Agent Deployment for Healthcare — Module C</p>

        <div class="dlv-arch-section">
          <div class="dlv-arch-title">Healthcare AI Agent System</div>
          <svg viewBox="0 0 700 350" style="width: 100%; height: auto;">
            <!-- Central Orchestrator -->
            <g>
              <rect x="290" y="150" width="120" height="60" fill="rgba(255,107,43,0.15)" stroke="#FF6B2B" stroke-width="2" rx="4"/>
              <text x="350" y="175" font-size="12" font-weight="600" text-anchor="middle" fill="#FF6B2B">Orchestrator</text>
              <text x="350" y="193" font-size="10" text-anchor="middle" fill="#888">LLM Router</text>
            </g>

            <!-- Specialized Agents (top row) -->
            <g>
              <rect x="20" y="30" width="110" height="70" fill="rgba(22,163,74,0.1)" stroke="#16a34a" stroke-width="1.5" rx="3"/>
              <text x="75" y="55" font-size="11" font-weight="500" text-anchor="middle" fill="#fff">Triage Agent</text>
              <text x="75" y="73" font-size="9" text-anchor="middle" fill="#888">Initial Assessment</text>
              <line x1="75" y1="85" x2="75" y2="105" stroke="#16a34a" stroke-width="1"/>
            </g>

            <g>
              <rect x="160" y="30" width="110" height="70" fill="rgba(22,163,74,0.1)" stroke="#16a34a" stroke-width="1.5" rx="3"/>
              <text x="215" y="55" font-size="11" font-weight="500" text-anchor="middle" fill="#fff">Scheduling</text>
              <text x="215" y="73" font-size="9" text-anchor="middle" fill="#888">Appointments</text>
              <line x1="215" y1="85" x2="215" y2="105" stroke="#16a34a" stroke-width="1"/>
            </g>

            <g>
              <rect x="300" y="30" width="110" height="70" fill="rgba(22,163,74,0.1)" stroke="#16a34a" stroke-width="1.5" rx="3"/>
              <text x="355" y="55" font-size="11" font-weight="500" text-anchor="middle" fill="#fff">Documentation</text>
              <text x="355" y="73" font-size="9" text-anchor="middle" fill="#888">EHR Entry</text>
              <line x1="355" y1="85" x2="355" y2="105" stroke="#16a34a" stroke-width="1"/>
            </g>

            <g>
              <rect x="440" y="30" width="110" height="70" fill="rgba(22,163,74,0.1)" stroke="#16a34a" stroke-width="1.5" rx="3"/>
              <text x="495" y="55" font-size="11" font-weight="500" text-anchor="middle" fill="#fff">Billing Agent</text>
              <text x="495" y="73" font-size="9" text-anchor="middle" fill="#888">Insurance Checks</text>
              <line x1="495" y1="85" x2="495" y2="105" stroke="#16a34a" stroke-width="1"/>
            </g>

            <g>
              <rect x="580" y="30" width="110" height="70" fill="rgba(22,163,74,0.1)" stroke="#16a34a" stroke-width="1.5" rx="3"/>
              <text x="635" y="55" font-size="11" font-weight="500" text-anchor="middle" fill="#fff">Patient Comms</text>
              <text x="635" y="73" font-size="9" text-anchor="middle" fill="#888">Messaging</text>
              <line x1="635" y1="85" x2="635" y2="105" stroke="#16a34a" stroke-width="1"/>
            </g>

            <!-- Lines from agents to orchestrator -->
            <path d="M 75 105 L 75 150 Q 350 130 350 150" fill="none" stroke="rgba(22,163,74,0.4)" stroke-width="1.5" stroke-dasharray="3,2"/>
            <path d="M 215 105 L 215 140 L 350 140 L 350 150" fill="none" stroke="rgba(22,163,74,0.4)" stroke-width="1.5" stroke-dasharray="3,2"/>
            <path d="M 355 105 L 355 150" fill="none" stroke="rgba(22,163,74,0.4)" stroke-width="1.5" stroke-dasharray="3,2"/>
            <path d="M 495 105 L 495 140 L 350 140 L 350 150" fill="none" stroke="rgba(22,163,74,0.4)" stroke-width="1.5" stroke-dasharray="3,2"/>
            <path d="M 635 105 L 635 150 Q 350 130 350 150" fill="none" stroke="rgba(22,163,74,0.4)" stroke-width="1.5" stroke-dasharray="3,2"/>

            <!-- Support Systems (bottom) -->
            <g>
              <rect x="20" y="240" width="130" height="70" fill="rgba(107,114,128,0.08)" stroke="rgba(107,114,128,0.3)" stroke-width="1" rx="3"/>
              <text x="85" y="263" font-size="10" font-weight="500" text-anchor="middle" fill="#aaa">LLM Providers</text>
              <text x="85" y="280" font-size="8" text-anchor="middle" fill="#888">Claude, GPT-4</text>
              <text x="85" y="293" font-size="8" text-anchor="middle" fill="#888">Hybrid routing</text>
            </g>

            <g>
              <rect x="170" y="240" width="130" height="70" fill="rgba(107,114,128,0.08)" stroke="rgba(107,114,128,0.3)" stroke-width="1" rx="3"/>
              <text x="235" y="263" font-size="10" font-weight="500" text-anchor="middle" fill="#aaa">Vector Database</text>
              <text x="235" y="280" font-size="8" text-anchor="middle" fill="#888">Embeddings</text>
              <text x="235" y="293" font-size="8" text-anchor="middle" fill="#888">Similarity Search</text>
            </g>

            <g>
              <rect x="320" y="240" width="130" height="70" fill="rgba(107,114,128,0.08)" stroke="rgba(107,114,128,0.3)" stroke-width="1" rx="3"/>
              <text x="385" y="263" font-size="10" font-weight="500" text-anchor="middle" fill="#aaa">Knowledge Base</text>
              <text x="385" y="280" font-size="8" text-anchor="middle" fill="#888">Clinical Protocols</text>
              <text x="385" y="293" font-size="8" text-anchor="middle" fill="#888">Patient History</text>
            </g>

            <g>
              <rect x="470" y="240" width="130" height="70" fill="rgba(107,114,128,0.08)" stroke="rgba(107,114,128,0.3)" stroke-width="1" rx="3"/>
              <text x="535" y="263" font-size="10" font-weight="500" text-anchor="middle" fill="#aaa">Audit Log</text>
              <text x="535" y="280" font-size="8" text-anchor="middle" fill="#888">Compliance</text>
              <text x="535" y="293" font-size="8" text-anchor="middle" fill="#888">Accountability</text>
            </g>

            <!-- Support connections -->
            <path d="M 85 240 L 350 210" fill="none" stroke="rgba(107,114,128,0.2)" stroke-width="1" stroke-dasharray="2,2"/>
            <path d="M 235 240 L 350 210" fill="none" stroke="rgba(107,114,128,0.2)" stroke-width="1" stroke-dasharray="2,2"/>
            <path d="M 385 240 L 350 210" fill="none" stroke="rgba(107,114,128,0.2)" stroke-width="1" stroke-dasharray="2,2"/>
            <path d="M 535 240 L 350 210" fill="none" stroke="rgba(107,114,128,0.2)" stroke-width="1" stroke-dasharray="2,2"/>
          </svg>
        </div>

        <h2 class="dlv-section-title">Agent Specifications</h2>
        <table class="dlv-table">
          <thead>
            <tr>
              <th>Agent</th>
              <th>Input Sources</th>
              <th>Key Tools/APIs</th>
              <th>Guardrails</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Clinical Triage</strong></td>
              <td>Patient symptoms, vitals, history</td>
              <td>FHIR APIs, symptom DB, severity classifier</td>
              <td>Clinical disclaimers, escalation rules</td>
            </tr>
            <tr>
              <td><strong>Scheduling</strong></td>
              <td>Doctor calendars, availability, patient needs</td>
              <td>Calendar APIs, booking system, conflict detector</td>
              <td>Timezone awareness, no double-booking</td>
            </tr>
            <tr>
              <td><strong>Documentation</strong></td>
              <td>Clinical notes, voice transcripts, codes</td>
              <td>EHR APIs, ICD-10 codifier, clinical templates</td>
              <td>HIPAA compliance, audit trail for all writes</td>
            </tr>
            <tr>
              <td><strong>Billing</strong></td>
              <td>Service codes, insurance plans, patient data</td>
              <td>Insurance verification, claims API, pricing DB</td>
              <td>Compliance checks, pre-auth validation</td>
            </tr>
            <tr>
              <td><strong>Patient Comms</strong></td>
              <td>Appointment data, clinical info, patient preferences</td>
              <td>SMS gateway, email, patient portal APIs</td>
              <td>Consent checks, message templates only</td>
            </tr>
          </tbody>
        </table>

        <div class="dlv-doc-footer">
          <span>PERCEPT<em>Y</em>A — Agent Architecture</span>
          <span>Page 1 of 1</span>
        </div>
      </div>`,
},

'preview-agent-monitoring': {
    title: 'agent-monitoring-dashboard.live',
    body: `<div class="dlv-page">
        <div class="dlv-sanitized"><div class="dlv-sanitized-stripe">Sanitized client example</div></div>

        <div class="dlv-doc-header">
          <div class="dlv-doc-brand">PERCEPT<em>Y</em>A</div>
          <div class="dlv-doc-meta">
            <div class="dlv-doc-badge">Live</div>
            <div class="dlv-doc-meta-text">Healthcare Agents</div>
          </div>
        </div>

        <h1 class="dlv-doc-title">AI Agent Monitoring Dashboard</h1>
        <p class="dlv-doc-subtitle">Real-time Operations & Health Monitoring</p>

        <div class="dlv-kpi-row">
          <div class="dlv-kpi">
            <div class="dlv-kpi-value accent">5</div>
            <div class="dlv-kpi-label">Active Agents</div>
            <div class="dlv-kpi-delta">All healthy</div>
          </div>
          <div class="dlv-kpi">
            <div class="dlv-kpi-value">1.8s</div>
            <div class="dlv-kpi-label">Avg Response Time</div>
            <div class="dlv-kpi-delta positive">↓ 300ms vs last week</div>
          </div>
          <div class="dlv-kpi">
            <div class="dlv-kpi-value positive">3,400</div>
            <div class="dlv-kpi-label">Conversations/Day</div>
            <div class="dlv-kpi-delta">↑ 22% week-over-week</div>
          </div>
          <div class="dlv-kpi">
            <div class="dlv-kpi-value">8.2%</div>
            <div class="dlv-kpi-label">Escalation Rate</div>
            <div class="dlv-kpi-delta negative">Target: &lt;5%</div>
          </div>
        </div>

        <h2 class="dlv-section-title">Daily Conversation Volume — Last 30 Days</h2>
        <div class="dlv-chart">
          <svg viewBox="0 0 650 220" style="width: 100%; height: auto;">
            <defs>
              <linearGradient id="convGrad" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" style="stop-color:#16a34a;stop-opacity:0.3" />
                <stop offset="100%" style="stop-color:#16a34a;stop-opacity:0.05" />
              </linearGradient>
              <linearGradient id="escalGrad" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" style="stop-color:#FF6B2B;stop-opacity:0.2" />
                <stop offset="100%" style="stop-color:#FF6B2B;stop-opacity:0.02" />
              </linearGradient>
            </defs>
            <!-- Conversation volume (primary) -->
            <polyline points="20,140 48,120 76,145 104,110 132,105 160,135 188,125 216,150 244,115 272,100 300,130 328,125 356,155 384,135 412,120 440,145 468,140 496,150 524,118 552,110 580,135 608,128" fill="none" stroke="#16a34a" stroke-width="2.5"/>
            <polygon points="20,140 48,120 76,145 104,110 132,105 160,135 188,125 216,150 244,115 272,100 300,130 328,125 356,155 384,135 412,120 440,145 468,140 496,150 524,118 552,110 580,135 608,128 608,200 20,200" fill="url(#convGrad)"/>

            <!-- Escalation rate (overlay, scaled) -->
            <polyline points="20,165 48,160 76,172 104,155 132,152 160,168 188,158 216,175 244,152 272,145 300,162 328,158 356,178 384,165 412,155 440,170 468,168 496,172 524,150 552,145 580,165 608,160" fill="none" stroke="#FF6B2B" stroke-width="1.5" stroke-dasharray="3,2" opacity="0.6"/>

            <line x1="20" y1="200" x2="608" y2="200" stroke="rgba(255,255,255,0.1)" stroke-width="1"/>
            <text x="630" y="130" font-size="9" fill="#16a34a">Conversations</text>
            <text x="630" y="162" font-size="9" fill="#FF6B2B">Escalations</text>
          </svg>
        </div>

        <h2 class="dlv-section-title">Agent Performance</h2>
        <table class="dlv-table">
          <thead>
            <tr>
              <th>Agent</th>
              <th>Status</th>
              <th>Conversations Today</th>
              <th>Avg Satisfaction</th>
              <th>Escalation Rate</th>
              <th>Guardrail Triggers</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Clinical Triage</strong></td>
              <td><span class="dlv-status green">Active</span></td>
              <td class="positive">890</td>
              <td class="num">4.7/5.0</td>
              <td class="num">12.4%</td>
              <td class="num">18 (clinical safety)</td>
            </tr>
            <tr>
              <td><strong>Scheduling</strong></td>
              <td><span class="dlv-status green">Active</span></td>
              <td class="positive">620</td>
              <td class="num">4.8/5.0</td>
              <td class="num">3.2%</td>
              <td class="num">2 (conflict detect)</td>
            </tr>
            <tr>
              <td><strong>Documentation</strong></td>
              <td><span class="dlv-status green">Active</span></td>
              <td class="positive">740</td>
              <td class="num">4.6/5.0</td>
              <td class="num">6.8%</td>
              <td class="num">12 (HIPAA audit)</td>
            </tr>
            <tr>
              <td><strong>Billing Agent</strong></td>
              <td><span class="dlv-status green">Active</span></td>
              <td class="positive">580</td>
              <td class="num">4.5/5.0</td>
              <td class="num">8.1%</td>
              <td class="num">5 (compliance)</td>
            </tr>
            <tr>
              <td><strong>Patient Comms</strong></td>
              <td><span class="dlv-status green">Active</span></td>
              <td class="positive">570</td>
              <td class="num">4.9/5.0</td>
              <td class="num">2.6%</td>
              <td class="num">1 (consent check)</td>
            </tr>
          </tbody>
        </table>

        <div class="dlv-doc-footer">
          <span>PERCEPT<em>Y</em>A — Agent Monitoring</span>
          <span>Last updated: 5 minutes ago</span>
        </div>
      </div>`,
},

'preview-security-guardrails': {
    title: 'security-guardrails-policy.pdf',
    body: `<div class="dlv-page">
        <div class="dlv-sanitized"><div class="dlv-sanitized-stripe">Sanitized client example</div></div>

        <div class="dlv-doc-header">
          <div class="dlv-doc-brand">PERCEPT<em>Y</em>A</div>
          <div class="dlv-doc-meta">
            <div class="dlv-doc-badge">Confidential</div>
            <div class="dlv-doc-meta-text">May 2025</div>
          </div>
        </div>

        <h1 class="dlv-doc-title">AI Agent Security & Guardrails</h1>
        <p class="dlv-doc-subtitle">Compliance & Safety Framework — Module C</p>

        <div class="dlv-arch-section">
          <div class="dlv-arch-title">Guardrail Layers — Defense in Depth</div>
          <svg viewBox="0 0 700 240" style="width: 100%; height: auto;">
            <!-- Input to Output flow with guardrails -->
            <rect x="10" y="10" width="680" height="220" fill="rgba(255,107,43,0.02)" stroke="rgba(255,107,43,0.1)" stroke-width="1" rx="4"/>

            <!-- Layer 1 -->
            <g>
              <rect x="20" y="30" width="85" height="55" fill="rgba(22,163,74,0.15)" stroke="#16a34a" stroke-width="1.5" rx="3"/>
              <text x="62.5" y="48" font-size="10" font-weight="500" text-anchor="middle" fill="#fff">Input</text>
              <text x="62.5" y="63" font-size="9" text-anchor="middle" fill="#888">Validation</text>
            </g>

            <!-- Layer 2 -->
            <g>
              <rect x="115" y="30" width="85" height="55" fill="rgba(22,163,74,0.15)" stroke="#16a34a" stroke-width="1.5" rx="3"/>
              <text x="157.5" y="48" font-size="10" font-weight="500" text-anchor="middle" fill="#fff">PII</text>
              <text x="157.5" y="63" font-size="9" text-anchor="middle" fill="#888">Detection</text>
            </g>

            <!-- Layer 3 -->
            <g>
              <rect x="210" y="30" width="85" height="55" fill="rgba(22,163,74,0.15)" stroke="#16a34a" stroke-width="1.5" rx="3"/>
              <text x="252.5" y="48" font-size="10" font-weight="500" text-anchor="middle" fill="#fff">Content</text>
              <text x="252.5" y="63" font-size="9" text-anchor="middle" fill="#888">Filtering</text>
            </g>

            <!-- Layer 4 -->
            <g>
              <rect x="305" y="30" width="85" height="55" fill="rgba(22,163,74,0.15)" stroke="#16a34a" stroke-width="1.5" rx="3"/>
              <text x="347.5" y="48" font-size="10" font-weight="500" text-anchor="middle" fill="#fff">Clinical</text>
              <text x="347.5" y="63" font-size="9" text-anchor="middle" fill="#888">Safety Check</text>
            </g>

            <!-- Layer 5 -->
            <g>
              <rect x="400" y="30" width="85" height="55" fill="rgba(22,163,74,0.15)" stroke="#16a34a" stroke-width="1.5" rx="3"/>
              <text x="442.5" y="48" font-size="10" font-weight="500" text-anchor="middle" fill="#fff">Output</text>
              <text x="442.5" y="63" font-size="9" text-anchor="middle" fill="#888">Validation</text>
            </g>

            <!-- Layer 6 -->
            <g>
              <rect x="495" y="30" width="85" height="55" fill="rgba(22,163,74,0.15)" stroke="#16a34a" stroke-width="1.5" rx="3"/>
              <text x="537.5" y="48" font-size="10" font-weight="500" text-anchor="middle" fill="#fff">Audit</text>
              <text x="537.5" y="63" font-size="9" text-anchor="middle" fill="#888">Logging</text>
            </g>

            <!-- User -->
            <g>
              <rect x="590" y="30" width="85" height="55" fill="rgba(107,114,128,0.1)" stroke="rgba(107,114,128,0.4)" stroke-width="1.5" rx="3"/>
              <text x="632.5" y="52" font-size="10" font-weight="500" text-anchor="middle" fill="#aaa">User</text>
            </g>

            <!-- Arrows -->
            <path d="M 62.5 85 L 62.5 110" fill="none" stroke="#888" stroke-width="1.5" marker-end="url(#arrowSmall)"/>
            <path d="M 157.5 85 L 157.5 110" fill="none" stroke="#888" stroke-width="1.5" marker-end="url(#arrowSmall)"/>
            <path d="M 252.5 85 L 252.5 110" fill="none" stroke="#888" stroke-width="1.5" marker-end="url(#arrowSmall)"/>
            <path d="M 347.5 85 L 347.5 110" fill="none" stroke="#888" stroke-width="1.5" marker-end="url(#arrowSmall)"/>
            <path d="M 442.5 85 L 442.5 110" fill="none" stroke="#888" stroke-width="1.5" marker-end="url(#arrowSmall)"/>
            <path d="M 537.5 85 L 537.5 110" fill="none" stroke="#888" stroke-width="1.5" marker-end="url(#arrowSmall)"/>
            <path d="M 632.5 85 L 632.5 110" fill="none" stroke="#888" stroke-width="1.5" marker-end="url(#arrowSmall)"/>

            <!-- Rule trigger action boxes -->
            <g>
              <rect x="20" y="130" width="655" height="80" fill="rgba(255,107,43,0.05)" stroke="rgba(255,107,43,0.15)" stroke-width="1" rx="3"/>
              <text x="30" y="150" font-size="10" font-weight="500" fill="#FF6B2B">If Rule Triggered:</text>
              <text x="30" y="168" font-size="9" fill="#ddd">• Block request &amp; log violation</text>
              <text x="30" y="183" font-size="9" fill="#ddd">• Notify security team in real-time</text>
              <text x="30" y="198" font-size="9" fill="#ddd">• Escalate to human review if severity &gt;= High</text>
            </g>
          </svg>
        </div>

        <h2 class="dlv-section-title">Guardrail Rules Register</h2>
        <table class="dlv-table">
          <thead>
            <tr>
              <th>Rule ID</th>
              <th>Category</th>
              <th>Trigger Condition</th>
              <th>Action</th>
              <th>Severity</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>GR-001</strong></td>
              <td class="uc-tag">Privacy</td>
              <td>SSN or insurance ID in input</td>
              <td>Mask + Alert</td>
              <td class="positive">High</td>
            </tr>
            <tr>
              <td><strong>GR-002</strong></td>
              <td class="uc-tag">Compliance</td>
              <td>Medication prescription without context</td>
              <td>Block + Escalate</td>
              <td class="positive">Critical</td>
            </tr>
            <tr>
              <td><strong>GR-003</strong></td>
              <td class="uc-tag">Safety</td>
              <td>Hallucination confidence &lt; 60%</td>
              <td>Flag + Show Disclaimer</td>
              <td class="positive">High</td>
            </tr>
            <tr>
              <td><strong>GR-004</strong></td>
              <td class="uc-tag">Privacy</td>
              <td>Patient MRN detected in chat logs</td>
              <td>Mask + Redact</td>
              <td class="positive">High</td>
            </tr>
            <tr>
              <td><strong>GR-005</strong></td>
              <td class="uc-tag">Compliance</td>
              <td>Clinical diagnosis without evidence</td>
              <td>Block &amp; Rephrase</td>
              <td class="positive">Critical</td>
            </tr>
            <tr>
              <td><strong>GR-006</strong></td>
              <td class="uc-tag">Safety</td>
              <td>Attempt to override guardrails</td>
              <td>Log + Alert CISO</td>
              <td class="positive">Critical</td>
            </tr>
            <tr>
              <td><strong>GR-007</strong></td>
              <td class="uc-tag">Quality</td>
              <td>Response length &gt; 500 tokens</td>
              <td>Truncate &amp; Summarize</td>
              <td>Low</td>
            </tr>
            <tr>
              <td><strong>GR-008</strong></td>
              <td class="uc-tag">Compliance</td>
              <td>Unauthorized data access request</td>
              <td>Block + Audit</td>
              <td class="positive">Critical</td>
            </tr>
            <tr>
              <td><strong>GR-009</strong></td>
              <td class="uc-tag">Privacy</td>
              <td>Email or phone in response</td>
              <td>Mask + Warn User</td>
              <td class="positive">High</td>
            </tr>
            <tr>
              <td><strong>GR-010</strong></td>
              <td class="uc-tag">Safety</td>
              <td>Patient consent not verified</td>
              <td>Block Communication</td>
              <td class="positive">Critical</td>
            </tr>
            <tr>
              <td><strong>GR-011</strong></td>
              <td class="uc-tag">Compliance</td>
              <td>HIPAA-regulated data in temp logs</td>
              <td>Delete + Alert</td>
              <td class="positive">High</td>
            </tr>
            <tr>
              <td><strong>GR-012</strong></td>
              <td class="uc-tag">Safety</td>
              <td>Contradiction of clinical standard</td>
              <td>Warn + Suggest Escalation</td>
              <td class="positive">High</td>
            </tr>
          </tbody>
        </table>

        <div class="dlv-doc-footer">
          <span>PERCEPT<em>Y</em>A — Security Guardrails</span>
          <span>12 Rules Active • Real-time Monitoring</span>
        </div>
      </div>`,
},

'preview-operating-model': {
    title: 'operating-model-blueprint.pdf',
    body: `<div class="dlv-page">
        <div class="dlv-sanitized"><div class="dlv-sanitized-stripe">Sanitized client example</div></div>

        <div class="dlv-doc-header">
          <div class="dlv-doc-brand">PERCEPT<em>Y</em>A</div>
          <div class="dlv-doc-meta">
            <div class="dlv-doc-badge">Confidential</div>
            <div class="dlv-doc-meta-text">June 2025</div>
          </div>
        </div>

        <h1 class="dlv-doc-title">AI Operating Model Blueprint</h1>
        <p class="dlv-doc-subtitle">Federated Governance Structure — Module D</p>

        <div class="dlv-arch-section">
          <div class="dlv-arch-title">Federated AI Center of Excellence (CoE)</div>
          <svg viewBox="0 0 700 280" style="width: 100%; height: auto;">
            <!-- Central CoE -->
            <g>
              <rect x="280" y="30" width="140" height="70" fill="rgba(255,107,43,0.15)" stroke="#FF6B2B" stroke-width="2" rx="4"/>
              <text x="350" y="55" font-size="12" font-weight="600" text-anchor="middle" fill="#FF6B2B">AI CoE</text>
              <text x="350" y="73" font-size="9" text-anchor="middle" fill="#888">Central Leadership</text>
            </g>

            <!-- CoE Roles -->
            <text x="350" y="125" font-size="9" fill="#888" text-anchor="middle">Head of AI • Data Gov Lead • Ethics Officer</text>

            <!-- Business Units -->
            <g>
              <rect x="20" y="150" width="100" height="60" fill="rgba(22,163,74,0.1)" stroke="#16a34a" stroke-width="1.5" rx="3"/>
              <text x="70" y="172" font-size="11" font-weight="500" text-anchor="middle" fill="#fff">Ops</text>
              <text x="70" y="192" font-size="8" text-anchor="middle" fill="#888">BU Lead • Champions</text>
            </g>

            <g>
              <rect x="135" y="150" width="100" height="60" fill="rgba(22,163,74,0.1)" stroke="#16a34a" stroke-width="1.5" rx="3"/>
              <text x="185" y="172" font-size="11" font-weight="500" text-anchor="middle" fill="#fff">Quality</text>
              <text x="185" y="192" font-size="8" text-anchor="middle" fill="#888">BU Lead • Champions</text>
            </g>

            <g>
              <rect x="250" y="150" width="100" height="60" fill="rgba(22,163,74,0.1)" stroke="#16a34a" stroke-width="1.5" rx="3"/>
              <text x="300" y="172" font-size="11" font-weight="500" text-anchor="middle" fill="#fff">Supply Chain</text>
              <text x="300" y="192" font-size="8" text-anchor="middle" fill="#888">BU Lead • Champions</text>
            </g>

            <g>
              <rect x="365" y="150" width="100" height="60" fill="rgba(22,163,74,0.1)" stroke="#16a34a" stroke-width="1.5" rx="3"/>
              <text x="415" y="172" font-size="11" font-weight="500" text-anchor="middle" fill="#fff">Maintenance</text>
              <text x="415" y="192" font-size="8" text-anchor="middle" fill="#888">BU Lead • Champions</text>
            </g>

            <g>
              <rect x="480" y="150" width="100" height="60" fill="rgba(22,163,74,0.1)" stroke="#16a34a" stroke-width="1.5" rx="3"/>
              <text x="530" y="172" font-size="11" font-weight="500" text-anchor="middle" fill="#fff">R&amp;D</text>
              <text x="530" y="192" font-size="8" text-anchor="middle" fill="#888">BU Lead • Champions</text>
            </g>

            <!-- Lines from CoE to BUs -->
            <line x1="350" y1="100" x2="70" y2="150" stroke="rgba(22,163,74,0.3)" stroke-width="1.5" stroke-dasharray="2,2"/>
            <line x1="350" y1="100" x2="185" y2="150" stroke="rgba(22,163,74,0.3)" stroke-width="1.5" stroke-dasharray="2,2"/>
            <line x1="350" y1="100" x2="300" y2="150" stroke="rgba(22,163,74,0.3)" stroke-width="1.5" stroke-dasharray="2,2"/>
            <line x1="350" y1="100" x2="415" y2="150" stroke="rgba(22,163,74,0.3)" stroke-width="1.5" stroke-dasharray="2,2"/>
            <line x1="350" y1="100" x2="530" y2="150" stroke="rgba(22,163,74,0.3)" stroke-width="1.5" stroke-dasharray="2,2"/>

            <!-- Operating Rhythm -->
            <rect x="20" y="240" width="660" height="30" fill="rgba(107,114,128,0.05)" stroke="rgba(107,114,128,0.1)" stroke-width="1" rx="3"/>
            <text x="40" y="260" font-size="10" font-weight="500" fill="#aaa">Operating Rhythm:</text>
            <text x="240" y="260" font-size="9" fill="#ddd">Weekly Standups • Monthly Reviews • Quarterly Planning • Annual Strategy</text>
          </svg>
        </div>

        <h2 class="dlv-section-title">Operating Rhythm</h2>
        <table class="dlv-table">
          <thead>
            <tr>
              <th>Cadence</th>
              <th>Attendees</th>
              <th>Agenda</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Weekly Standup</strong></td>
              <td>CoE + BU Champions (30 min)</td>
              <td>Blockers, use case progress, quick decisions</td>
            </tr>
            <tr>
              <td><strong>Monthly Governance</strong></td>
              <td>CoE Leadership + BU Heads (90 min)</td>
              <td>Data quality, model performance, budget tracking, risk review</td>
            </tr>
            <tr>
              <td><strong>Quarterly Business Review</strong></td>
              <td>Exec Sponsors + CoE (120 min)</td>
              <td>ROI tracking, portfolio health, roadmap adjustments, new initiatives</td>
            </tr>
            <tr>
              <td><strong>Annual Strategy</strong></td>
              <td>C-Suite + CoE + BU Leadership (full day)</td>
              <td>Year 2 roadmap, capability investments, organizational changes, budget planning</td>
            </tr>
          </tbody>
        </table>

        <h2 class="dlv-section-title">Key Responsibilities</h2>
        <p style="font-size: 13px; color: #ddd; line-height: 1.6; margin-bottom: 12px;">
          <strong style="color: #fff;">AI CoE Head:</strong> Sets vision, approves major investments, resolves cross-BU conflicts, reports to CTO/COO.<br>
          <strong style="color: #fff;">Data Governance Lead:</strong> Ensures data quality, ownership, lineage, compliance, standardization across enterprise.<br>
          <strong style="color: #fff;">Ethics Officer:</strong> Reviews models for bias, fairness, responsible AI practices. Escalates concerns to governance committee.<br>
          <strong style="color: #fff;">BU AI Champions:</strong> Local advocates. Drive adoption, identify new opportunities, report issues to CoE weekly.
        </p>

        <div class="dlv-doc-footer">
          <span>PERCEPT<em>Y</em>A — Operating Model</span>
          <span>Page 1 of 1</span>
        </div>
      </div>`,
},

'preview-raci-matrix': {
    title: 'raci-matrix.xlsx',
    body: `<div class="dlv-page">
        <div class="dlv-sanitized"><div class="dlv-sanitized-stripe">Sanitized client example</div></div>

        <div class="dlv-doc-header">
          <div class="dlv-doc-brand">PERCEPT<em>Y</em>A</div>
          <div class="dlv-doc-meta">
            <div class="dlv-doc-badge">Spreadsheet</div>
            <div class="dlv-doc-meta-text">RACI</div>
          </div>
        </div>

        <h1 class="dlv-doc-title">AI Governance RACI Matrix</h1>
        <p class="dlv-doc-subtitle">Roles & Responsibilities — Module D</p>

        <table class="dlv-table" style="font-size: 12px;">
          <thead>
            <tr>
              <th style="min-width: 180px;">Activity</th>
              <th style="min-width: 70px;">CoE Head</th>
              <th style="min-width: 70px;">Data Gov</th>
              <th style="min-width: 70px;">BU Head</th>
              <th style="min-width: 70px;">IT/Infra</th>
              <th style="min-width: 70px;">Data Eng</th>
              <th style="min-width: 70px;">ML Eng</th>
              <th style="min-width: 70px;">Legal/Comp</th>
              <th style="min-width: 90px;">Exec Sponsor</th>
            </tr>
          </thead>
          <tbody style="font-size: 11px;">
            <tr>
              <td><strong>Use Case Prioritization</strong></td>
              <td style="background: rgba(255,107,43,0.2); color: #FF6B2B; font-weight: 600; text-align: center;">R</td>
              <td style="background: rgba(22,163,74,0.2); color: #16a34a; font-weight: 600; text-align: center;">C</td>
              <td style="background: rgba(22,163,74,0.2); color: #16a34a; font-weight: 600; text-align: center;">C</td>
              <td style="text-align: center;">—</td>
              <td style="text-align: center;">—</td>
              <td style="text-align: center;">—</td>
              <td style="text-align: center;">—</td>
              <td style="background: rgba(107,114,128,0.2); color: #aaa; font-weight: 600; text-align: center;">A</td>
            </tr>
            <tr>
              <td><strong>Data Quality Standards</strong></td>
              <td style="background: rgba(22,163,74,0.2); color: #16a34a; font-weight: 600; text-align: center;">C</td>
              <td style="background: rgba(255,107,43,0.2); color: #FF6B2B; font-weight: 600; text-align: center;">R</td>
              <td style="text-align: center;">—</td>
              <td style="background: rgba(22,163,74,0.2); color: #16a34a; font-weight: 600; text-align: center;">C</td>
              <td style="background: rgba(107,114,128,0.2); color: #aaa; font-weight: 600; text-align: center;">A</td>
              <td style="text-align: center;">—</td>
              <td style="text-align: center;">—</td>
              <td style="text-align: center;">—</td>
            </tr>
            <tr>
              <td><strong>Model Development</strong></td>
              <td style="text-align: center;">—</td>
              <td style="background: rgba(22,163,74,0.2); color: #16a34a; font-weight: 600; text-align: center;">C</td>
              <td style="background: rgba(22,163,74,0.2); color: #16a34a; font-weight: 600; text-align: center;">I</td>
              <td style="text-align: center;">—</td>
              <td style="background: rgba(22,163,74,0.2); color: #16a34a; font-weight: 600; text-align: center;">C</td>
              <td style="background: rgba(255,107,43,0.2); color: #FF6B2B; font-weight: 600; text-align: center;">R</td>
              <td style="text-align: center;">—</td>
              <td style="text-align: center;">—</td>
            </tr>
            <tr>
              <td><strong>Model Approval</strong></td>
              <td style="background: rgba(22,163,74,0.2); color: #16a34a; font-weight: 600; text-align: center;">C</td>
              <td style="background: rgba(22,163,74,0.2); color: #16a34a; font-weight: 600; text-align: center;">C</td>
              <td style="text-align: center;">—</td>
              <td style="text-align: center;">—</td>
              <td style="text-align: center;">—</td>
              <td style="background: rgba(107,114,128,0.2); color: #aaa; font-weight: 600; text-align: center;">A</td>
              <td style="background: rgba(255,107,43,0.2); color: #FF6B2B; font-weight: 600; text-align: center;">R</td>
              <td style="background: rgba(22,163,74,0.2); color: #16a34a; font-weight: 600; text-align: center;">C</td>
            </tr>
            <tr>
              <td><strong>Production Deployment</strong></td>
              <td style="background: rgba(22,163,74,0.2); color: #16a34a; font-weight: 600; text-align: center;">C</td>
              <td style="text-align: center;">—</td>
              <td style="text-align: center;">—</td>
              <td style="background: rgba(255,107,43,0.2); color: #FF6B2B; font-weight: 600; text-align: center;">R</td>
              <td style="background: rgba(22,163,74,0.2); color: #16a34a; font-weight: 600; text-align: center;">C</td>
              <td style="background: rgba(107,114,128,0.2); color: #aaa; font-weight: 600; text-align: center;">A</td>
              <td style="text-align: center;">—</td>
              <td style="text-align: center;">—</td>
            </tr>
            <tr>
              <td><strong>Monitoring &amp; Alerts</strong></td>
              <td style="text-align: center;">—</td>
              <td style="background: rgba(22,163,74,0.2); color: #16a34a; font-weight: 600; text-align: center;">C</td>
              <td style="text-align: center;">—</td>
              <td style="background: rgba(255,107,43,0.2); color: #FF6B2B; font-weight: 600; text-align: center;">R</td>
              <td style="background: rgba(22,163,74,0.2); color: #16a34a; font-weight: 600; text-align: center;">C</td>
              <td style="background: rgba(107,114,128,0.2); color: #aaa; font-weight: 600; text-align: center;">A</td>
              <td style="text-align: center;">—</td>
              <td style="text-align: center;">—</td>
            </tr>
            <tr>
              <td><strong>Incident Response</strong></td>
              <td style="background: rgba(255,107,43,0.2); color: #FF6B2B; font-weight: 600; text-align: center;">R</td>
              <td style="background: rgba(22,163,74,0.2); color: #16a34a; font-weight: 600; text-align: center;">C</td>
              <td style="background: rgba(22,163,74,0.2); color: #16a34a; font-weight: 600; text-align: center;">C</td>
              <td style="background: rgba(107,114,128,0.2); color: #aaa; font-weight: 600; text-align: center;">A</td>
              <td style="text-align: center;">—</td>
              <td style="text-align: center;">—</td>
              <td style="text-align: center;">—</td>
              <td style="background: rgba(22,163,74,0.2); color: #16a34a; font-weight: 600; text-align: center;">C</td>
            </tr>
            <tr>
              <td><strong>Budget Allocation</strong></td>
              <td style="background: rgba(255,107,43,0.2); color: #FF6B2B; font-weight: 600; text-align: center;">R</td>
              <td style="text-align: center;">—</td>
              <td style="background: rgba(22,163,74,0.2); color: #16a34a; font-weight: 600; text-align: center;">C</td>
              <td style="text-align: center;">—</td>
              <td style="text-align: center;">—</td>
              <td style="text-align: center;">—</td>
              <td style="text-align: center;">—</td>
              <td style="background: rgba(107,114,128,0.2); color: #aaa; font-weight: 600; text-align: center;">A</td>
            </tr>
            <tr>
              <td><strong>Vendor Selection</strong></td>
              <td style="background: rgba(255,107,43,0.2); color: #FF6B2B; font-weight: 600; text-align: center;">R</td>
              <td style="background: rgba(22,163,74,0.2); color: #16a34a; font-weight: 600; text-align: center;">C</td>
              <td style="background: rgba(22,163,74,0.2); color: #16a34a; font-weight: 600; text-align: center;">C</td>
              <td style="background: rgba(22,163,74,0.2); color: #16a34a; font-weight: 600; text-align: center;">C</td>
              <td style="text-align: center;">—</td>
              <td style="text-align: center;">—</td>
              <td style="text-align: center;">—</td>
              <td style="background: rgba(107,114,128,0.2); color: #aaa; font-weight: 600; text-align: center;">A</td>
            </tr>
            <tr>
              <td><strong>Ethics Review</strong></td>
              <td style="background: rgba(22,163,74,0.2); color: #16a34a; font-weight: 600; text-align: center;">C</td>
              <td style="background: rgba(22,163,74,0.2); color: #16a34a; font-weight: 600; text-align: center;">C</td>
              <td style="text-align: center;">—</td>
              <td style="text-align: center;">—</td>
              <td style="text-align: center;">—</td>
              <td style="background: rgba(255,107,43,0.2); color: #FF6B2B; font-weight: 600; text-align: center;">R</td>
              <td style="background: rgba(107,114,128,0.2); color: #aaa; font-weight: 600; text-align: center;">A</td>
              <td style="text-align: center;">—</td>
            </tr>
            <tr>
              <td><strong>Performance Reporting</strong></td>
              <td style="background: rgba(255,107,43,0.2); color: #FF6B2B; font-weight: 600; text-align: center;">R</td>
              <td style="background: rgba(22,163,74,0.2); color: #16a34a; font-weight: 600; text-align: center;">C</td>
              <td style="background: rgba(22,163,74,0.2); color: #16a34a; font-weight: 600; text-align: center;">C</td>
              <td style="text-align: center;">—</td>
              <td style="text-align: center;">—</td>
              <td style="text-align: center;">—</td>
              <td style="text-align: center;">—</td>
              <td style="background: rgba(107,114,128,0.2); color: #aaa; font-weight: 600; text-align: center;">A</td>
            </tr>
            <tr>
              <td><strong>Scaling Decisions</strong></td>
              <td style="background: rgba(255,107,43,0.2); color: #FF6B2B; font-weight: 600; text-align: center;">R</td>
              <td style="background: rgba(22,163,74,0.2); color: #16a34a; font-weight: 600; text-align: center;">C</td>
              <td style="background: rgba(22,163,74,0.2); color: #16a34a; font-weight: 600; text-align: center;">C</td>
              <td style="background: rgba(22,163,74,0.2); color: #16a34a; font-weight: 600; text-align: center;">C</td>
              <td style="text-align: center;">—</td>
              <td style="text-align: center;">—</td>
              <td style="text-align: center;">—</td>
              <td style="background: rgba(107,114,128,0.2); color: #aaa; font-weight: 600; text-align: center;">A</td>
            </tr>
          </tbody>
        </table>

        <p style="font-size: 11px; color: #888; margin-top: 16px; font-style: italic;">R = Responsible • A = Accountable • C = Consulted • I = Informed • — = Not Involved</p>

        <div class="dlv-doc-footer">
          <span>PERCEPT<em>Y</em>A — RACI Matrix</span>
          <span>12 Activities × 8 Roles</span>
        </div>
      </div>`,
},

'preview-governance-policies': {
    title: 'ai-governance-policies.pdf',
    body: `<div class="dlv-page">
        <div class="dlv-sanitized"><div class="dlv-sanitized-stripe">Sanitized client example</div></div>

        <div class="dlv-doc-header">
          <div class="dlv-doc-brand">PERCEPT<em>Y</em>A</div>
          <div class="dlv-doc-meta">
            <div class="dlv-doc-badge">Confidential</div>
            <div class="dlv-doc-meta-text">July 2025</div>
          </div>
        </div>

        <h1 class="dlv-doc-title">AI Governance Policies</h1>
        <p class="dlv-doc-subtitle">Enterprise Policy Register — Module D</p>

        <table class="dlv-table">
          <thead>
            <tr>
              <th>Policy ID</th>
              <th>Policy Name</th>
              <th>Category</th>
              <th>Description</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>POL-001</strong></td>
              <td>Model Bias Testing</td>
              <td class="uc-tag">Ethics</td>
              <td>All models must pass fairness testing. Minimum 95% equity across protected classes.</td>
              <td><span class="dlv-status green">Approved</span></td>
            </tr>
            <tr>
              <td><strong>POL-002</strong></td>
              <td>Data Retention &amp; Deletion</td>
              <td class="uc-tag">Data</td>
              <td>Training data purged after 24 months or on request per GDPR/CCPA.</td>
              <td><span class="dlv-status green">Approved</span></td>
            </tr>
            <tr>
              <td><strong>POL-003</strong></td>
              <td>Access Control &amp; Authorization</td>
              <td class="uc-tag">Security</td>
              <td>Role-based access. Sensitive data requires multi-factor auth &amp; audit trail.</td>
              <td><span class="dlv-status green">Approved</span></td>
            </tr>
            <tr>
              <td><strong>POL-004</strong></td>
              <td>Incident Response Protocol</td>
              <td class="uc-tag">Operations</td>
              <td>Model drift detection &amp; response SLA: High severity &lt;1h, Medium &lt;24h.</td>
              <td><span class="dlv-status green">Approved</span></td>
            </tr>
            <tr>
              <td><strong>POL-005</strong></td>
              <td>Responsible AI Usage</td>
              <td class="uc-tag">Ethics</td>
              <td>Prohibition on discriminatory, deceptive, or harmful AI applications. CEO sign-off required.</td>
              <td><span class="dlv-status green">Approved</span></td>
            </tr>
            <tr>
              <td><strong>POL-006</strong></td>
              <td>Model Documentation Standards</td>
              <td class="uc-tag">Operations</td>
              <td>Every model requires: model card, data provenance, decision boundary, known limitations.</td>
              <td><span class="dlv-status green">Approved</span></td>
            </tr>
            <tr>
              <td><strong>POL-007</strong></td>
              <td>Third-Party Vendor Management</td>
              <td class="uc-tag">Security</td>
              <td>AI vendors must comply with data privacy, security certifications (SOC 2, ISO 27001).</td>
              <td><span class="dlv-status green">Approved</span></td>
            </tr>
            <tr>
              <td><strong>POL-008</strong></td>
              <td>Risk Assessment &amp; Approval</td>
              <td class="uc-tag">Operations</td>
              <td>High-risk models: ethics committee review + signed approval before production deployment.</td>
              <td style="background: rgba(255,107,43,0.1);"><span class="dlv-status orange">Under Review</span></td>
            </tr>
            <tr>
              <td><strong>POL-009</strong></td>
              <td>Model Transparency &amp; Explainability</td>
              <td class="uc-tag">Ethics</td>
              <td>High-impact decisions must be explainable. Explainability score &gt; 0.75 or human override required.</td>
              <td><span class="dlv-status green">Approved</span></td>
            </tr>
            <tr>
              <td><strong>POL-010</strong></td>
              <td>Data Governance &amp; Quality</td>
              <td class="uc-tag">Data</td>
              <td>Centralized ownership, lineage tracking, quality SLAs: 98%+ accuracy, &lt;15min latency.</td>
              <td><span class="dlv-status green">Approved</span></td>
            </tr>
            <tr>
              <td><strong>POL-011</strong></td>
              <td>External AI Model Review</td>
              <td class="uc-tag">Security</td>
              <td>Third-party models audited for bias, security, license compliance before integration.</td>
              <td><span class="dlv-status green">Approved</span></td>
            </tr>
            <tr>
              <td><strong>POL-012</strong></td>
              <td>Continuous Monitoring &amp; Auditing</td>
              <td class="uc-tag">Operations</td>
              <td>All production models monitored 24/7. Monthly performance audits. Annual external audit.</td>
              <td><span class="dlv-status green">Approved</span></td>
            </tr>
          </tbody>
        </table>

        <h2 class="dlv-section-title">Review Cadence</h2>
        <table class="dlv-table">
          <thead>
            <tr>
              <th>Policy Category</th>
              <th>Review Frequency</th>
              <th>Owner</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Ethics Policies</strong></td>
              <td class="num">Quarterly</td>
              <td>Ethics Officer + CoE Head</td>
            </tr>
            <tr>
              <td><strong>Security Policies</strong></td>
              <td class="num">Bi-annually</td>
              <td>CISO + IT Security</td>
            </tr>
            <tr>
              <td><strong>Data Policies</strong></td>
              <td class="num">Quarterly</td>
              <td>Data Governance Lead</td>
            </tr>
            <tr>
              <td><strong>Operations Policies</strong></td>
              <td class="num">Semi-annually</td>
              <td>CoE Head + BU Leads</td>
            </tr>
          </tbody>
        </table>

        <div class="dlv-doc-footer">
          <span>PERCEPT<em>Y</em>A — Governance Policies</span>
          <span>12 Policies • 10 Approved • 2 Under Review</span>
        </div>
      </div>`,
},

'preview-roi-dashboard': {
    title: 'roi-dashboard.live',
    body: `<div class="dlv-page">
        <div class="dlv-sanitized"><div class="dlv-sanitized-stripe">Sanitized client example</div></div>

        <div class="dlv-doc-header">
          <div class="dlv-doc-brand">PERCEPT<em>Y</em>A</div>
          <div class="dlv-doc-meta">
            <div class="dlv-doc-badge">Live</div>
            <div class="dlv-doc-meta-text">Executive Dashboard</div>
          </div>
        </div>

        <h1 class="dlv-doc-title">AI Portfolio ROI Dashboard</h1>
        <p class="dlv-doc-subtitle">Value Capture & Performance Tracking</p>

        <div class="dlv-kpi-row">
          <div class="dlv-kpi">
            <div class="dlv-kpi-value positive">\$1.85M</div>
            <div class="dlv-kpi-label">Total AI Investment (YTD)</div>
            <div class="dlv-kpi-delta">Budget on track</div>
          </div>
          <div class="dlv-kpi">
            <div class="dlv-kpi-value accent">\$4.2M</div>
            <div class="dlv-kpi-label">Total Value Captured (YTD)</div>
            <div class="dlv-kpi-delta positive">↑ 34% vs projected</div>
          </div>
          <div class="dlv-kpi">
            <div class="dlv-kpi-value positive">\$2.35M</div>
            <div class="dlv-kpi-label">Net Value (Gain)</div>
            <div class="dlv-kpi-delta">127% above baseline</div>
          </div>
          <div class="dlv-kpi">
            <div class="dlv-kpi-value accent">227%</div>
            <div class="dlv-kpi-label">Portfolio ROI</div>
            <div class="dlv-kpi-delta positive">↑ 45% vs target</div>
          </div>
        </div>

        <h2 class="dlv-section-title">Investment vs Value Capture — 12 Months</h2>
        <div class="dlv-chart">
          <svg viewBox="0 0 650 220" style="width: 100%; height: auto;">
            <defs>
              <linearGradient id="investGrad" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" style="stop-color:#FF6B2B;stop-opacity:0.25" />
                <stop offset="100%" style="stop-color:#FF6B2B;stop-opacity:0.05" />
              </linearGradient>
              <linearGradient id="valueGrad" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" style="stop-color:#16a34a;stop-opacity:0.25" />
                <stop offset="100%" style="stop-color:#16a34a;stop-opacity:0.05" />
              </linearGradient>
            </defs>
            <!-- Investment (cumulative, lower) -->
            <polyline points="20,165 70,160 120,155 170,150 220,145 270,140 320,135 370,130 420,125 470,120 520,115 570,110 620,105" fill="none" stroke="#FF6B2B" stroke-width="2.5"/>
            <polygon points="20,165 70,160 120,155 170,150 220,145 270,140 320,135 370,130 420,125 470,120 520,115 570,110 620,105 620,200 20,200" fill="url(#investGrad)"/>

            <!-- Value Captured (accelerating) -->
            <polyline points="20,180 70,175 120,168 170,155 220,140 270,120 320,95 370,70 420,50 470,35 520,25 570,20 620,15" fill="none" stroke="#16a34a" stroke-width="2.5"/>
            <polygon points="20,180 70,175 120,168 170,155 220,140 270,120 320,95 370,70 420,50 470,35 520,25 570,20 620,15 620,200 20,200" fill="url(#valueGrad)"/>

            <line x1="20" y1="200" x2="620" y2="200" stroke="rgba(255,255,255,0.1)" stroke-width="1"/>
            <text x="630" y="108" font-size="9" fill="#FF6B2B">Investment</text>
            <text x="630" y="145" font-size="9" fill="#16a34a">Value Captured</text>
          </svg>
        </div>

        <h2 class="dlv-section-title">Use Case Value Performance</h2>
        <table class="dlv-table">
          <thead>
            <tr>
              <th>Use Case</th>
              <th>Monthly Value</th>
              <th>Cumulative Value</th>
              <th>Status</th>
              <th>Trend</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Demand Forecasting</strong></td>
              <td class="positive">\$420K</td>
              <td class="positive">\$1.68M</td>
              <td><span class="dlv-status green">Active</span></td>
              <td class="positive" style="text-align: center;">↑</td>
            </tr>
            <tr>
              <td><strong>Predictive Maintenance</strong></td>
              <td class="positive">\$285K</td>
              <td class="positive">\$980K</td>
              <td><span class="dlv-status green">Active</span></td>
              <td class="positive" style="text-align: center;">↑</td>
            </tr>
            <tr>
              <td><strong>Customer Churn Prevention</strong></td>
              <td class="positive">\$310K</td>
              <td class="positive">\$890K</td>
              <td><span class="dlv-status green">Active</span></td>
              <td style="text-align: center;">→</td>
            </tr>
            <tr>
              <td><strong>Inventory Optimization</strong></td>
              <td class="positive">\$195K</td>
              <td class="positive">\$685K</td>
              <td><span class="dlv-status green">Active</span></td>
              <td class="positive" style="text-align: center;">↑</td>
            </tr>
            <tr>
              <td><strong>Supply Chain Visibility</strong></td>
              <td class="positive">\$165K</td>
              <td class="positive">\$480K</td>
              <td><span class="dlv-status green">Ramping</span></td>
              <td class="positive" style="text-align: center;">↑</td>
            </tr>
            <tr>
              <td><strong>Quality Detection (Computer Vision)</strong></td>
              <td class="positive">\$125K</td>
              <td class="positive">\$375K</td>
              <td><span class="dlv-status orange">Pilot</span></td>
              <td class="positive" style="text-align: center;">↑</td>
            </tr>
            <tr>
              <td><strong>Dynamic Pricing</strong></td>
              <td class="positive">\$75K</td>
              <td class="positive">\$210K</td>
              <td><span class="dlv-status orange">Early Stage</span></td>
              <td class="positive" style="text-align: center;">↑</td>
            </tr>
          </tbody>
        </table>

        <div class="dlv-doc-footer">
          <span>PERCEPT<em>Y</em>A — ROI Dashboard</span>
          <span>Last updated: 1 minute ago</span>
        </div>
      </div>`,
},

'preview-executive-scorecard': {
    title: 'executive-scorecard.xlsx',
    body: `<div class="dlv-page">
        <div class="dlv-sanitized"><div class="dlv-sanitized-stripe">Sanitized client example</div></div>

        <div class="dlv-doc-header">
          <div class="dlv-doc-brand">PERCEPT<em>Y</em>A</div>
          <div class="dlv-doc-meta">
            <div class="dlv-doc-badge">Spreadsheet</div>
            <div class="dlv-doc-meta-text">Monthly Scorecard</div>
          </div>
        </div>

        <h1 class="dlv-doc-title">Executive Scorecard — AI Performance Metrics</h1>
        <p class="dlv-doc-subtitle">Financial, Operational, Customer & Capability Metrics</p>

        <h2 class="dlv-section-title">Financial Metrics</h2>
        <table class="dlv-table" style="font-size: 12px;">
          <thead>
            <tr>
              <th>Metric</th>
              <th>Target</th>
              <th>Actual</th>
              <th>Variance</th>
              <th>Status</th>
              <th>Trend</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>AI Portfolio ROI</strong></td>
              <td class="num">150%</td>
              <td class="positive">227%</td>
              <td class="positive">+77%</td>
              <td><span style="color: #16a34a; font-weight: 600;">●</span> Green</td>
              <td class="positive">↑</td>
            </tr>
            <tr>
              <td><strong>Cost per Prediction</strong></td>
              <td class="num">\$0.08</td>
              <td class="positive">\$0.062</td>
              <td class="positive">-22.5%</td>
              <td><span style="color: #16a34a; font-weight: 600;">●</span> Green</td>
              <td class="positive">↓</td>
            </tr>
            <tr>
              <td><strong>Time-to-Value (months)</strong></td>
              <td class="num">6</td>
              <td class="positive">4.2</td>
              <td class="positive">-30%</td>
              <td><span style="color: #16a34a; font-weight: 600;">●</span> Green</td>
              <td class="positive">↓</td>
            </tr>
            <tr>
              <td><strong>ML Model Development Cost</strong></td>
              <td class="num">\$125K</td>
              <td class="positive">\$98K</td>
              <td class="positive">-21.6%</td>
              <td><span style="color: #16a34a; font-weight: 600;">●</span> Green</td>
              <td class="positive">↓</td>
            </tr>
          </tbody>
        </table>

        <h2 class="dlv-section-title">Operational Metrics</h2>
        <table class="dlv-table" style="font-size: 12px;">
          <thead>
            <tr>
              <th>Metric</th>
              <th>Target</th>
              <th>Actual</th>
              <th>Variance</th>
              <th>Status</th>
              <th>Trend</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Model Uptime (%)</strong></td>
              <td class="num">99.5%</td>
              <td class="positive">99.8%</td>
              <td class="positive">+0.3%</td>
              <td><span style="color: #16a34a; font-weight: 600;">●</span> Green</td>
              <td class="positive">↑</td>
            </tr>
            <tr>
              <td><strong>Data Quality Score</strong></td>
              <td class="num">96%</td>
              <td class="positive">97.4%</td>
              <td class="positive">+1.4%</td>
              <td><span style="color: #16a34a; font-weight: 600;">●</span> Green</td>
              <td class="positive">↑</td>
            </tr>
            <tr>
              <td><strong>Days to Production Deploy</strong></td>
              <td class="num">14</td>
              <td class="positive">9</td>
              <td class="positive">-36%</td>
              <td><span style="color: #16a34a; font-weight: 600;">●</span> Green</td>
              <td class="positive">↓</td>
            </tr>
            <tr>
              <td><strong>Incident Response Time (hrs)</strong></td>
              <td class="num">&lt;2h</td>
              <td class="positive">0.8h</td>
              <td class="positive">-60%</td>
              <td><span style="color: #16a34a; font-weight: 600;">●</span> Green</td>
              <td class="positive">↓</td>
            </tr>
          </tbody>
        </table>

        <h2 class="dlv-section-title">Customer & Business Metrics</h2>
        <table class="dlv-table" style="font-size: 12px;">
          <thead>
            <tr>
              <th>Metric</th>
              <th>Target</th>
              <th>Actual</th>
              <th>Variance</th>
              <th>Status</th>
              <th>Trend</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>NPS Impact (lift)</strong></td>
              <td class="num">+5</td>
              <td class="positive">+7.2</td>
              <td class="positive">+44%</td>
              <td><span style="color: #16a34a; font-weight: 600;">●</span> Green</td>
              <td class="positive">↑</td>
            </tr>
            <tr>
              <td><strong>Revenue Lift (\$ millions)</strong></td>
              <td class="num">\$1.5M</td>
              <td class="positive">\$2.1M</td>
              <td class="positive">+40%</td>
              <td><span style="color: #16a34a; font-weight: 600;">●</span> Green</td>
              <td class="positive">↑</td>
            </tr>
            <tr>
              <td><strong>Customer Churn Reduction (%)</strong></td>
              <td class="num">8%</td>
              <td class="positive">11.3%</td>
              <td class="positive">+41%</td>
              <td><span style="color: #16a34a; font-weight: 600;">●</span> Green</td>
              <td class="positive">↑</td>
            </tr>
            <tr>
              <td><strong>Cost Savings (millions)</strong></td>
              <td class="num">\$1.2M</td>
              <td class="positive">\$1.8M</td>
              <td class="positive">+50%</td>
              <td><span style="color: #16a34a; font-weight: 600;">●</span> Green</td>
              <td class="positive">↑</td>
            </tr>
          </tbody>
        </table>

        <h2 class="dlv-section-title">Capability Metrics</h2>
        <table class="dlv-table" style="font-size: 12px;">
          <thead>
            <tr>
              <th>Metric</th>
              <th>Target</th>
              <th>Actual</th>
              <th>Variance</th>
              <th>Status</th>
              <th>Trend</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Data Literacy Score (team %)</strong></td>
              <td class="num">70%</td>
              <td class="positive">82%</td>
              <td class="positive">+17%</td>
              <td><span style="color: #16a34a; font-weight: 600;">●</span> Green</td>
              <td class="positive">↑</td>
            </tr>
            <tr>
              <td><strong>AI Tool Adoption Rate (%)</strong></td>
              <td class="num">75%</td>
              <td class="positive">88%</td>
              <td class="positive">+17%</td>
              <td><span style="color: #16a34a; font-weight: 600;">●</span> Green</td>
              <td class="positive">↑</td>
            </tr>
            <tr>
              <td><strong>Models in Production</strong></td>
              <td class="num">5</td>
              <td class="positive">7</td>
              <td class="positive">+40%</td>
              <td><span style="color: #16a34a; font-weight: 600;">●</span> Green</td>
              <td class="positive">↑</td>
            </tr>
            <tr>
              <td><strong>Team Hiring Progress (%)</strong></td>
              <td class="num">100%</td>
              <td style="background: rgba(255,107,43,0.1);">85%</td>
              <td style="background: rgba(255,107,43,0.1);">-15%</td>
              <td style="background: rgba(255,107,43,0.1);"><span style="color: #FF6B2B; font-weight: 600;">●</span> Yellow</td>
              <td style="background: rgba(255,107,43,0.1);">→</td>
            </tr>
          </tbody>
        </table>

        <h2 class="dlv-section-title">Key Insights</h2>
        <p style="font-size: 13px; color: #ddd; line-height: 1.6; margin-bottom: 12px;">
          <strong style="color: #fff;">Strong Performance:</strong> Portfolio ROI at 227%, ahead of target by 77%. Revenue lift exceeded forecast by 40%, driven primarily by Demand Forecasting and Churn Prevention use cases. Operational efficiency metrics all green.
        </p>
        <p style="font-size: 13px; color: #ddd; line-height: 1.6; margin-bottom: 12px;">
          <strong style="color: #fff;">Focus Area:</strong> Team hiring at 85% completion. Recommend accelerated recruitment for ML Ops and Data Engineering roles to support scaling. Customer Churn model showing early strong results; recommend expanded pilot scope.
        </p>

        <div class="dlv-doc-footer">
          <span>PERCEPT<em>Y</em>A — Executive Scorecard</span>
          <span>18 Metrics • 17 Green • 1 Yellow</span>
        </div>
      </div>`,
},

'preview-value-realization': {
    title: 'value-realization-report_q3-2025.pdf',
    body: `<div class="dlv-page">

        <!-- Sanitized overlay -->
        <div class="dlv-sanitized"><div class="dlv-sanitized-stripe">Sanitized client example</div></div>

        <!-- Document Header -->
        <div class="dlv-doc-header">
          <div>
            <div class="dlv-doc-brand">PERCEPT<em>Y</em>A</div>
            <div style="font-size:9px;color:#aaa;font-family:'DM Mono',monospace;margin-top:2px;">AI VALUE SYSTEM&trade;</div>
          </div>
          <div class="dlv-doc-meta">
            <div class="dlv-doc-badge">Confidential</div>
            <div style="margin-top:6px;">Client: Latin American Big Fashion Retail</div>
            <div>Report Period: Q3 2025</div>
            <div>Module E &middot; ROI &amp; Value Tracking</div>
          </div>
        </div>

        <!-- Title -->
        <div class="dlv-doc-title">Value Realization Report</div>
        <div class="dlv-doc-subtitle">QUARTERLY AI PORTFOLIO PERFORMANCE &middot; Q3 2025</div>

        <!-- Executive KPIs -->
        <div class="dlv-kpi-row">
          <div class="dlv-kpi">
            <div class="dlv-kpi-value accent">\$4.2M</div>
            <div class="dlv-kpi-label">Total Value Captured</div>
            <div class="dlv-kpi-delta">&uarr; 38% vs Q3</div>
          </div>
          <div class="dlv-kpi">
            <div class="dlv-kpi-value positive">312%</div>
            <div class="dlv-kpi-label">Portfolio ROI</div>
            <div class="dlv-kpi-delta">&uarr; 67pp vs Baseline</div>
          </div>
          <div class="dlv-kpi">
            <div class="dlv-kpi-value">7 / 7</div>
            <div class="dlv-kpi-label">Use Cases in Production</div>
            <div class="dlv-kpi-delta">100% deployed</div>
          </div>
          <div class="dlv-kpi">
            <div class="dlv-kpi-value positive">+18pts</div>
            <div class="dlv-kpi-label">NPS Impact</div>
            <div class="dlv-kpi-delta">62 &rarr; 80</div>
          </div>
        </div>

        <!-- Value by Use Case -->
        <div class="dlv-section-title">Value Realization by Use Case</div>
        <table class="dlv-table">
          <thead>
            <tr>
              <th style="width:28%">Use Case</th>
              <th>Status</th>
              <th class="num">Investment</th>
              <th class="num">Value Captured</th>
              <th class="num">ROI</th>
              <th style="width:18%">Progress to Target</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><span class="uc-tag">UC-01</span> Dynamic Pricing Engine</td>
              <td><span class="dlv-status green">Live</span></td>
              <td class="num">\$180K</td>
              <td class="num positive">\$1.42M</td>
              <td class="num positive">689%</td>
              <td><div class="dlv-progress"><div class="dlv-progress-bar" style="width:94%"></div></div></td>
            </tr>
            <tr>
              <td><span class="uc-tag">UC-02</span> Personalized Recommendations</td>
              <td><span class="dlv-status green">Live</span></td>
              <td class="num">\$220K</td>
              <td class="num positive">\$1.08M</td>
              <td class="num positive">391%</td>
              <td><div class="dlv-progress"><div class="dlv-progress-bar" style="width:82%"></div></div></td>
            </tr>
            <tr>
              <td><span class="uc-tag">UC-03</span> Demand Forecasting</td>
              <td><span class="dlv-status green">Live</span></td>
              <td class="num">\$150K</td>
              <td class="num positive">\$680K</td>
              <td class="num positive">353%</td>
              <td><div class="dlv-progress"><div class="dlv-progress-bar" style="width:76%"></div></div></td>
            </tr>
            <tr>
              <td><span class="uc-tag">UC-04</span> Inventory Optimization</td>
              <td><span class="dlv-status green">Live</span></td>
              <td class="num">\$130K</td>
              <td class="num positive">\$520K</td>
              <td class="num positive">300%</td>
              <td><div class="dlv-progress"><div class="dlv-progress-bar" style="width:68%"></div></div></td>
            </tr>
            <tr>
              <td><span class="uc-tag">UC-05</span> Churn Prediction &amp; Retention</td>
              <td><span class="dlv-status green">Live</span></td>
              <td class="num">\$95K</td>
              <td class="num positive">\$310K</td>
              <td class="num positive">226%</td>
              <td><div class="dlv-progress"><div class="dlv-progress-bar" style="width:71%"></div></div></td>
            </tr>
            <tr>
              <td><span class="uc-tag">UC-06</span> Customer Service Agents</td>
              <td><span class="dlv-status green">Live</span></td>
              <td class="num">\$110K</td>
              <td class="num positive">\$140K</td>
              <td class="num positive">27%</td>
              <td><div class="dlv-progress"><div class="dlv-progress-bar" style="width:42%"></div></div></td>
            </tr>
            <tr>
              <td><span class="uc-tag">UC-07</span> Supplier Lead Time Prediction</td>
              <td><span class="dlv-status orange">Scaling</span></td>
              <td class="num">\$75K</td>
              <td class="num positive">\$52K</td>
              <td class="num" style="color:#888">—</td>
              <td><div class="dlv-progress"><div class="dlv-progress-bar" style="width:28%;background:#FF6B2B;"></div></div></td>
            </tr>
          </tbody>
        </table>

        <!-- Revenue Impact Chart (SVG bar chart) -->
        <div class="dlv-section-title">Quarterly Value Capture Trajectory</div>
        <div class="dlv-chart">
          <svg viewBox="0 0 700 220" fill="none" xmlns="http://www.w3.org/2000/svg">
            <!-- Grid lines -->
            <line x1="60" y1="20" x2="60" y2="180" stroke="#e0e0e0" stroke-width="1"/>
            <line x1="60" y1="180" x2="680" y2="180" stroke="#e0e0e0" stroke-width="1"/>
            <line x1="60" y1="140" x2="680" y2="140" stroke="#f0f0f0" stroke-width="0.5" stroke-dasharray="4 3"/>
            <line x1="60" y1="100" x2="680" y2="100" stroke="#f0f0f0" stroke-width="0.5" stroke-dasharray="4 3"/>
            <line x1="60" y1="60" x2="680" y2="60" stroke="#f0f0f0" stroke-width="0.5" stroke-dasharray="4 3"/>
            <line x1="60" y1="20" x2="680" y2="20" stroke="#f0f0f0" stroke-width="0.5" stroke-dasharray="4 3"/>

            <!-- Y-axis labels -->
            <text x="52" y="184" text-anchor="end" fill="#999" font-size="9" font-family="DM Mono">\$0</text>
            <text x="52" y="144" text-anchor="end" fill="#999" font-size="9" font-family="DM Mono">\$1M</text>
            <text x="52" y="104" text-anchor="end" fill="#999" font-size="9" font-family="DM Mono">\$2M</text>
            <text x="52" y="64" text-anchor="end" fill="#999" font-size="9" font-family="DM Mono">\$3M</text>
            <text x="52" y="24" text-anchor="end" fill="#999" font-size="9" font-family="DM Mono">\$4M</text>

            <!-- Bars — Investment (gray) + Value Captured (orange/green) -->
            <!-- Q1 -->
            <rect x="90" y="168" width="40" height="12" rx="2" fill="#ddd"/>
            <rect x="135" y="160" width="40" height="20" rx="2" fill="#FF6B2B" opacity="0.7"/>
            <text x="132" y="200" fill="#666" font-size="9" font-family="DM Mono" text-anchor="middle">Q1</text>
            <text x="155" y="155" fill="#FF6B2B" font-size="9" font-family="DM Mono" text-anchor="middle">\$0.5M</text>

            <!-- Q2 -->
            <rect x="230" y="162" width="40" height="18" rx="2" fill="#ddd"/>
            <rect x="275" y="128" width="40" height="52" rx="2" fill="#FF6B2B" opacity="0.8"/>
            <text x="272" y="200" fill="#666" font-size="9" font-family="DM Mono" text-anchor="middle">Q2</text>
            <text x="295" y="123" fill="#FF6B2B" font-size="9" font-family="DM Mono" text-anchor="middle">\$1.3M</text>

            <!-- Q3 -->
            <rect x="370" y="156" width="40" height="24" rx="2" fill="#ddd"/>
            <rect x="415" y="60" width="40" height="120" rx="2" fill="#FF6B2B" opacity="0.9"/>
            <text x="412" y="200" fill="#666" font-size="9" font-family="DM Mono" text-anchor="middle">Q3</text>
            <text x="435" y="55" fill="#FF6B2B" font-size="9" font-family="DM Mono" text-anchor="middle">\$3.0M</text>

            <!-- Q4 (current — highlighted) -->
            <rect x="510" y="152" width="40" height="28" rx="2" fill="#ddd"/>
            <rect x="555" y="12" width="40" height="168" rx="2" fill="#16a34a"/>
            <text x="552" y="200" fill="#1a1a1a" font-size="10" font-family="DM Mono" font-weight="600" text-anchor="middle">Q4</text>
            <text x="575" y="8" fill="#16a34a" font-size="10" font-family="DM Mono" font-weight="600" text-anchor="middle">\$4.2M</text>

            <!-- Legend -->
            <rect x="90" y="210" width="10" height="8" rx="1" fill="#ddd"/>
            <text x="105" y="217" fill="#888" font-size="8" font-family="DM Mono">Investment</text>
            <rect x="180" y="210" width="10" height="8" rx="1" fill="#16a34a"/>
            <text x="195" y="217" fill="#888" font-size="8" font-family="DM Mono">Value Captured</text>
            <line x1="290" y1="214" x2="310" y2="214" stroke="#FF6B2B" stroke-width="1.5" stroke-dasharray="3 2"/>
            <text x="315" y="217" fill="#888" font-size="8" font-family="DM Mono">Projected Target (\$5.1M)</text>

            <!-- Target line -->
            <line x1="60" y1="28" x2="680" y2="28" stroke="#FF6B2B" stroke-width="1" stroke-dasharray="5 3" opacity="0.5"/>
            <text x="685" y="32" fill="#FF6B2B" font-size="8" font-family="DM Mono" opacity="0.7">Target</text>
          </svg>
        </div>

        <!-- Key Insights -->
        <div class="dlv-section-title">Key Insights &amp; Recommendations</div>
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-bottom:24px;">
          <div style="background:#f0fdf4;border:1px solid #bbf7d0;border-radius:6px;padding:14px 16px;">
            <div style="font-size:9px;font-family:'DM Mono',monospace;color:#16a34a;text-transform:uppercase;letter-spacing:.06em;margin-bottom:6px;">Scaling Recommendation</div>
            <div style="font-size:12px;color:#333;line-height:1.6;">Dynamic Pricing Engine (UC-01) delivering 689% ROI. Recommend expanding to 3 additional product categories in Q4 2025 — projected incremental value: \$620K.</div>
          </div>
          <div style="background:#fff7ed;border:1px solid #fed7aa;border-radius:6px;padding:14px 16px;">
            <div style="font-size:9px;font-family:'DM Mono',monospace;color:#FF6B2B;text-transform:uppercase;letter-spacing:.06em;margin-bottom:6px;">Watch Item</div>
            <div style="font-size:12px;color:#333;line-height:1.6;">Customer Service Agents (UC-06) at 27% ROI, below 50% threshold. Agent accuracy improving — recommend extended monitoring before scaling investment.</div>
          </div>
        </div>

        <!-- Footer -->
        <div class="dlv-doc-footer">
          <div class="dlv-doc-footer-left">
            PERCEPTYA &middot; AI Value System&trade; &middot; Module E: ROI &amp; Value Tracking<br>
            Prepared for Latin American Big Fashion Retail &middot; Strictly Confidential
          </div>
          <div class="dlv-doc-footer-right">
            Page 1 of 3<br>
            Generated: Sep 30, 2025
          </div>
        </div>

      </div>`,
},

};

export { MODALS };

interface DeliverableModalsProps {
    activeModal: string | null;
    onClose: () => void;
}

const DeliverableModals: React.FC<DeliverableModalsProps> = ({ activeModal, onClose }) => {
    useEffect(() => {
        if (activeModal) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => { document.body.style.overflow = ''; };
    }, [activeModal]);

    useEffect(() => {
        const handleEsc = (e: KeyboardEvent) => {
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', handleEsc);
        return () => document.removeEventListener('keydown', handleEsc);
    }, [onClose]);

    if (!activeModal) return null;
    const modal = MODALS[activeModal];
    if (!modal) return null;

    return (
        <div
            className={`dlv-modal-overlay${activeModal ? ' open' : ''}`}
            onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
        >
            <div className="dlv-modal">
                <div className="dlv-modal-bar">
                    <div className="dlv-modal-bar-left">
                        <div className="dlv-modal-bar-dots"><span></span><span></span><span></span></div>
                        <span className="dlv-modal-bar-title">{modal.title}</span>
                    </div>
                    <button className="dlv-modal-close" aria-label="Close" onClick={onClose}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                            <line x1="18" y1="6" x2="6" y2="18" />
                            <line x1="6" y1="6" x2="18" y2="18" />
                        </svg>
                    </button>
                </div>
                <div className="dlv-modal-body" dangerouslySetInnerHTML={{ __html: modal.body }} />
            </div>
        </div>
    );
};

export default DeliverableModals;
